<template>
    <div class="property" id="property" ref="searchBar">
        <div class="title">樓盤管理</div>
        <!-- 筛选搜索 -->
        <div class="filter">
            <!-- 第一排默認搜索 -->
            <div>
                <el-row>
                    <el-col :span="24">
                        <!-- 組別 -->
                        <el-cascader
                            v-if="isDepartment"
                            placeholder="組別"
                            class="w135"
                            filterable
                            v-model="departmentID"
                            :show-all-levels="false"
                            :options="departmentList"
                            :props="{
                                checkStrictly: true,
                                children: 'childNode',
                                value: 'departmentID',
                                label: 'departmentName',
                                emitPath: false
                            }"
                        ></el-cascader>
                        <!-- 樓盤代理 -->
                        <el-select class="w135" v-model="searchAccountPropertyType" placeholder="全部樓盤">
                            <el-option v-for="item in propertyAgentList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <!-- 租售 -->
                        <!-- 宽度150->100 -->
                        <el-select class="w100" v-model="rentalType" no-data-text="暫無數據" @change="changerental" placeholder="租售">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option v-for="item in rentalList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <!-- 搜索 -->
                        <el-input class="w315" placeholder="樓盤編號、物業編號、放盤人、屋苑、地區" suffix-icon="el-icon-search" v-model="keyString"></el-input>
                        <!-- 宽度150->100 -->
                        <el-select class="w100" v-model="showStatus" placeholder="顯示狀態">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option v-for="item in showStatusList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <span class="btn-filter">
                            <el-button type="danger" class="seabtn" @click="clickSearch">搜尋</el-button>
                            <el-button type="info" @click="resetSearch">重置</el-button>
                            <!-- 打開更多選項 -->
                            <el-button class="more" type="warning" @click="isMoreChoose = !isMoreChoose">打開更多選項</el-button>
                        </span>
                    </el-col>
                </el-row>
            </div>
            <!-- 更多搜索 -->
            <div v-show="isMoreChoose">
                <el-row>
                    <el-col>
                        <el-select class="w150" v-model="categoryValue" placeholder="樓盤類型">
                            <el-option class="property-tags-cascader-none-li" label="全部" value="0"></el-option>

                            <el-cascader-panel
                                :key="isResouceShow"
                                v-model="category"
                                :options="categoryList"
                                :show-all-levels="false"
                                class="property-tags-cascader-panelcheckbox"
                                collapse-tags
                                ref="cascader"
                                :props="{
                                    multiple: true,
                                    children: 'children',
                                    value: 'dictionaryValue',
                                    label: 'dictionaryNameWithCulture',
                                    checkStrictly: false
                                }"
                                clearable
                                @change="categoryCascaderChange"
                            >
                                <!--  collapse-tags 重复了 -->
                                <!-- <template slot-scope="{ node, data }">
                                    <span>{{ data.dictionaryNameWithCulture }}</span>
                                    <span class="length-num" v-if="!node.isLeaf"> {{ filterPeopertyTags(data.dictionaryValue, 0) }} </span>
                                </template> -->
                            </el-cascader-panel>
                        </el-select>
                        <el-select class="w150" v-model="paymentStatus" placeholder="付款狀態">
                            <el-option v-for="item in paymentStatusList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <el-select class="w150" v-model="zoneCode" placeholder="地區">
                            <el-option v-for="(item, index) in regionList" :key="index" :label="item.gscopeNameWithCulture" :value="item.gscopeCode"></el-option>
                        </el-select>
                        <el-select class="w150" v-model="gscopeCode" no-data-text="暫無數據" placeholder="樓市片區">
                            <el-option v-for="item in gscopeList" :key="item.gscopeCode" :label="item.gscopeNameWithCulture" :value="item.gscopeCode"></el-option>
                        </el-select>
                        <el-select class="w150" v-model="saleRentStatus" placeholder="樓盤狀態">
                            <!-- 动态判断租售 -->
                            <el-option v-if="statusList.length" label="全部" :value="0"></el-option>
                            <el-option v-for="item in statusList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <el-select class="w150" v-model="isAdminOffLine" placeholder="已被下架">
                            <el-option v-for="item in isAdminOffList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <el-select class="w150" v-model="topType" placeholder="放盤方式">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option v-for="item in topOptions" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <!-- 曝光等級-->
                        <el-select v-if="showAdRank" class="w150" v-model="rankType" placeholder="曝光等級">
                            <el-option v-for="item in AdRank" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <el-select class="w160" style="width: 176px" multiple collapse-tags v-model="propertyLabelValueList" placeholder="功能">
                            <!-- <el-option label="全部" :value="0"></el-option> -->
                            <el-option v-for="item in propertyLabel" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <el-select class="w160" style="width: 176px" v-model="unitFloor" placeholder="樓層">
                            <el-option v-for="item in unitFloorList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <!-- ! 下拉选项是否 -->
                        <el-select class="w160" style="width: 176px" v-model="isAutoRecommend" placeholder="自動置頂">
                            <el-option v-for="item in isAutoRecommendList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <el-select class="w160" style="width: 176px" v-model="isPropertyUpgradeType" placeholder="可以升級">
                            <el-option v-for="item in isPropertyUpgradeTypeList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                    </el-col>
                    <el-col>
                        <span class="area-span">租價範圍：</span>
                        <el-select v-if="rentPriceCode !== 0 && !minRentPrice && !maxRentPrice" class="w160" v-model="rentPriceCode" placeholder="請選擇租價範圍">
                            <el-option label="自訂範圍" :value="0"></el-option>
                            <el-option v-for="item in rentPriceList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <div v-else class="input-model w245">
                            <el-input class="w90" v-model="minRentPrice" placeholder="請輸入價格" />
                            <span class="pm">-</span>
                            <el-input class="w90" v-model="maxRentPrice" placeholder="請輸入價格" />
                            <span class="pm">元</span>
                        </div>
                        <span class="area-span">售價範圍：</span>
                        <el-select v-if="salePriceCode !== 0 && !minSalePrice && !maxSalePrice" class="w160" v-model="salePriceCode" placeholder="請選擇售價範圍">
                            <el-option label="自訂範圍" :value="0"></el-option>
                            <el-option v-for="item in salePriceList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <div v-else class="input-model w245">
                            <el-input class="w90" v-model="minSalePrice" placeholder="請輸入價格"></el-input>
                            <span class="pm">-</span>
                            <el-input class="w90" v-model="maxSalePrice" placeholder="請輸入價格"></el-input>
                            <span class="pm">萬</span>
                        </div>
                        <span class="area-span">建築面積：</span>
                        <el-select class="w160" v-model="buildingAreaCode" placeholder="請選擇建築面積">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option v-for="item in areaList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <span class="area-span">實用面積：</span>
                        <el-select class="w160" v-model="saleableAreaCode" placeholder="請選擇實用面積">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option v-for="item in areaList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <!-- <span class="area-span">備註狀態：</span> -->
                        <el-select class="w160" v-model="SearchPropertyRemark" placeholder="備註狀態">
                            <el-option v-for="item in showPropertyRemark" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                    </el-col>
                    <el-col>
                        <el-select class="w160" style="width: 176px" v-model="propertySource" placeholder="業主/代理盤">
                            <el-option v-for="item in propertySourceList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                        </el-select>
                        <span class="time">放盤時間：</span>
                        <el-date-picker class="w150 mr4" format="yyyy/MM/dd" value-format="timestamp" v-model="publicTimeStartTime" :picker-options="publicTimeOption2" type="date" placeholder="選擇日期"></el-date-picker>-
                        <el-date-picker class="w150" format="yyyy/MM/dd" value-format="timestamp" v-model="publicTimeEndTime" :picker-options="publicTimeOption" type="date" placeholder="選擇日期"></el-date-picker>
                        <span class="time">到期時間：</span>
                        <el-date-picker class="w150 mr4" format="yyyy/MM/dd" value-format="timestamp" v-model="expireStartTime" :picker-options="expireTimeOption2" type="date" placeholder="選擇日期"></el-date-picker>-
                        <el-date-picker class="w150" format="yyyy/MM/dd" value-format="timestamp" v-model="expireEndTime" :picker-options="expireTimeOption" type="date" placeholder="選擇日期"></el-date-picker>
                        <!-- 楼盘标签 -->
                        <el-select class="property-tags-cascader w195" v-model="propertyTagsValue" v-if="categoryIf[0] != 5" placeholder="樓盤標籤">
                            <el-option class="property-tags-cascader-none-li" value="1">.</el-option>
                            <el-cascader-panel
                                :key="isResouceShow"
                                @change="propertyTagsCascaderChange"
                                class="property-tags-cascader-panel"
                                :options="propertyTagsList"
                                :show-all-levels="false"
                                v-model="propertyTags"
                                collapse-tags
                                :props="{
                                    checkStrictly: true,
                                    multiple: true,
                                    checkStrictly: true,
                                    children: 'children',
                                    value: 'dictionaryValue',
                                    label: 'dictionaryNameWithCulture',
                                    emitPath: false
                                }"
                            >
                                <template slot-scope="{ node, data }">
                                    <span>{{ data.dictionaryNameWithCulture }}</span>
                                    <span class="length-num" v-if="!node.isLeaf"> {{ filterPeopertyTags(data.dictionaryValue, 1) }} </span>
                                </template>
                            </el-cascader-panel>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="line"></div>
        <!-- 功能按钮-->
        <div :class="{ button: true, fixed: !isFixed && !sideBar, 'fixed-1': isFixed, 'fixed-2': !sideBar ,'overBut':!showTooltip && !showCurrentTooltip}">
            <!-- 代理人不显示操作按钮 -->
            <span v-show="!isAgent && !isDisabledPublish">
                <span class="span post-top" @click="enterPost">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconkandengloupan1-copy" />
                    </svg>
                    <span class="btn-text">刊登樓盤</span>
                </span>
                <span class="span" @click="enterDraftBox">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconcaogaoxiang1-copy" />
                    </svg>
                    <span class="btn-text">草稿箱</span>
                </span>
                <!-- class="span" -->
                <span v-show="isEditPost" :class="['span', { disspan: noneFrontSel ? !isShowEdit : true }]" @click="editPostUserShow">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isShowEdit && isFixDis ? '#iconxiugaifangpanren-copy' : '#iconxiugaifangpanren'" />
                    </svg>
                    <!-- <span :class="{ 'btn-text': true, ban: !isShowEdit}">修改放盤人</span> -->
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isShowEdit : true }">修改放盤人</span>
                </span>
                <span :class="['span', { disspan: noneFrontSel ? !isShow : true }]" @click="propertyShow(false)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isShow && isFixDis ? '#iconxianshi-copy' : '#iconxianshi'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isShow : true }">顯示</span>
                </span>
                <span :class="['span', { disspan: noneFrontSel ? !isShow : true }]" @click="propertyShow(true)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isShow && isFixDis ? '#iconyincang-copy' : '#iconyincang'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isShow : true }">隱藏</span>
                </span>
                <span v-if="isCopyShow" :class="['span', { disspan: noneFrontSel ? !isCopy : true }]" @click="openCopyEnter(isCopy)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isCopy && isFixDis ? '#iconfuzhi-copy' : '#iconfuzhi'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isCopy : true }">複製</span>
                </span>
                <span :class="['span', { disspan: noneFrontSel ? !isEdit : true }]" @click="operatingEnter('edit', isEdit)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isEdit && isFixDis ? '#iconxiugai-copy' : '#iconxiugai'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isEdit : true }">修改</span>
                </span>
                <span :class="['span', { disspan: noneFrontSel ? !isRenew : true }]" @click="renewProperty(isRenew)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isRenew && isFixDis ? '#iconxuqi-copy' : '#iconxuqi'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isRenew : true }">續期</span>
                </span>
                <!-- <span :class="['span', { disspan: noneFrontSel ? !isPay : true }]" @click="operatingEnter('1', isPay)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isPay && isFixDis ? '#iconfukuan-copy' : '#iconfukuan'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isPay : true }">付款</span>
                </span> -->
                <span :class="['span', { disspan: noneFrontSel ? !isSet : true }]" @click="editPropertyStatusShow(isSet)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isSet && isFixDis ? '#iconloupanzhuangtai-copy' : '#iconloupanzhuangtai'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isSet : true }">修改樓盤狀態</span>
                </span>
                <span :class="['span', { disspan: noneFrontSel ? !isDel : true }]" @click="deleteRow(isDel)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isDel && isFixDis ? '#iconshanchu1-copy' : '#iconshanchu1'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isDel : true }">刪除</span>
                </span>
                <span :class="['span', { disspan: noneFrontSel ? !isRecommend : true }]" @click="recommend(isRecommend)">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isRecommend && isFixDis ? '#iconzhiding-copy' : '#iconzhiding'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isRecommend : true }">重新推前</span>
                </span>
                <span  v-if="noneFrontSel && isAutoRec" :class="['span', { disspan: noneFrontSel ? !isAutoRec : true }]" @click="showAutoRecDia(isAutoRec,'autoRecTab')">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="isAutoRec && isFixDis  ? '#iconzidongzhiding2' : '#iconzidongzhiding'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: noneFrontSel ? !isAutoRec : true }">自動置頂</span>
                </span>
                <!-- 关闭水印 -->
                <span v-if="isWatermark" class="span" @click="watermark(isWatermark)">
                    <img style="width: 20px; height: 17px" src="../../assets/watermark.svg" alt="##" />
                    <span :class="{ 'btn-text': true, ban: !isWatermark }">開啟/關閉水印</span>
                </span>
                <span v-if="isQueryCouponRange && userInfo.roleID != 4" class="span" @click="gozyCoupon">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconduihuanyouhuiquan2" />
                    </svg>
                    <span class="btn-text">中原優惠券</span>
                    <svg class="icon baseicon" aria-hidden="true">
                        <use xlink:href="#iconnews" />
                    </svg>
                </span>
                <span v-if="isOwner" :class="['span', { disspan: isOwner  && isFixDis ? false : true }]" @click="showSourceDia">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href=" isOwner  && isFixDis ? '#iconxiugaidailiyezhupan':'#iconxiugaidailiyezhupan-copy'" />
                    </svg>
                    <span :class="{ 'btn-text': true, ban: isOwner  && isFixDis ? false : true }">修改為業主/代理盤</span>
                </span>
            </span>
            <span v-show="showOrderBtn" class="btn-span-r">
                <!-- 切换列表图文按钮 -->
                <span class="r-btn">
                    <el-tooltip placement="top" content="自訂欄目">
                        <div v-if="!isSwitchShow" @click="editShow()" :class="{ 'r-btn1': true, active: isEditTextShow }">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#iconshaixuan" />
                            </svg>
                        </div>
                    </el-tooltip>
                    <el-tooltip placement="top" content="列表">
                        <div @click="switchShow(0)" :class="{ 'r-btn2': true, active: !isSwitchShow }">
                            <svg class="icon" aria-hidden="true">
                                <use :xlink:href="!isSwitchShow ? '#iconliebiaomoshi' : '#iconliebiaomoshi-copy'" />
                            </svg>
                        </div>
                    </el-tooltip>
                    <el-tooltip placement="top" content="圖文">
                        <div @click="switchShow(1)" :class="{ 'r-btn3': true, active: isSwitchShow }">
                            <svg class="icon" aria-hidden="true">
                                <use :xlink:href="!isSwitchShow ? '#icondatumoshi-copy' : '#icondatumoshi'" />
                            </svg>
                        </div>
                    </el-tooltip>
                </span>
                <!-- 排序按钮 -->
                 <span class="sort-btn">
                    <div v-show="showTooltip" class="custom-tooltip">
                        注意現在的排序是：{{ tooltipText }}
                    </div>
                    <!-- <el-tooltip
                        v-model="showTooltip"
                        :content="`注意現在的排序是：${tooltipText}`"
                        placement="top"
                        effect="dark"
                        :visible-arrow="true"
                        :append-to-body="true"
                        popper-class="custom-tooltip-box"
                    >
                        <template #default>
                        <span></span>
                        </template>
                    </el-tooltip> -->
                    <div v-show="showCurrentTooltip" class="custom-tooltip">
                        已更改新的排序：{{ tooltipText }}
                    </div>
                    <!-- <el-tooltip
                        v-model="showCurrentTooltip"
                        :content="`已更改新的排序：${tooltipText}`"
                        placement="top"
                        effect="dark"
                        :visible-arrow="true"
                        :append-to-body="true"
                        popper-class="custom-tooltip-box"
                    >
                        <template #default>
                        <span></span>
                        </template>
                    </el-tooltip> -->
                     <div class="pos_shengxu">
                         <svg class="icon" aria-hidden="true" style="width: 16px; height: 16px;">
                             <use xlink:href="#iconshengxu" />
                         </svg>
                     </div>
                    <el-select @change="changeOrder" :class ="['w_230', 'shangye' ,'custom-select-icon',{grecol : colorChanged}]" v-model="order " placeholder="請選擇排序">
                        <el-option v-for=" (item,index) in propertyListSort" :key="index" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"> </el-option>
                    </el-select>
                 </span>
                <!-- <span onselectstart="return false" class="sort">
                    <span :class="{ blue: sortSale }" @click="imgSort('sale')">
                        售價
                        <svg class="icon" aria-hidden="true">
                            <use :xlink:href="!sortSale ? '#iconmorenpaixu' : sortSale == 1 ? '#iconjiangxu' : '#iconshengxu'" />
                        </svg>
                    </span>
                    <span :class="{ blue: sortRent }" @click="imgSort('rent')">
                        租價
                        <svg class="icon" aria-hidden="true">
                            <use :xlink:href="!sortRent ? '#iconmorenpaixu' : sortRent == 1 ? '#iconjiangxu' : '#iconshengxu'" />
                        </svg>
                    </span>
                    <span :class="{ blue: sortTime }" @click="imgSort('time')">
                        到期時間
                        <svg class="icon" aria-hidden="true">
                            <use :xlink:href="!sortTime ? '#iconmorenpaixu' : sortTime == 1 ? '#iconjiangxu' : '#iconshengxu'" />
                        </svg>
                    </span>
                </span> -->

                <span>
                    <el-select @change="loadPropertyList" class="shangye" v-model="pageIndex" placeholder="请选择">
                        <el-option v-for="index in Math.ceil(count / pageCount)" :key="index" :label="`第${index}頁`" :value="index"> </el-option>
                    </el-select>
                </span>
            </span>
        </div>
        <!-- 占位元素 button-->
        <div v-if="isFixed" class="button2"></div>
        <div class="table">
            <!-- 文字列表 -->
            <div class="text-list" v-show="!isSwitchShow">
                <el-table ref="textMultipleTable" :row-class-name="tableRowClassName" :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }" :data="propertyList" empty-text="暫無數據" style="width: 100%" @selection-change="handleSelectionChange" v-loading="firstLoading">
                    <div v-if="isShowText">
                        <el-table-column width="109" v-if="!isDisabledPublish" label="操作" fixed="right">
                            <template slot-scope="scope">
                                <el-button :class="['editBut', { disspancol: !scope.row.showEditButtons || !(scope.row.isFixDisOth || !isFixDis) }]" type="primary" @click="operatingEnter('edit', true, scope.row)">修改</el-button>
                                <div v-show="false">{{ showButtons }}</div>
                                <el-dropdown @visible-change="isshowButtonselse($event, scope.row, false)" trigger="click" :hide-on-click="false">
                                    <span :class="['marBut', { disspancol: !(scope.row.isFixDisOth || !isFixDis) }]">
                                        <el-button v-show="!scope.row.showButtons" :disabled="!(scope.row.isFixDisOth || !isFixDis)" class="expandBut" icon="el-icon-caret-bottom" @click="isshowButtons(scope.row, true)"></el-button>
                                        <el-button v-show="scope.row.showButtons" :disabled="!(scope.row.isFixDisOth || !isFixDis)" class="expandBut" icon="el-icon-caret-top" @click="isshowButtons(scope.row, false)"></el-button>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item>
                                            <div :class="['span', { disspan: !isRecommend }]" @click="recommend(isRecommend, scope.row)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isRecommend ? '#iconzhiding-copy' : '#iconzhiding'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isRecommend }">重新推前</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item v-if="isAutoRec">
                                            <div class="span" @click="showAutoRecDia(scope.row)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href=" isAutoRec ? '#iconzidongzhiding2' : '#iconzidongzhiding'"  />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isAutoRec }">自動置頂</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item v-if="isShowBuyRec">
                                            <div class="span" @click="buyRecommend(scope.row)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use xlink:href="#icongoumaituiqian2icon"  />
                                                </svg>
                                                <span class="btn-text">購買重新推前次數</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item v-if="isShowRecRecord">
                                            <div class="span" @click="recommendRecord(scope.row.propertyID)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use xlink:href="#icontuiqiancishujilu2icon"  />
                                                </svg>
                                                <span class="btn-text">重新推前次數記錄</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div v-show="isShowEdit" :class="['span', { disspan: !isShowEdit }]" @click="editPostUserShow">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isShowEdit ? '#iconxiugaifangpanren-copy' : '#iconxiugaifangpanren'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isShowEdit }">修改放盤人</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div :class="['span', { disspan: !isShow }]" @click="propertyShow(false)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isShow ? '#iconxianshi-copy' : '#iconxianshi'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isShow }">顯示</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div :class="['span', { disspan: !isShow }]" @click="propertyShow(true)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isShow ? '#iconyincang-copy' : '#iconyincang'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isShow }">隱藏</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div v-if="isCopyShow" :class="['span', { disspan: !isCopy }]" @click="openCopyEnter(isCopy)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isCopy ? '#iconfuzhi-copy' : '#iconfuzhi'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isCopy }">複製</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div :class="['span', { disspan: !isRenew }]" @click="renewProperty(isRenew)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isRenew ? '#iconxuqi-copy' : '#iconxuqi'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isRenew }">續期</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item v-if="isShowUpgrade || isUpgradeExpire">
                                            <div :class="['span']" @click="upgradeDiaShow(scope.row)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isUpgradeExpire ? '#iconloupanshengji-copy' : '#iconloupanshengji'"/>
                                                </svg>
                                                <span :class="{ 'btn-text': true,ban:isUpgradeExpire }">樓盤升級</span>
                                            </div>
                                        </el-dropdown-item>
                                        <!-- <el-dropdown-item>
                                            <div :class="['span', { disspan: !isPay }]" @click="operatingEnter('1', isPay)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isPay ? '#iconfukuan-copy' : '#iconfukuan'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isPay }">付款</span>
                                            </div>
                                        </el-dropdown-item> -->
                                        <el-dropdown-item>
                                            <div :class="['span', { disspan: !isSet }]" @click="editPropertyStatusShow(isSet)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isSet ? '#iconloupanzhuangtai-copy' : '#iconloupanzhuangtai'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isSet }">修改樓盤狀態</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div :class="['span']" @click="viewData(scope.row.propertyID)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isShowBrose ? '#iconshuju3' : '#iconshuju4'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isShowBrose }">瀏覽及聯絡數據</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div class="span" @click="goEditJournal(scope.row.propertyID)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href=" isShowJournal ? '#iconxiugaigaiyao1-copy' : '#iconxiugaigaiyao1'"  />
                                                </svg>
                                                <span class="btn-text">樓盤修改概要</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item v-if="isOwner">
                                            <div class="span" @click="updateSource(scope.row.propertyID,scope.row)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use xlink:href="#iconxiugaidailiyezhupan" />
                                                </svg>

                                                <span class="btn-text">修改為{{scope.row.propertySource == '1' ? '代理盤' : '業主盤'}}</span>
                                            </div>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <div :class="['span', { disspan: !isDel }]" @click="deleteRow(isDel)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href="isDel ? '#iconshanchu1-copy' : '#iconshanchu1'" />
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isDel }">刪除</span>
                                            </div>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                        <div v-for="(item, index) in showTextList" :key="item.columnID">
                            <el-table-column width="15" v-if="index === 0"></el-table-column>
                            <el-table-column v-if="index === 0" :selectable="isDisabled" type="selection" width="55"></el-table-column>
                            <!-- 放盤人 -->
                            <el-table-column :show-overflow-tooltip="true" v-if="item.isDefault && item.columnID === 1" label="放盤人" width="220">
                                <template slot-scope="scope">
                                    <span class="account" v-if="scope.row.accountName">{{ scope.row.accountName }}</span>
                                    <span v-else>-</span>
                                    <span class="account">{{ scope.row.departmentNameWithCulture }}</span>
                                </template>
                            </el-table-column>
                            <!-- 楼盘編號 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 2" label="樓盤編號" width="100">
                                <template slot-scope="scope">
                                    <span class="btn-a btn-cursor" @click="enterDetails(scope.row.rentalType, scope.row.propertyID)">{{ scope.row.propertyID }}</span>
                                </template>
                            </el-table-column>
                            <!-- 物業編號 -->
                            <el-table-column label="物業編號" v-if="item.isDefault && item.columnID === 3" width="120">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.propertyNo">{{ scope.row.propertyNo }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 放盤類型 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 4" label="放盤類型" width="100">
                                <template slot-scope="scope">{{ scope.row.rentalTypeWithCulture }}</template>
                            </el-table-column>
                            <!-- 放盤方式 -->
                            <el-table-column label="放盤方式" v-if="item.isDefault && item.columnID === 5" width="100">
                                <template slot-scope="scope">{{ scope.row.topTypeWithCulture ? scope.row.topTypeWithCulture : '-' }}</template>
                            </el-table-column>
                            <!-- 圖片 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 6" label="圖片" width="100">
                                <template slot-scope="scope">
                                    <!-- 图片 -->
                                    <img class="img-cover" :src="pub.imgResize(scope.row.imagePath, 'user')" onerror="errorImg(this,'property')" alt />
                                    <!-- -->
                                    <div v-if="scope.row.imageNumber" class="img-number">{{ scope.row.imageNumber }}</div>
                                </template>
                            </el-table-column>
                            <!-- 平面图 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 28" label="平面圖" width="100">
                                <template slot-scope="scope">
                                    <img class="img-cover" style="width: 50px; height: 50px" v-if="scope.row.planImages[0]" :src="pub.imgResize(scope.row.planImages[0].imagePath, 'user')" onerror="errorImg(this,'property')" alt />
                                    <div v-if="scope.row.planImages[0]" style="width: 50px" class="img-number">{{ scope.row.planImages.length }}</div>
                                    <div style="text-align: center" v-else>-</div>
                                </template>
                            </el-table-column>
                            <!-- 標題 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 7" label="標題" width="220">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.titleWithCulture">{{ scope.row.titleWithCulture }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 區域 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 8" label="樓市片區" width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.gscopeNameWithCulture">{{ scope.row.gscopeNameWithCulture }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 地區 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 9" label="地區" width="200">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.zoneNameWithCulture">{{ scope.row.zoneNameWithCulture }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 屋苑 -->
                            <el-table-column label="屋苑" v-if="item.isDefault && item.columnID === 10" width="150">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.estateNameWithCulture">{{ scope.row.estateNameWithCulture }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 期数 -->
                            <el-table-column label="期數" v-if="item.isDefault && item.columnID === 30" width="180">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.phase">{{ scope.row.phase }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 座數及單位 -->
                            <el-table-column label="座數" v-if="item.isDefault && item.columnID === 31" width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.buildingName">{{ scope.row.buildingName }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="單位" v-if="item.isDefault && item.columnID === 32" width="180">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.roomNo">{{ scope.row.roomNo }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 樓層 -->
                            <el-table-column label="樓層" v-if="item.isDefault && item.columnID === 12" width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.unitFloorWithCulture">{{ scope.row.unitFloorWithCulture }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 自動置頂 -->
                            <el-table-column label="自動置頂到期時間" v-if="item.isDefault && item.columnID === 33" width="140">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.recommendExpireTime">{{ scope.row.recommendExpireTime | getNewTime}}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!--分類  -->
                            <el-table-column label="樓盤類型" v-if="item.isDefault && item.columnID === 13" width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.propertyCategoryWithCulture">{{ scope.row.propertyCategoryWithCulture }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <!-- 價格 -->
                            <el-table-column label="售價(萬)" v-if="item.isDefault && item.columnID === 14" width="120" prop="salePrice" column-key="salePrice">
                                <template slot-scope="scope">
                                    <span v-if="!scope.row.isReducePaidSalePrice && scope.row.isReduceUnPaidSalePrice">{{ scope.row.unPaidSalePrice | priceUnit }}</span>
                                    <span v-else-if="scope.row.salePrice">{{ scope.row.salePrice | priceUnit }}{{ !scope.row.isReducePaidSalePrice && !scope.row.isReduceUnPaidSalePrice && scope.row.subCategory && (scope.row.subCategory[6] || scope.row.subCategory[7]) ? (scope.row.paidSalePrice ? '(已補)' : '(未補)') : '' }}</span>
                                    <span v-else>-</span>
                                    <el-tooltip placement="top" v-if="scope.row.isReducePaidSalePrice || scope.row.isReduceUnPaidSalePrice">
                                        <div slot="content">
                                            原價： <span v-if="scope.row.subCategory && (scope.row.subCategory[6] || scope.row.subCategory[7])">{{ scope.row.isReducePaidSalePrice ? `(已補)${$options.filters.priceUnit(scope.row.firstPaidSalePrice)}` : !scope.row.isReducePaidSalePrice && scope.row.isReduceUnPaidSalePrice ? `(未補)${$options.filters.priceUnit(scope.row.firstUnPaidSalePrice)}` : '' }}</span>
                                            <span v-else>{{ scope.row.firstPaidSalePrice | priceUnit }}</span>
                                        </div>
                                        <img class="imgTip" src="../../assets/hovertip.svg" alt="" />
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <!-- 組價 -->
                            <el-table-column label="租價（元）" v-if="item.isDefault && item.columnID === 15" width="120" prop="rentPrice" column-key="rentPrice">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.rentPrice">{{ scope.row.rentPrice }}</span>
                                    <span v-else>-</span>
                                    <el-tooltip placement="top" v-if="scope.row.isReduceRentPrice">
                                        <div slot="content">原價：${{ parseInt(scope.row.firstRentPrice) }}元</div>
                                        <img class="imgTip" src="../../assets/hovertip.svg" alt="" />
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <!-- 面積 -->
                            <el-table-column label="面積" v-if="item.isDefault && item.columnID === 16" width="150">
                                <template slot-scope="scope">
                                    <p>
                                        實用面積:
                                        {{ scope.row.saleableArea ? scope.row.saleableArea : '-' }}
                                    </p>
                                    <p>
                                        建築面積:
                                        {{ scope.row.buildingArea ? scope.row.buildingArea : '-' }}
                                    </p>
                                </template>
                            </el-table-column>
                            <!-- 顯示狀態 -->
                            <el-table-column label="顯示狀態" v-if="item.isDefault && item.columnID === 17" width="100">
                                <template slot-scope="scope">{{ scope.row.isHide ? '隱藏' : '顯示' }}</template>
                            </el-table-column>
                            <!-- 放盤狀態 -->
                            <el-table-column label="樓盤狀態" v-if="item.isDefault && item.columnID === 18" width="100">
                                <template slot-scope="scope"> {{ scope.row.propertyStatusWithCulture }}</template>
                            </el-table-column>
                            <!-- 樓盤詳情 -->
                            <el-table-column label="樓盤詳情" v-if="item.isDefault && item.columnID === 19" width="250">
                                <template slot-scope="scope">
                                    <p>更新:{{ scope.row.updateTime | getNewTime }}</p>
                                    <p>刊登/續期:{{ scope.row.publicTime | getNewTime }}</p>
                                    <p>可重新推前次數:{{ scope.row.topType == 0 ? '0' : scope.row.recommendNumber }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="到期時間" v-if="item.isDefault && item.columnID === 20" width="150" prop="expireTime" column-key="expireTime">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.expireTime > 0">
                                        <span :class="{ red: expiredDate >= scope.row.expireTime }">{{ scope.row.expireTime | getNewTime }}</span>
                                    </span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="付款狀態" v-if="item.isDefault && item.columnID === 21" width="100" prop="paymentStatusWithCulture">
                                <template slot-scope="scope">
                                    <el-button v-if="!scope.row.paymentStatus" :class="{ 'btn-a': userInfo.accountID === scope.row.accountID && isGoPlay(scope.row), 'btn-table': true }" type="text" @click="goPlay(scope.row.propertyID, scope.row.accountID, scope.row)">{{ scope.row.paymentStatusWithCulture }}</el-button>
                                    <span v-else>{{ scope.row.paymentStatusWithCulture }}</span>
                                </template>
                            </el-table-column>
                            <!-- VR樓盤  -->
                            <el-table-column label="VR" v-if="item.isDefault && item.columnID === 22" width="100">
                                <template slot-scope="scope">
                                    <span @click="enterVr(scope.row)" v-if="scope.row.isTrim" class="blue-vr">有(連AI裝修)</span>
                                    <span @click="enterVr(scope.row)" v-else-if="scope.row.isVR" class="blue-vr">有</span>
                                    <span v-else>無</span>
                                </template>
                            </el-table-column>
                            <!-- 影片 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 26" label="影片" width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isVideo">有</span>
                                    <span v-else>無</span>
                                </template>
                            </el-table-column>
                            <!-- 下架 -->
                            <el-table-column v-if="item.isDefault && item.columnID === 27" label="已被下架" width="100">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isAdminOffLine">是</span>
                                    <span v-else>否</span>
                                </template>
                            </el-table-column>
                            <!-- 曝光等级-->
                            <el-table-column v-if="item.isDefault && item.columnID === 29 && showAdRank" label="曝光等級" width="100">
                                <template slot-scope="scope">
                                    <div class="flexStar" v-if="scope.row.topType !== 3">
                                        <span>{{ scope.row.adRankWithCulture }}</span>
                                        <span class="starimg">
                                            <img v-for="index in starNum(scope.row.adRankWithCulture)" :key="index" src="../../assets/scorestar.svg" alt="##" />
                                            <img v-for="index in 4 - starNum(scope.row.adRankWithCulture)" :key="index + 'star'" src="../../assets/scorestar_gray.svg" alt="##" />
                                        </span>
                                    </div>
                                    <div v-else>-</div>
                                </template>
                            </el-table-column>
                            <!-- 展示位置 -->
                            <el-table-column label="參考排名" v-if="item.isDefault && item.columnID === 23" width="180">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.topType == 3">
                                        <p v-if="scope.row.disPlayPosition.globalRank && scope.row.disPlayPosition.globalRankPage">預設：{{ scope.row.disPlayPosition.globalRankPage > 100 ? '100+' : scope.row.disPlayPosition.globalRankPage }}頁，第{{ scope.row.disPlayPosition.globalRank }}位</p>
                                        <p v-if="scope.row.disPlayPosition.zoneRank && scope.row.disPlayPosition.zoneRankPage">地區：{{ scope.row.disPlayPosition.zoneRankPage > 100 ? '100+' : scope.row.disPlayPosition.zoneRankPage }}頁，第{{ scope.row.disPlayPosition.zoneRank }}位</p>
                                        <p v-else>-</p>
                                    </div>
                                    <div v-else>-</div>
                                </template>
                            </el-table-column>

                            <!-- 楼盘标签 -->
                            <el-table-column label="樓盤標籤" v-if="item.isDefault && item.columnID === 24" width="280">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.propertyTags && scope.row.propertyTags.length <= 5" class="property-tags-main">
                                        <span v-for="item in scope.row.propertyTags" :key="item.propertyTagValue" class="property-tags">
                                            <span>{{ item.propertyTagName }}</span>
                                        </span>
                                    </div>
                                    <div v-else-if="scope.row.propertyTags" class="property-tags-main">
                                        <el-dropdown :hide-timeout="moreTagsHideTimeout" placement="top">
                                            <span class="el-dropdown-link">
                                                <span v-for="(item, index) in scope.row.propertyTags" :key="item.propertyTagValue" class="property-tags">
                                                    <span v-if="index < 5">{{ item.propertyTagName }}</span>
                                                </span>
                                                <span v-if="scope.row.propertyTags && scope.row.propertyTags.length > 5" class="property-tags-more">更多</span>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <div class="properyty-tag-more-dropdown">
                                                    <span v-for="item in scope.row.propertyTags" :key="item.propertyTagName">{{ item.propertyTagName }} </span>
                                                </div>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                    <div v-else>
                                        <span>-</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="顯示業主/代理盤" v-if="item.isDefault && item.columnID === 34" width="180">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.propertySource == '1' ? '業主盤' : '代理盤'}}</span>
                                </template>
                            </el-table-column>
                            <!-- 列表模式楼盘備註 -->
                            <el-table-column label="備註" v-if="item.isDefault && item.columnID === 25" width="180">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length !== 0 && scope.row.propertyRemark.replace(/\s+/g, '').length <= 20">
                                        <span>{{ scope.row.propertyRemark }}</span>
                                    </div>
                                    <div v-else-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length !== 0" class="property-tags-main">
                                        <el-dropdown :hide-timeout="moreTagsHideTimeout" placement="top">
                                            <span class="el-dropdown-link">
                                                <!-- 这里需要展示前20个 -->
                                                <span v-if="scope.row.propertyRemark.replace(/\s+/g, '').length >= 20" style="color: #222222">{{ scope.row.propertyRemark.replace(/\s+/g, ' ').slice(0, 20) }}</span>
                                                <span v-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length > 20" class="property-tags-more">更多</span>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <div class="properyty-tag-more-dropdown">
                                                    <span>{{ scope.row.propertyRemark }} </span>
                                                </div>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                    <div v-else>
                                        <span>-</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </div>
                    </div>
                </el-table>
            </div>
            <!-- 圖片列表 -->
            <div class="img-list" v-show="isSwitchShow">
                <el-table ref="imgMultipleTable" empty-text="暫無數據" cell-class-name="cellImgC" row-class-name="rowImgC" :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }" :data="propertyList" style="width: 100%" @selection-change="handleSelectionChange" v-loading="firstLoading">
                    <el-table-column type="selection" :selectable="isDisabled" width="55"></el-table-column>
                    <el-table-column v-if="!isDisabledPublish" class-name="fixColumm" width="109" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <span>
                                <el-button :class="['editBut', { disspancol: !scope.row.showEditButtons || !(scope.row.isFixDisOth || !isFixDis) }]" type="primary" @click="operatingEnter('edit', true, scope.row)">修改</el-button>
                                <!-- <el-button v-show="!scope.row.showButtons" :disabled="!(scope.row.isFixDisOth || !isFixDis)" class="expandBut" icon="el-icon-caret-bottom" @click="isshowButtons(scope.row, true)"></el-button>
                                <el-button v-show="scope.row.showButtons" :disabled="!(scope.row.isFixDisOth || !isFixDis)" class="expandBut" icon="el-icon-caret-top" @click="isshowButtons(scope.row, false)"></el-button> -->
                            </span>
                            <div v-show="false">{{ showButtons }}</div>
                            <!-- <el-popover placement="bottom" trigger="manual" :ref="`popover-${scope.row.propertyID}`" v-model="scope.row.showButtons" class="item" width="150"> -->
                            <!-- <el-button slot="reference" v-show="!scope.row.showButtons" :disabled="!(scope.row.isFixDisOth || !isFixDis)" class="expandBut" icon="el-icon-caret-bottom" @click="isshowButtons(scope.row, true)"></el-button>
                                <el-button slot="reference" v-show="scope.row.showButtons" :disabled="!(scope.row.isFixDisOth || !isFixDis)" class="expandBut" icon="el-icon-caret-top" @click="isshowButtons(scope.row, false)"></el-button> -->
                            <el-dropdown @visible-change="isshowButtonselse($event, scope.row, false)" trigger="click" :hide-on-click="false">
                                <span :class="['marBut', { disspancol: !(scope.row.isFixDisOth || !isFixDis) }]">
                                    <el-button v-show="!scope.row.showButtons" :disabled="!(scope.row.isFixDisOth || !isFixDis)" class="expandBut" icon="el-icon-caret-bottom" @click="isshowButtons(scope.row, true)"></el-button>
                                    <el-button v-show="scope.row.showButtons" :disabled="!(scope.row.isFixDisOth || !isFixDis)" class="expandBut" icon="el-icon-caret-top" @click="isshowButtons(scope.row, false)"></el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <div :class="['span', { disspan: !isRecommend }]" @click="recommend(isRecommend, scope.row)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isRecommend ? '#iconzhiding-copy' : '#iconzhiding'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isRecommend }">重新推前</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="isAutoRec">
                                            <div class="span" @click="showAutoRecDia(scope.row)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use :xlink:href=" isAutoRec ? '#iconzidongzhiding2' : '#iconzidongzhiding'"/>
                                                </svg>
                                                <span :class="{ 'btn-text': true, ban: !isAutoRec }">自動置頂</span>
                                            </div>
                                        </el-dropdown-item>
                                    <el-dropdown-item v-if="isShowBuyRec">
                                        <div class="span" @click="buyRecommend(scope.row)">
                                            <svg class="icon" aria-hidden="true">
                                                <use xlink:href="#icongoumaituiqian2icon" />
                                            </svg>
                                            <span class="btn-text">購買重新推前次數</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="isShowRecRecord">
                                        <div class="span" @click="recommendRecord(scope.row.propertyID)">
                                            <svg class="icon" aria-hidden="true">
                                                <use xlink:href="#icontuiqiancishujilu2icon" />
                                            </svg>
                                            <span class="btn-text">重新推前次數記錄</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div v-show="isShowEdit" :class="['span', { disspan: !isShowEdit }]" @click="editPostUserShow">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isShowEdit ? '#iconxiugaifangpanren-copy' : '#iconxiugaifangpanren'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isShowEdit }">修改放盤人</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div :class="['span', { disspan: !isShow }]" @click="propertyShow(false)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isShow ? '#iconxianshi-copy' : '#iconxianshi'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isShow }">顯示</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div :class="['span', { disspan: !isShow }]" @click="propertyShow(true)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isShow ? '#iconyincang-copy' : '#iconyincang'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isShow }">隱藏</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div v-if="isCopyShow" :class="['span', { disspan: !isCopy }]" @click="openCopyEnter(isCopy)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isCopy ? '#iconfuzhi-copy' : '#iconfuzhi'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isCopy }">複製</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div :class="['span', { disspan: !isRenew }]" @click="renewProperty(isRenew)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isRenew ? '#iconxuqi-copy' : '#iconxuqi'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isRenew }">續期</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="isShowUpgrade || isUpgradeExpire">
                                        <div :class="['span']" @click="upgradeDiaShow(scope.row)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isUpgradeExpire ? '#iconloupanshengji-copy' : '#iconloupanshengji'"/>
                                            </svg>
                                            <span :class="{ 'btn-text': true,ban:isUpgradeExpire }">樓盤升級</span>
                                        </div>
                                    </el-dropdown-item>
                                    <!-- <el-dropdown-item>
                                        <div :class="['span', { disspan: !isPay }]" @click="operatingEnter('1', isPay)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isPay ? '#iconfukuan-copy' : '#iconfukuan'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isPay }">付款</span>
                                        </div>
                                    </el-dropdown-item> -->
                                    <el-dropdown-item>
                                        <div :class="['span', { disspan: !isSet }]" @click="editPropertyStatusShow(isSet)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isSet ? '#iconloupanzhuangtai-copy' : '#iconloupanzhuangtai'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isSet }">修改樓盤狀態</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div :class="['span']" @click="viewData(scope.row.propertyID)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isShowBrose ? '#iconshuju3' : '#iconshuju4'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isShowBrose }">瀏覽及聯絡數據</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div class="span" @click="goEditJournal(scope.row.propertyID)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href=" isShowJournal ? '#iconxiugaigaiyao1-copy' : '#iconxiugaigaiyao1'"  />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isShowJournal }">樓盤修改概要</span>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="isOwner">
                                            <div class="span" @click="updateSource(scope.row.propertyID,scope.row)">
                                                <svg class="icon" aria-hidden="true">
                                                    <use xlink:href="#iconxiugaidailiyezhupan" />
                                                </svg>
                                                <span class="btn-text">修改為{{scope.row.propertySource == '1' ? '代理盤' : '業主盤'}}</span>
                                            </div>
                                        </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div :class="['span', { disspan: !isDel }]" @click="deleteRow(isDel)">
                                            <svg class="icon" aria-hidden="true">
                                                <use :xlink:href="isDel ? '#iconshanchu1-copy' : '#iconshanchu1'" />
                                            </svg>
                                            <span :class="{ 'btn-text': true, ban: !isDel }">刪除</span>
                                        </div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <div v-show="false" :ref="`popover-${scope.row.propertyID}`" class="popdiv">
                                <div :class="['span', { disspan: !isRecommend }]" @click="recommend(isRecommend, scope.row)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isRecommend ? '#iconzhiding-copy' : '#iconzhiding'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isRecommend }">重新推前</span>
                                </div>
                                <div v-show="isShowEdit" :class="['span', { disspan: !isShowEdit }]" @click="editPostUserShow">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isShowEdit ? '#iconxiugaifangpanren-copy' : '#iconxiugaifangpanren'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isShowEdit }">修改放盤人</span>
                                </div>
                                <div :class="['span', { disspan: !isShow }]" @click="propertyShow(false)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isShow ? '#iconxianshi-copy' : '#iconxianshi'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isShow }">顯示</span>
                                </div>
                                <div :class="['span', { disspan: !isShow }]" @click="propertyShow(true)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isShow ? '#iconyincang-copy' : '#iconyincang'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isShow }">隱藏</span>
                                </div>
                                <div v-if="isCopyShow" :class="['span', { disspan: !isCopy }]" @click="openCopyEnter(isCopy)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isCopy ? '#iconfuzhi-copy' : '#iconfuzhi'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isCopy }">複製</span>
                                </div>
                                <div :class="['span', { disspan: !isRenew }]" @click="renewProperty(isRenew)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isRenew ? '#iconxuqi-copy' : '#iconxuqi'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isRenew }">續期</span>
                                </div>
                                <!-- <div :class="['span', { disspan: !isPay }]" @click="operatingEnter('1', isPay)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isPay ? '#iconfukuan-copy' : '#iconfukuan'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isPay }">付款</span>
                                </div> -->
                                <div :class="['span', { disspan: !isSet }]" @click="editPropertyStatusShow(isSet)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isSet ? '#iconloupanzhuangtai-copy' : '#iconloupanzhuangtai'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isSet }">修改樓盤狀態</span>
                                </div>
                                <div :class="['span', { disspan: !isDel }]" @click="deleteRow(isDel)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="isDel ? '#iconshanchu1-copy' : '#iconshanchu1'" />
                                    </svg>
                                    <span :class="{ 'btn-text': true, ban: !isDel }">刪除</span>
                                </div>
                            </div>
                            <!-- </el-popover> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="圖片" width="150">
                        <template slot-scope="scope">
                            <div class="img" v-if="scope.row.imagePath">
                                <img :src="pub.imgResize(scope.row.imagePath, 'user')" onerror="errorImg(this,'property')" alt />
                                <div v-if="scope.row.topTypeWithCulture === '精選'" class="top">{{ scope.row.topTypeWithCulture }}</div>
                                <div v-if="scope.row.topType === 3" class="star">{{ scope.row.topTypeWithCulture }}</div>
                                <div class="vr">
                                    <span @click="enterVr(scope.row)" v-if="scope.row.isTrim" class="vr-ai"></span>
                                    <span @click="enterVr(scope.row)" v-else-if="scope.row.isVR" class="vr-gif"></span>
                                </div>
                                <div v-if="scope.row.imageNumber" class="number">{{ scope.row.imageNumber }}</div>
                                <img v-if="scope.row.isVideo" class="vidM" src="../../assets/vidlis.svg" alt />
                                <div v-if="scope.row.planImages[0] && scope.row.images.length == 0" class="top" style="background: #090b3b; color: #fff">平面圖</div>
                                <div v-if="scope.row.planImages[0] && scope.row.images.length == 0" class="number">{{ scope.row.planImages.length }}</div>
                            </div>
                            <!-- 平面图 -->
                            <div class="img" v-if="scope.row.images.length !== 0 && scope.row.planImages">
                                <img class="img-cover" v-if="scope.row.planImages[0]" :src="pub.imgResize(scope.row.planImages[0].imagePath, 'user')" onerror="errorImg(this,'property')" alt />
                                <!-- <img class="img-cover" v-else :src="pub.imgResize('', 'user')" onerror="errorImg(this,'property')" alt /> -->
                                <div v-if="scope.row.planImages[0]" class="top" style="background: #090b3b; color: #fff">平面圖</div>
                                <div v-if="scope.row.planImages[0]" class="number">{{ scope.row.planImages.length }}</div>
                            </div>
                            <div class="img">
                                <img v-if="!scope.row.imagePath" :src="pub.imgResize('', 'user')" onerror="errorImg(this,'property')" alt />
                            </div>
                            <div :class="{ h_230: scope.row.planImages.length == 0 || scope.row.images.length == 0, h_120: scope.row.planImages.length !== 0 && scope.row.images.length !== 0 }"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="信息" min-width="1050">
                        <template slot-scope="scope">
                            <div class="title">
                                <div class="left-titbox left-titbox-one">
                                    <!-- {{ scope.row.rentalTypeWithCulture }}- -->
                                    <span class="title-text">{{ scope.row.titleWithCulture }}</span>
                                    <span v-if="scope.row.propertyDisPlayType" class="full-adre">
                                        <!-- 樓盤資料顯示: -->
                                        {{ scope.row.gscopeNameWithCulture ? scope.row.gscopeNameWithCulture : '' }}
                                        {{ scope.row.estateNameWithCulture ? scope.row.estateNameWithCulture : '' }}
                                        {{ scope.row.phase ? scope.row.phase + '&nbsp;&nbsp;' : '' }}{{ scope.row.buildingName ? scope.row.buildingName + '&nbsp;&nbsp;' : '' }}{{ scope.row.floorName ?scope.row.floorName+(scope.row.floorNameEN ?','+ scope.row.floorNameEN:'') +(scope.row.unitFloorWithCulture ? ',' +scope.row.unitFloorWithCulture :''): '' }}{{ scope.row.unitFloorWithCulture && !scope.row.floorName ? scope.row.unitFloorWithCulture : '' }}{{ scope.row.roomNo ? '&nbsp;'+scope.row.roomNo : '' }}
                                    </span>
                                    <span v-else class="full-adre">
                                        {{ scope.row.gscopeNameWithCulture ? scope.row.gscopeNameWithCulture : '' }}
                                        {{ scope.row.estateNameWithCulture ? scope.row.estateNameWithCulture : '' }}
                                        {{ scope.row.phase ? scope.row.phase : '' }}{{ scope.row.buildingName ? scope.row.buildingName : '' }} {{ scope.row.unitFloorWithCulture ? scope.row.unitFloorWithCulture : '' }}{{ scope.row.roomNo ? scope.row.roomNo : '' }}
                                    </span>
                                </div>
                                <div class="left-titbox">
                                    <span class="stitle">
                                        <span class="stitile-no">樓盤編號：</span>
                                        <span @click="enterDetails(scope.row.rentalType, scope.row.propertyID)" class="span click-span">{{ scope.row.propertyID }}</span>
                                    </span>
                                    <span class="stitle">
                                        <span class="stitile-no">物業編號：</span>
                                        <span class="span">{{ scope.row.propertyNo }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="content-1">
                                <div class="detail">
                                    <div class="left">
                                        <p>{{ scope.row.rentalType === 1 ? '售價（萬）：' : '租價（元）：' }}</p>
                                        <p>樓盤類型：</p>
                                        <p>地區：</p>
                                        <p>樓市片區：</p>
                                    </div>
                                    <div class="right">
                                        <!-- "{ 'sale-color': scope.row.rentalType === 1, 'rent-color': scope.row.rentalType === 2 }" -->
                                        <p>
                                            {{ scope.row.rentalType === 1 ? (!scope.row.isReducePaidSalePrice && scope.row.isReduceUnPaidSalePrice ? $options.filters.priceUnit(scope.row.unPaidSalePrice) : scope.row.salePrice ? $options.filters.priceUnit(scope.row.salePrice) + (!scope.row.isReducePaidSalePrice && !scope.row.isReduceUnPaidSalePrice && scope.row.subCategory && (scope.row.subCategory[6] || scope.row.subCategory[7]) ? (scope.row.paidSalePrice ? '(已補)' : '(未補)') : '') : '-') : scope.row.rentPrice ? '$' + scope.row.rentPrice + '元' : '-' }}
                                            <!-- {{ scope.row.rentalType === 1 ? (!scope.row.isReducePaidSalePrice && scope.row.isReduceUnPaidSalePrice ? '$' + parseInt(scope.row.unPaidSalePrice / 10000) + '萬': scope.row.salePrice ? '$' + parseInt(scope.row.salePrice / 10000) + '萬' : '-') : scope.row.rentPrice ? '$' + scope.row.rentPrice + '元' : '-' }} -->
                                            <el-tooltip placement="top" v-if="scope.row.isReducePaidSalePrice || scope.row.isReduceUnPaidSalePrice">
                                                <div slot="content">
                                                    原價：<span v-if="scope.row.subCategory && (scope.row.subCategory[6] || scope.row.subCategory[7])">{{ scope.row.isReducePaidSalePrice ? `(已補)${$options.filters.priceUnit(scope.row.firstPaidSalePrice)}` : !scope.row.isReducePaidSalePrice && scope.row.isReduceUnPaidSalePrice ? `(未補)${$options.filters.priceUnit(scope.row.firstUnPaidSalePrice)}` : '' }}</span>
                                                    <span v-else>{{ parseInt(scope.row.firstPaidSalePrice) | priceUnit }}</span>
                                                </div>
                                                <img class="imgTip" src="../../assets/hovertip.svg" alt="" />
                                            </el-tooltip>
                                            <el-tooltip placement="top" v-if="scope.row.isReduceRentPrice">
                                                <div slot="content">原價：${{ parseInt(scope.row.firstRentPrice) }}元</div>
                                                <img class="imgTip" src="../../assets/hovertip.svg" alt="" />
                                            </el-tooltip>
                                        </p>
                                        <p>
                                            {{ scope.row.propertyCategoryWithCulture ? scope.row.propertyCategoryWithCulture : '-' }}
                                            <span class="pl16">{{ subCategory(scope.row) }}</span>
                                        </p>
                                        <p>{{ scope.row.zoneNameWithCulture ? scope.row.zoneNameWithCulture : '-' }}</p>
                                        <p>{{ scope.row.gscopeNameWithCulture ? scope.row.gscopeNameWithCulture : '-' }}</p>
                                    </div>
                                </div>
                                <div class="detail detail-2 detail-21">
                                    <div class="left">
                                        <p>放盤類型：</p>
                                        <p>樓盤狀態：</p>
                                        <p>顯示業主/代理盤：</p>
                                        <p>樓盤標籤：</p>
                                    </div>
                                    <div class="right">
                                        <p>{{ scope.row.rentalTypeWithCulture }}</p>
                                        <p>{{ scope.row.propertyStatusWithCulture ? scope.row.propertyStatusWithCulture : '-' }}</p>
                                        <p>{{ scope.row.propertySource == '1' ? '業主盤' : '代理盤' }}</p>
                                        <p v-if="scope.row.propertyTags && scope.row.propertyTags.length <= 2">
                                            <span class="tags-list">
                                                <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 1">{{ scope.row.propertyTags[0].propertyTagName }}</span>
                                                <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 2">、{{ scope.row.propertyTags[1].propertyTagName }}</span>
                                            </span>
                                        </p>
                                        <p v-else-if="scope.row.propertyTags" class="property-tags-p">
                                            <el-dropdown :hide-timeout="moreTagsHideTimeout" placement="top">
                                                <span class="el-dropdown-link">
                                                    <div class="tags-show">
                                                        <span class="tags-list">
                                                            <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 1">{{ scope.row.propertyTags[0].propertyTagName }}</span>
                                                            <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 2">、{{ scope.row.propertyTags[1].propertyTagName }}</span>
                                                            <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 3">、</span>
                                                        </span>
                                                        <span class="tag-more" v-if="scope.row.propertyTags && scope.row.propertyTags.length > 2">更多</span>
                                                    </div>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <div class="properyty-tag-more-dropdown">
                                                        <span v-for="item in scope.row.propertyTags" :key="item.propertyTagName">{{ item.propertyTagName }} </span>
                                                    </div>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </p>
                                        <p v-else>-</p>
                                    </div>
                                </div>
                                <div class="detail detail-3">
                                    <div class="left">
                                        <p>實用面積(呎)：</p>
                                        <p>呎價(實用)：</p>
                                        <p>建築面積(呎) ：</p>
                                        <p>呎價(建築) ：</p>
                                    </div>
                                    <div class="right">
                                        <p>{{ scope.row.saleableArea ? scope.row.saleableArea : '-' }}</p>
                                        <p>{{ scope.row.saleableAvgPrice ? '@$' + scope.row.saleableAvgPrice : '-' }}</p>
                                        <p>{{ scope.row.buildingArea ? scope.row.buildingArea : '-' }}</p>
                                        <p>{{ scope.row.buildingAvgPrice ? '@$' + scope.row.buildingAvgPrice : '-' }}</p>
                                    </div>
                                    <!-- <div class="left">
                                        <p>地區：</p>
                                        <p>樓市片區：</p>
                                        <p>放盤類型：</p>
                                        <p>放盤狀態：</p>
                                        <p>樓盤標籤：</p>
                                    </div>
                                    <div class="right">
                                        <p>{{ scope.row.zoneNameWithCulture ? scope.row.zoneNameWithCulture : '-' }}</p>
                                        <p>{{ scope.row.gscopeNameWithCulture ? scope.row.gscopeNameWithCulture : '-' }}</p>
                                        <p>{{ scope.row.rentalTypeWithCulture }}</p>
                                        <p>{{ scope.row.propertyStatusWithCulture ? scope.row.propertyStatusWithCulture : '-' }}</p>
                                        <p v-if="scope.row.propertyTags && scope.row.propertyTags.length <= 2">
                                            <span class="tags-list">
                                                <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 1">{{ scope.row.propertyTags[0].propertyTagName }}</span>
                                                <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 2">、{{ scope.row.propertyTags[1].propertyTagName }}</span>
                                            </span>
                                        </p>
                                        <p v-else-if="scope.row.propertyTags" class="property-tags-p">
                                            <el-dropdown :hide-timeout="moreTagsHideTimeout" placement="top">
                                                <span class="el-dropdown-link">
                                                    <div class="tags-show">
                                                        <span class="tags-list">
                                                            <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 1">{{ scope.row.propertyTags[0].propertyTagName }}</span>
                                                            <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 2">、{{ scope.row.propertyTags[1].propertyTagName }}</span>
                                                            <span v-if="scope.row.propertyTags && scope.row.propertyTags.length >= 3">、</span>
                                                        </span>
                                                        <span class="tag-more" v-if="scope.row.propertyTags && scope.row.propertyTags.length > 2">更多</span>
                                                    </div>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <div class="properyty-tag-more-dropdown">
                                                        <span v-for="item in scope.row.propertyTags" :key="item.propertyTagName">{{ item.propertyTagName }} </span>
                                                    </div>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </p>
                                        <p v-else>-</p>
                                    </div> -->
                                </div>
                            </div>
                            <div class="content-2">
                                <div class="detail">
                                    <div class="left">
                                        <p>付款狀態：</p>
                                        <p>顯示狀態：</p>
                                        <p>已被下架：</p>
                                        <p v-if="scope.row.topType !== 3 && showAdRank">曝光等級：</p>
                                        <p v-else>備註：</p>
                                    </div>
                                    <div class="right">
                                        <p>
                                            <span v-if="!scope.row.paymentStatus" :class="{ 'btn-disable': btndisable, 'btn-a': userInfo.accountID === scope.row.accountID && isGoPlay(scope.row), 'btn-table': true }" type="text" @click="goPlay(scope.row.propertyID, scope.row.accountID, scope.row)">{{ scope.row.paymentStatusWithCulture }} </span>
                                            <span v-if="!scope.row.paymentStatus">
                                                <el-tooltip v-if="scope.row.expireTimeOrderCulture" placement="top">
                                                    <div slot="content">訂單有效期剩餘：{{ scope.row.expireTimeOrderCulture }}</div>
                                                    <img class="imgTip" src="../../assets/hovertip.svg" alt="" />
                                                </el-tooltip>
                                            </span>
                                            <span v-else>{{ scope.row.paymentStatusWithCulture }}</span>
                                        </p>
                                        <p>{{ scope.row.isHide ? '隱藏' : '顯示' }}</p>
                                        <p>
                                            <span>{{ scope.row.isAdminOffLine ? '是' : '否' }}</span>
                                        </p>
                                        <div v-if="scope.row.topType !== 3 && showAdRank">
                                            <span>{{ scope.row.adRankWithCulture }}</span>
                                            <span class="starimg">
                                                <img v-for="index in starNum(scope.row.adRankWithCulture)" :key="index" src="../../assets/scorestar.svg" alt="##" />
                                                <img v-for="index in 4 - starNum(scope.row.adRankWithCulture)" :key="index + 'star'" src="../../assets/scorestar_gray.svg" alt="##" />
                                            </span>
                                        </div>
                                        <div v-else>
                                            <div v-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length !== 0 && scope.row.propertyRemark.replace(/\s+/g, '').length <= 7">
                                                <span>{{ scope.row.propertyRemark }}</span>
                                            </div>
                                            <div v-else-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length !== 0" class="property-tags-main">
                                                <el-dropdown :hide-timeout="moreTagsHideTimeout" placement="top">
                                                    <span class="el-dropdown-link">
                                                        <span v-if="scope.row.propertyRemark.replace(/\s+/g, '').length >= 7" style="font-family: PingFangSC-Regular; font-size: 14px; color: #222222; letter-spacing: 0; line-height: 26px; font-weight: 400">{{ scope.row.propertyRemark.replace(/\s+/g, ' ').slice(0, 7) }}</span>
                                                        <span v-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length > 7" class="property-tags-more">更多</span>
                                                    </span>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <div class="properyty-tag-more-dropdown">
                                                            <span>{{ scope.row.propertyRemark }} </span>
                                                        </div>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </div>
                                            <div v-else>
                                                <span>-</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="detail detail-2">
                                    <div class="left">
                                        <p>放盤人：</p>
                                        <p>刊登/續期：</p>
                                        <p>到期時間：</p>
                                        <p>更新時間：</p>
                                    </div>
                                    <div class="right">
                                        <p>{{ scope.row.accountName ? scope.row.accountName : '-' }}</p>
                                        <p>
                                            <span v-if="scope.row.publicTime > 0">{{ scope.row.publicTime | getNewTime }}</span>
                                            <span v-else>-</span>
                                        </p>
                                        <p>
                                            <span :class="{ red: expiredDate >= scope.row.expireTime }" v-if="scope.row.expireTime > 0">
                                                {{ scope.row.expireTime | getNewTime }}
                                                <el-tooltip placement="top">
                                                    <div slot="content">{{ nowDate >= scope.row.expireTime ? '已過期：' : '剩餘：' }}{{ scope.row.expireTime | getTimeDifference }}</div>
                                                    <img class="imgTip" src="../../assets/hovertip.svg" alt="" />
                                                </el-tooltip>
                                            </span>
                                            <span v-else>-</span>
                                        </p>
                                        <!-- <p>{{ scope.row.refreshTime | getNewTime }}</p> -->
                                        <p>{{ scope.row.updateTime | getNewTime }}</p>
                                    </div>
                                </div>
                                <div class="detail detail-3">
                                    <div class="left">
                                        <p>可重新推前次數：</p>
                                        <p v-if="scope.row.recommendExpireTime">自動置頂到期時間：</p>
                                        <p v-if="scope.row.topType == 3 && scope.row.disPlayPosition.globalRank && scope.row.disPlayPosition.globalRankPage">參考排名(預設)：</p>
                                        <p v-if="scope.row.topType == 3 && scope.row.disPlayPosition.zoneRank && scope.row.disPlayPosition.zoneRankPage">參考排名(地區)：</p>
                                    </div>
                                    <div class="right">
                                        <p>{{ scope.row.topType == 0 ? '0' : scope.row.recommendNumber }}</p>
                                        <p v-if="scope.row.recommendExpireTime">{{ scope.row.recommendExpireTime | getNewTime }}</p>
                                        <p v-if="scope.row.topType == 3 && scope.row.disPlayPosition.globalRank && scope.row.disPlayPosition.globalRankPage">{{ scope.row.disPlayPosition.globalRankPage > 100 ? '100+' : scope.row.disPlayPosition.globalRankPage }}頁，第{{ scope.row.disPlayPosition.globalRank }}位</p>
                                        <p v-if="scope.row.topType == 3 && scope.row.disPlayPosition.zoneRank && scope.row.disPlayPosition.zoneRankPage">{{ scope.row.disPlayPosition.zoneRankPage > 100 ? '100+' : scope.row.disPlayPosition.zoneRankPage }}頁，第{{ scope.row.disPlayPosition.zoneRank }}位</p>
                                    </div>
                                </div>
                                <!-- 已被下架 -->
                                <!-- <div class="detaildown">
                                    <div class="left">
                                        <p>已被下架：</p>
                                    </div>
                                    <div class="right">
                                        <div>
                                            <span>{{ scope.row.isAdminOffLine ? '是' : '否' }}</span>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- 曝光等级 -->
                                <!-- <div v-if="showAdRank" class="detaildown">
                                    <div class="left">
                                        <p>曝光等級：</p>
                                    </div>
                                    <div class="right">
                                        <template>
                                            <div v-if="scope.row.topType !== 3">
                                                <span>{{ scope.row.adRankWithCulture }}</span>
                                                <span class="starimg">
                                                    <img v-for="index in starNum(scope.row.adRankWithCulture)" :key="index" src="../../assets/scorestar.svg" alt="##" />
                                                    <img v-for="index in 4 - starNum(scope.row.adRankWithCulture)" :key="index + 'star'" src="../../assets/scorestar_gray.svg" alt="##" />
                                                </span>
                                            </div>
                                            <div v-else>-</div>
                                        </template>
                                    </div>
                                </div> -->

                                <!-- 图文模式楼盘备注 -->
                                <div class="detaildown" v-if="scope.row.topType !== 3 && showAdRank">
                                    <div class="left">
                                        <p>備註：</p>
                                    </div>
                                    <div class="right">
                                        <div v-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length !== 0 && scope.row.propertyRemark.replace(/\s+/g, '').length <= 50">
                                            <span>{{ scope.row.propertyRemark }}</span>
                                        </div>
                                        <div v-else-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length !== 0" class="property-tags-main">
                                            <el-dropdown :hide-timeout="moreTagsHideTimeout" placement="top">
                                                <span class="el-dropdown-link">
                                                    <!-- 这里需要展示前50个 -->
                                                    <span v-if="scope.row.propertyRemark.replace(/\s+/g, '').length >= 50" style="font-family: PingFangSC-Regular; font-size: 14px; color: #222222; letter-spacing: 0; line-height: 26px; font-weight: 400">{{ scope.row.propertyRemark.replace(/\s+/g, ' ').slice(0, 50) }}</span>
                                                    <span v-if="scope.row.propertyRemark && scope.row.propertyRemark.replace(/\s+/g, '').length > 50" class="property-tags-more">更多</span>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <div class="properyty-tag-more-dropdown">
                                                        <span>{{ scope.row.propertyRemark }} </span>
                                                    </div>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </div>
                                        <div v-else>
                                            <span>-</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column  width="180" label="功能按钮" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" @click="goPlays(scope.row)">复制</el-button>
                            <el-button type="text" @click="goPlays(scope.row)">续期</el-button>
                            <el-button type="text" @click="goPlays(scope.row)">更多</el-button>
                        </template>
                    </el-table-column> -->
                    <el-table-column v-if="false" prop="salePrice" label="姓名" width="180"></el-table-column>
                </el-table>
            </div>
            <!-- 底部分頁 -->
            <div class="footer">
                <el-pagination class="page" background @size-change="sizeChange" :page-size="pageCount" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev, pager, next,jumper" @current-change="currentChange" :current-page.sync="pageIndex" :total="count"></el-pagination>
            </div>
        </div>
        <!-- 列表滚动按钮 -->
        <div v-if="!isSwitchShow" class="left-right-scorll">
            <span onselectstart="return false">
                <svg @click="clicRightScroll('text-list')" class="icon" aria-hidden="true">
                    <use xlink:href="#iconzuo" />
                </svg>
            </span>
            <span onselectstart="return false">
                <svg @click="clicLeftScroll('text-list')" class="icon" aria-hidden="true">
                    <use xlink:href="#iconyou" />
                </svg>
            </span>
        </div>
        <!-- 图文滚动按钮 -->
        <div v-if="isSwitchShow" class="left-right-scorll">
            <span onselectstart="return false">
                <svg @click="clicRightScroll('img-list')" class="icon" aria-hidden="true">
                    <use xlink:href="#iconzuo" />
                </svg>
            </span>
            <span onselectstart="return false">
                <svg @click="clicLeftScroll('img-list')" class="icon" aria-hidden="true">
                    <use xlink:href="#iconyou" />
                </svg>
            </span>
        </div>
        <div>
            <el-dialog top="25vh" :close-on-click-modal="false" v-if="propertyOrder.upgradeTypeToGoldTopSet || propertyOrder.upgradeTypeToStarSet" class="ti-shi" title="樓盤升級" width="580px" :visible.sync="upgradeDia">
                <div class="rec_jieyu">現有結餘：{{renewPropertyData.remainderDiamond.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}鑽石</div>
                <div class="rec_jieyu">當前放盤方式：{{upGradeProData.topType == '1' ? '精選盤' : '標準盤' }}</div>
                <div class="rec_jieyu" >
                    升級放盤方式：
                    <span v-if="upGradeSuper.isShowSuper" :class="['upgrade_box',upgradeType =='Super' ? 'highlight_box' : '']" @click="changeUpPro('Super')">精選盤</span>
                    <span v-if="upGradeStar.isShowStar" :class="['upgrade_box',upgradeType =='Star'? 'highlight_box' : '']" @click="changeUpPro('Star')">星級盤</span>
                </div>
                <div class="rec_jieyu">升級金額：{{upgradeType=='Super' && propertyOrder.upgradeTypeToGoldTopSet ? propertyOrder.upgradeTypeToGoldTopSet.upgradePrice: propertyOrder.upgradeTypeToStarSet.upgradePrice}}鑽石</div>
                <div class="rec_jieyu">
                    升級後樓盤到期日：
                    {{upgradeType=='Super' && propertyOrder.upgradeTypeToGoldTopSet ? propertyOrder.upgradeTypeToGoldTopSet.newExpireTime.substring(0, propertyOrder.upgradeTypeToGoldTopSet.newExpireTime.indexOf('T')): propertyOrder.upgradeTypeToStarSet.newExpireTime.substring(0, propertyOrder.upgradeTypeToStarSet.newExpireTime.indexOf('T'))}}, 
                    {{upgradeType=='Super' ? '精選' : '星級'}}盤
                    {{upgradeType=='Super' && propertyOrder.upgradeTypeToGoldTopSet ?( upGradeProData.rentalType == 1 ? propertyOrder.upgradeTypeToGoldTopSet.newPriceSet.effectiveDays : propertyOrder.upgradeTypeToGoldTopSet.newPriceSet.rentEffectiveDays ): ( upGradeProData.rentalType == 1 ? propertyOrder.upgradeTypeToStarSet.newPriceSet.effectiveDays : propertyOrder.upgradeTypeToStarSet.newPriceSet.rentEffectiveDays )}}天
                </div>
                <div class="mrtxt">
                    升級之後不允許降級，後續所有費用會按照新放盤方式進行收費。<br/>
                    樓盤如已有自動置頂，升級後需重新購買自動置頂
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="upgradeDia = false">取 消</el-button>
                    <el-button type="primary" :class="[(upgradeType=='Super' && propertyOrder.upgradeTypeToGoldTopSet ? propertyOrder.upgradeTypeToGoldTopSet.upgradePrice: propertyOrder.upgradeTypeToStarSet.upgradePrice) <= 0 ? 'dis_but' : '']" @click="showUpgradeDialogStep">確 認</el-button>
                </div>
            </el-dialog>
            <el-dialog top="25vh" v-if="propertyOrder.upgradeTypeToGoldTopSet || propertyOrder.upgradeTypeToStarSet" class="ti-shi" title="樓盤升級" width="580px" :visible.sync="upgradeDiaStep">
                <div class="rec_jieyu">樓盤 {{ upGradeProData.propertyID }} 成功升級</div>
                <div class="rec_jieyu">放盤方式：{{upGradeProData.topType == '1' ? '精選盤' : '標準盤' }}→{{upgradeType=='Super' ? '精選盤' : '星級盤'}}</div>
                <div class="rec_jieyu">付款金額：{{upgradeType=='Super' && propertyOrder.upgradeTypeToGoldTopSet ? propertyOrder.upgradeTypeToGoldTopSet.upgradePrice: propertyOrder.upgradeTypeToStarSet.upgradePrice}}鑽石</div>
                <div class="rec_jieyu">
                    升級後樓盤到期日：
                    {{upgradeType=='Super' && propertyOrder.upgradeTypeToGoldTopSet ? propertyOrder.upgradeTypeToGoldTopSet.newExpireTime.substring(0, propertyOrder.upgradeTypeToGoldTopSet.newExpireTime.indexOf('T')): propertyOrder.upgradeTypeToStarSet.newExpireTime.substring(0, propertyOrder.upgradeTypeToStarSet.newExpireTime.indexOf('T'))}}, 
                    {{upgradeType=='Super' ? '精選' : '星級'}}盤
                    {{upgradeType=='Super' && propertyOrder.upgradeTypeToGoldTopSet ?( upGradeProData.rentalType == 1 ? propertyOrder.upgradeTypeToGoldTopSet.newPriceSet.effectiveDays : propertyOrder.upgradeTypeToGoldTopSet.newPriceSet.rentEffectiveDays ): ( upGradeProData.rentalType == 1 ? propertyOrder.upgradeTypeToStarSet.newPriceSet.effectiveDays : propertyOrder.upgradeTypeToStarSet.newPriceSet.rentEffectiveDays )}}天
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" :class="[(upgradeType=='Super' && propertyOrder.upgradeTypeToGoldTopSet ? propertyOrder.upgradeTypeToGoldTopSet.upgradePrice: propertyOrder.upgradeTypeToStarSet.upgradePrice) <= 0 ? 'dis_but' : '']" @click="confirmUpgrade()">確 認</el-button>
                </div>
            </el-dialog>
            <!-- 多选续期提示  -->
            <el-dialog top="25vh" class="ti-shi" title="樓盤續期" width="618px" :visible.sync="isShowRenewPromptBtn">
                <div class="renew-tishi">
                    <div>放盤方式：{{ renewPropertyData.topTypeWithCulture }}盤</div>
                    <div>
                        現有結餘：{{ renewPropertyData.remainderPropertyCoin }}金幣/{{ renewPropertyData.remainderDiamond }}鑽石
                    </div>
                    <div>
                        預計付款總額：
                        <i class="inormal" v-if="showCoinRs">{{ renewPropertyData.moneyCoin }}金幣</i>
                        <i class="inormal" v-if="showDiamondRs && showCoinRs">/</i>
                        <i class="inormal" v-if="showDiamondRs">{{ renewPropertyData.moneyDiamond }}鑽石</i>
                    </div>
                    <!-- <div>預計付款總額：{{ renewPropertyData.money }}{{ renewPropertyData.topType == 1 || renewPropertyData.topType == 3 ? '鑽石' : '金幣' }}</div> -->
                </div>
                <div v-if="renewPropertyData.expireTime > nowDate && this.multipleChoiceDetails.length == 1" class="renew-tishi renew-onesel">
                    <div>樓盤到期日：{{ renewPropertyData.expireTime | getTime }}, 剩餘：{{ renewPropertyData.expireTime | getTimeDifference }}</div>
                    <div>
                        <!-- 續期後的樓盤到期日：{{ renewPropertyData.expireTime+( renewPropertyData.topType == 0 ?norEffectiveDays :renewPropertyData.topType == 1?gtEffectiveDays:renewPropertyData.topType == 3&& rentalType ==1 ?sbEffectiveDays:srEffectiveDays)| getTime }} -->
                        續期後的樓盤到期日：{{ (renewPropertyData.expireTime + norEffectiveDays) | getTime }}
                    </div>
                    <div class="goon-renew" v-if="!isShowPayWay">是否繼續續期?</div>
                </div>
                <div v-if="this.multipleChoiceDetails.length > 1 && unExpire.length" class="renew-tishi renew-onesel">
                    <div>選擇的樓盤中有未到期樓盤</div>
                    <div>樓盤編號：</div>
                    <div v-if="unExpire.length" class="property-id property-idwid">
                        <span v-for="(item, index) in unExpire" :key="index">{{ item }}</span>
                    </div>
                    <div class="goon-renew" v-if="!isShowPayWay">是否繼續續期?</div>
                </div>
                <div class="iconBox" v-if="isShowPayWay">
                    <div class="goon-renew">是否繼續續期?</div>
                    <span class="renew_lu">請選擇貨幣付款</span>
                    <div class="icons" @click="changeCoin('coin')">
                        <div :class="['icon_img', disCoin ? 'dis_coin' : 'cli_coin',disTxtcoin?'dis_txt':'']"></div>
                        <span :class="{'total':true,'dis_txt':disTxtcoin}">{{ renewPropertyData.moneyCoin }}金幣</span>
                    </div>
                    <div class="icons" @click="changeCoin('diamond')">
                        <div :class="['icon_diamond', disDiamond ? 'dis_diamond' : 'cli_diamond',disTxtDia?'dis_txt':'']"></div>
                        <span :class="{'total':true,'dis_txt':disTxtDia}">{{ renewPropertyData.moneyDiamond }}鑽石</span>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="footerdiv" v-if="isShowUpgrade && isRenewUpgrade">可通過樓盤升級<br/>在續期的同時提升樓盤放盤方式</div>
                    <el-button type="primary" v-if="isShowUpgrade && isRenewUpgrade" @click="upgradeDiaShow(multipleChoiceDetails[0])">樓盤升級</el-button>
                    <el-button @click="isShowRenewPromptBtn = false">取 消</el-button>
                    <el-button type="primary" :class="[paymentType !== 0 && paymentType !== 3 ? 'dis_but' : '']" :disabled="paymentType !== 0 && paymentType !== 3" @click="submitRenewProperty">確 認</el-button>
                </div>
            </el-dialog>
            <!-- ! 自动置顶 -->
            <el-dialog :visible.sync="autoRecommendDia" class="ti-shi" width="618px" title="自動置頂" >
                <div class="rec_jieyu">
                    現有結餘：{{renewPropertyData.remainderDiamond}}鑽石
                    <span class="redTxt" v-if="renewPropertyData.remainderDiamond<recAutoDia">餘額不足</span>
                </div>
                <div class="rec_jieyu">
                    <span> 自動置頂方案：</span>
                    <span v-if="autoRecing">
                        {{autoRecingTxt}}
                    </span>
                    <span v-else-if="autoRecommendList && autoRecommendList.length == 1">
                        {{ autoRecommendList[0].recommendNumber }}天/{{autoRecommendList[0].price }}鑽石
                    </span>
                    <span v-else>
                        <el-select class="w180" v-model="propertyCoinSetID" placeholder="请选择">
                            <el-option v-for="item in autoRecommendList" :key="item.id" :label="item.priceSetCulture" :value="item.id" @click.native="selAutoRecOption(item)"></el-option>
                        </el-select>
                    </span>
                    
                </div>
                <div class="mrl130 mrtxt">服務為單次付款，付款後立即生效。</div>

                <!-- <div class="rec_jieyu">價格：{{recAutoDia}}鑽石</div>
                <div class="rec_jieyu">天數：{{recAutoDay}}天</div> -->
                <div class="rec_jieyu">樓盤過期時間：&nbsp;{{autoProExpire}}</div>
                <div class="rec_jieyu" v-show="autoRecNowDate">預計自動置頂時間：&nbsp;{{autoRecNowDate}}&nbsp;至&nbsp;{{autoRecExpireDate}}</div>
                <template v-if="autoRecing">
                    <div class = "iconbox">
                        <svg class="icon mrl153" aria-hidden="true">
                            <use xlink:href="#icondengdai" />
                        </svg>
                        <span class="mrauto">自動置頂中……</span>
                    </div>
                </template>
                <template v-else>
                    <div class="mrl153" v-if="autoRectimTit">
                        請注意, 自動置頂日期長過樓盤到期時間, 如果樓盤過期後, <br/>自動置頂也會失效。
                    </div>
                    <div class="mrl153 mrtxt">最終實際開始時間以再次確認自動置頂時間為準</div>
                </template>
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="autoRecommendDia = false">取 消</el-button>
                    <el-button type="primary"  :class="[renewPropertyData.remainderDiamond<recAutoDia ? 'dis_but' : '']" :disabled="renewPropertyData.remainderDiamond<recAutoDia" @click="autoRecDiaConTime">確 認</el-button>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="conRecDia" class="ti-shi" width="618px" title="自動置頂" >
                <div class="rec_jieyu">付款總額：{{recAutoDia}}鑽石</div>
                <div class="rec_jieyu">預計自動置頂時間：&nbsp;{{autoRecNowDate}}&nbsp;至&nbsp;{{autoRecExpireDate}}</div>
                <div class="mrl153 mrtxt">最終實際開始時間以再次確認自動置頂時間為準</div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="conRecDia = false">取 消</el-button>
                    <el-button type="primary" @click="goAutoRec">確 認</el-button>
                </div>
            </el-dialog>
            <el-dialog top="25vh" class="ti-shi" title="購買重新推前次數" width="580px" :visible.sync="isBuyRecommend">
                <div class="rec_jieyu">現有結餘:{{renewPropertyData.remainderPropertyCoin}}金幣/{{renewPropertyData.remainderDiamond}}鑽石</div>
                <div class="rec_jieyu"> {{recCoinDis ? recCoinPrice+'金幣':''}} {{recCoinDis && recDiaDis ? '/':''}}{{recDiaDis ?recDiaPrice+'鑽石':''}} :重新推前[ {{recParts}} ]次</div>
                <div class="rec_jieyu">
                    <span class="redStar">*</span>購買份數:
                    <el-input-number v-model="recommendPart" :min="1" :max="maxRecommendPart" @change = "changeRecPart"></el-input-number>
                    每增加一份為貨幣購買的倍數
                </div>
                <div v-if="isShowRecType">
                    <div class="icons left_coin" @click="changeRecCoin('coin')">
                        <div :class="['icon_img', disRecCoin ? 'dis_coin' : 'cli_coin',disRecTxtcoin?'dis_txt':'']"></div>
                        <span :class="{'total':true,'dis_txt':disRecTxtcoin}">{{ recommendPart*recCoinPrice }}金幣</span>
                    </div>
                    <div class="icons" @click="changeRecCoin('diamond')">
                        <div :class="['icon_diamond', disRecDiamond ? 'dis_diamond' : 'cli_diamond',disRecTxtDia?'dis_txt':'']"></div>
                        <span :class="{'total':true,'dis_txt':disRecTxtDia}">{{ recommendPart*recDiaPrice }}鑽石</span>
                    </div>
                    <div class="redTxt" v-if="disRecCoin && disRecDiamond">餘額不足</div>
                </div>
                <div class="rec_jieyu">合共重新推前次數:&nbsp;&nbsp;{{recParts*recommendPart}}次</div>
                <div class="rec_jieyu">付款總額:{{ paymentTypeRec == 3 ? recommendPart*recDiaPrice +'鑽石':recommendPart*recCoinPrice +'金幣' }}</div>
                <div class="rec_jieyu">請確認合共購買重新推前次數及付款</div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isBuyRecommend = false">取 消</el-button>
                    <el-button type="primary" :class="{'dis_but':(isShowRecType && disRecCoin && disRecDiamond) || (recCoinDis && !recDiaDis && recCoinPrice >renewPropertyData.remainderPropertyCoin ) || (!recCoinDis && recDiaDis && recDiaPrice >renewPropertyData.remainderDiamond )}" @click="conBuyRecommend">確 認</el-button>
                    <div class="redTxt" v-if=" (recCoinDis && !recDiaDis && recCoinPrice > renewPropertyData.remainderPropertyCoin) || (!recCoinDis && recDiaDis && recDiaPrice > renewPropertyData.remainderDiamond )">餘額不足</div>
                </div>
            </el-dialog>
            
            <!-- 多选续期提示  -->
            <el-dialog top="25vh" class="ti-shi" title="樓盤續期" width="480px" :visible.sync="isShowRenewPrompt">
                <div class="renew-tishi">
                    <div>放盤方式：{{ renewPropertyData.topTypeWithCulture }}盤</div>
                    <div>
                        預計付款總額：
                        <i class="inormal" v-if="showCoinRs && paymentType === 0">{{ renewPropertyData.moneyCoin }}金幣</i>
                        <i class="inormal" v-if="showDiamondRs && paymentType === 3">{{ renewPropertyData.moneyDiamond }}鑽石</i>
                    </div>
                    <div>
                        實際付款總額：
                        <i class="inormal" v-if="showCoinRs && paymentType === 0">{{ renewResData.sumCoin }}金幣</i>
                        <i class="inormal" v-if="showDiamondRs && paymentType === 3">{{ renewResData.sumDiamond }}鑽石</i>
                    </div>
                    <br />
                    <div v-for="(item, index) in renewResData.renewReasonList" :key="index">
                        <div>{{ item.message }}</div>
                        <div>樓盤編號：</div>
                        <div class="property-id">
                            <span v-for="it in item.propertyIDList" :key="it">{{ it }}</span>
                        </div>
                        <br />
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isShowRenewPrompt = false">取 消</el-button>
                    <el-button type="primary" @click="judgeOldPro('renew')">確 認</el-button>
                </div>
            </el-dialog>
            <!-- 删除提示框  -->
            <el-dialog top="25vh" class="ti-shi" title="提示" width="400px" :visible.sync="isShowdelPrompt">
                <div class="del-tishi">
                    <div>
                        <i class="el-icon-info icon"></i>
                        <span class="span">確認刪除已選的樓盤嗎?</span>
                        <div v-if="delPropertyData.post" class="num">刊登中：{{ delPropertyData.post }}個</div>
                        <div v-if="delPropertyData.noPay" class="num">未支付：{{ delPropertyData.noPay }}個</div>
                        <div v-if="delPropertyData.expired" class="num">已過期：{{ delPropertyData.expired }}個</div>
                    </div>
                    <div>
                        <p v-if="delPropertyData.post">刪除後，資料將無法復原，已支付的刊登費用亦不會獲退回</p>
                        <p v-else>刪除後，資料將無法復原</p>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isShowdelPrompt = false">取 消</el-button>
                    <el-button type="primary" @click="deleteProperty">確 認</el-button>
                </div>
            </el-dialog>
            <!-- 删除后提示框 -->
            <el-dialog top="25vh" class="ti-shi" title="刪除樓盤" width="480px" :visible.sync="isShowdeledPrompt">
                <div class="renew-tishi">
                    <template v-if="deledProperty.removeSuccess">
                        <div>成功刪除樓盤，共{{ deledProperty.removeSuccess }}個</div>
                        <div>樓盤編號：</div>
                        <div class="property-id">
                            <span v-for="it in deledProperty.successList" :key="it">{{ it }}</span>
                        </div>
                        <br />
                    </template>
                    <template v-if="deledProperty.removeFail">
                        <div>因沒有刪除該樓盤的權限，無法刪除，共{{ deledProperty.removeFail }}個</div>
                        <div>樓盤編號：</div>
                        <div class="property-id">
                            <span v-for="item in deledProperty.failList" :key="item">{{ item }}</span>
                        </div>
                    </template>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isShowdeledPrompt = false">取 消</el-button>
                    <el-button type="primary" @click="isShowdeledPrompt = false">確 認</el-button>
                </div>
            </el-dialog>
            <el-dialog top="25vh" class="ti-shi" title="修改為業主/代理盤" width="480px" :visible.sync="isshowSource">
                <div class="sour_box">
                    <el-radio-group v-model="updateProSource" class="onlyChoose">
                        <el-radio label="1">業主盤</el-radio>
                        <el-radio label="2">代理盤</el-radio>
                    </el-radio-group>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="updateSource('0')">確 認</el-button>
                </div>
            </el-dialog>

            <el-dialog top="25vh" class="ti-shi" title="提示" width="480px" :visible.sync="isShowSourceSuccessId">
                <div class="source-tishi">
                    <div class="id_box" v-if="showSoureID">
                        <div>以下樓盤已選擇了銀主盤，無法修改為業主盤</div>
                        <div>樓盤編號：</div>
                        <div class="property-id">
                            <span v-for="item in fileSourceList" :key="item">{{ item }}</span>
                        </div>
                    </div>
                    <div class="icon_box" v-else>
                        <i class="greeicon el-icon-success"></i>
                        修改完成
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="isShowSourceSuccessId = false">確 認</el-button>
                </div>
            </el-dialog>

            <!-- 钻石关闭  续期支付提示  -->
            <el-dialog top="25vh" class="ti-shi" title="提示" width="480px" :visible.sync="isShowDiamondPrompt">
                <div class="tishi">
                    <i class="el-icon-info icon"></i>
                    <div>
                        無法付款，你的公司已暫停使用此放盤方式，
                        <br />如需繼續使用，請與我們銷售部聯絡 (Tel: 3619 3218)
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isShowDiamondPrompt = false">取 消</el-button>
                    <el-button type="primary" @click="isShowDiamondPrompt = false">確 認</el-button>
                </div>
            </el-dialog>
            <el-dialog top="25vh" class="ti-shi disti-shi" title="提示" width="480px" :visible.sync="upbuttonClick" :close-on-click-modal="false">
                <div class="tishi distishi">
                    <i class="el-icon-warning icon"></i>
                    <div>
                        此刊登類型無法升級
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="upbuttonClick = false">知道了</el-button>
                </div>
            </el-dialog>
            <el-dialog top="25vh" class="ti-shi disti-shi" title="提示" width="480px" :visible.sync="isshowErrCon" :close-on-click-modal="false">
                <div class="tishi distishi">
                    <i class="el-icon-warning icon"></i>
                    <div>
                        貴公司沒有權限刊登/複製/續期[{{propertyDetail.propertyCategoryWithCulture}}<span v-for="item in childCateStr" :key="item.dictionaryValue">{{item.dictionaryWithCulture}}</span>]
                        類型樓盤，如有任何問題，請聯絡我們的銷售代表或客戶服務專員，謝謝。
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="closeErrCon">知道了</el-button>
                </div>
            </el-dialog>
            <!-- 複製樓盤选择租售 -->
            <el-dialog title="複製樓盤" width="480px" :visible.sync="isEnterCopy">
                <div class="post-enter">
                    <el-row>
                        <el-col :span="12">
                            <el-button type="primary" @click="enterCopyPost(1)">售盤</el-button>
                        </el-col>
                        <el-col :span="12">
                            <el-button type="primary" @click="enterCopyPost(2)">租盤</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
            <!-- 刊登樓盤租售選擇 -->
            <el-dialog title="刊登樓盤" width="480px" :visible.sync="isEnterPost">
                <div class="post-enter">
                    <el-row>
                        <el-col :span="12">
                            <el-button type="primary" @click="enterPostPage(1)">刊登售盤</el-button>
                        </el-col>
                        <el-col :span="12">
                            <el-button type="primary" @click="enterPostPage(2)">刊登租盤</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
            <!-- 修改楼盘状态管理弹窗 -->
            <el-dialog title="管理樓盤狀態" width="400px" :visible.sync="isEditPropertyStatus">
                <el-select class="w120" v-model="propertyStatus" placeholder="樓盤狀態">
                    <el-option v-for="item in editStatusForm.rentalType == '2' ? RentStatusList : SaleStatusList" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue"></el-option>
                </el-select>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isEditPropertyStatus = false">取 消</el-button>
                    <el-button type="primary" @click="editPropertyStatus">確 認</el-button>
                </div>
            </el-dialog>
            <!-- 修改楼盘放盘人代理人弹窗 -->
            <el-dialog title="選擇放盤人" width="580px" :visible.sync="isEditPostUser">
                <el-row :gutter="10">
                    <!-- 需要调整 -->
                    <el-col :span="3">
                        <div class="edit-text">組別：</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="edit-content">{{ editDepartmentName }}</div>
                    </el-col>
                    <el-col :span="3">
                        <div class="edit-text">員工：</div>
                    </el-col>
                    <el-col :span="8">
                        <el-select v-model="editAccountID" filterable placeholder="請選擇員工">
                            <!-- 动态判断租售 -->
                            <el-option v-for="(item, index) in editPostUserList" :key="index" :label="item.name" :value="item.accountID"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isEditPostUser = false">取 消</el-button>
                    <el-button type="primary" @click="editPostUser">確 認</el-button>
                </div>
            </el-dialog>
            <!-- 修改楼盘列表显示字段彈窗 -->
            <el-dialog title="樓盤列表顯示欄位" width="480px" height="580px" @close="editTextClose" :visible.sync="isEditTextShow" class="edit-text-show">
                <p class="p-dialog">選擇顯示欄位，拖動可修改欄位排列</p>
                <el-row class="el-row-dialog">
                    <el-col :span="12">欄位</el-col>
                    <el-col :span="6">是否顯示</el-col>
                    <el-col :span="6">排列次序</el-col>
                </el-row>
                <draggable v-model="editTextList">
                    <transition-group>
                        <el-row class="el-list" v-for="item in editTextList" :key="item.columnID">
                            <el-col :span="12">{{ item.columnName }}</el-col>
                            <el-col :span="6">
                                <el-checkbox v-model="item.isDefault"></el-checkbox>
                            </el-col>
                            <el-col :span="6">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icontuozhuai" />
                                </svg>
                            </el-col>
                        </el-row>
                    </transition-group>
                </draggable>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isEditTextShow = false">返 回</el-button>
                    <el-button type="primary" @click="editText">儲 存</el-button>
                </div>
            </el-dialog>
            <!-- 星级置顶成功提示 -->
            <el-dialog class="ti-shi" title="提示" width="480px" :visible.sync="isShowRecommend" :before-close="loadPropertyList">
                <div class="tishi">
                    <i class="el-icon-info icon"></i>
                    <div v-if="propertyDetail.topType == 3">
                        重新推前成功
                        <br />
                        <span>星級盤參考排名將於稍後更新</span>
                    </div>
                    <div v-else>重新推前成功</div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <!-- <el-button @click="isShowRecommend = false">取 消</el-button> -->
                    <el-button
                        type="primary"
                        @click="
                            () => {
                                this.loadPropertyList();
                            }
                        "
                        >確 認</el-button
                    >
                </div>
            </el-dialog>
            <!-- 水印 -->
            <el-dialog class="wa-mark" title="水印功能" :visible.sync="waterVisible" width="33%" :before-close="waterClose">
                <div class="wa-qiyong">
                    <span style="margin-right: 15px; margin-left: 13px">水印功能：</span>
                    <span>
                        <el-checkbox v-model="waterMark"><p style="font-size: 16px; color: #222">啟用</p></el-checkbox>
                        <span class="qiyong">啟用後，刊登樓盤時上傳的所有圖片會加上公司名稱</span>
                    </span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="waterVisible = false">取 消</el-button>
                    <el-button type="primary" @click="storeMark">確 認</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import { mapGetters, mapActions } from 'vuex';

/**调整火狐拖拽兼容性问题 */
document.body.ondrop = function (event) {
    event.preventDefault();
    event.stopPropagation();
};
export default {
    components: {
        draggable
    },
    name: 'property',
    watch: {
        '$store.state.keyString'(nval, oval) {
            if (nval != '-1') {
                this.keyString = this.$store.state.keyString;
                this.loadPropertyList(true);
            }
        },
        categoryIf: {
            handler(newVal, oldVal) {
                if (!Array.isArray(oldVal)) return;
                if (newVal[0] != oldVal[0]) {
                    this.tagShow();
                }
            },
            immediate: true
        },
        /**租售价修改监控 */
        rentPriceCode(val) {
            this.watchRentPrice(val);
        },
        minRentPrice(val) {
            this.watchRentPrice(val);
        },
        maxRentPrice(val) {
            this.watchRentPrice(val);
        },
        salePriceCode(val) {
            this.watchSalePrice(val);
        },
        minSalePrice(val) {
            this.watchSalePrice(val);
        },
        maxSalePrice(val) {
            this.watchSalePrice(val);
        },
        /**判断滚动距离 */
        scrollValue(val) {
            if (this.isMoreChoose) {
                if (val >= 250) {
                    this.isFixed = true;
                } else {
                    this.isFixed = false;
                }
            } else {
                if (val >= 120) {
                    this.isFixed = true;
                } else {
                    this.isFixed = false;
                }
            }
        },
        /**地區區域關聯 */
        zoneCode(val) {
            if (!val) this.gscopeList = [];
            this.gscopeCode = '';
            this.regionList.forEach(item => {
                if (item.gscopeCode === val) {
                    this.gscopeList = item.children;
                }
            });
        },
        /**暫時沒用 */
        editDepartmentID(val) {
            this.editAccountID = '';
            this.loadMarketParticipantsUser();
        },
        /**租售關聯 */
        rentalType(val) {
            this.rentalTags(val);
            if (val == 1) {
                this.statusList = this.SaleStatusList;
            } else if (val == 2) {
                this.statusList = this.RentStatusList;
            } else {
                this.statusList = [];
            }
        }
    },
    computed: {
        /**
         * 固定列按钮是否禁用规则
         * 1.前选中,只有选中数据后的固定按钮可用,其余禁用
         * 2.前多选,固定按钮皆禁用
         * 3.前未选,固定按钮皆可用,但是要根据当前选中了什么进行判断
         * */
        // isFixDis为true就全部禁用!
        // isFixDisOth为true就可以isSelected判断哪个功能可用,如果为false,就全部按钮禁用(证明前面选中的和后面打开的不是一个)
        // 前面没选就直接isSelected
        isFixDis() {
            if (this.fixPropertyList.length >= 1) return true;
            if (this.fixPropertyList.length < 1) return false;
        },
        maxRecommendPart(){
            if(this.paymentTypeRec){
               return Math.floor(this.renewPropertyData.remainderDiamond / this.recDiaPrice )
            }else{
               return Math.floor(this.renewPropertyData.remainderPropertyCoin / this.recCoinPrice )
            }
        },
        ...mapGetters(['page', 'sideBar'])
    },
    data() {
        return {
            showTooltip: false,//切换账户，重新登入展示tip
            showCurrentTooltip:false,//当前修改order展示tip
            tooltipText: '',
            colorChanged:false,
            isshowSource:false,
            updateProSource:'2',
            isShowSourceSuccessId :false,
            showSoureID :false,
            fileSourceList:[],
            childCateStr:[],
            upbuttonClick:false,
            isshowErrCon:false,
            upgradeDisBut:false,//已过期楼盘，楼盘类型错误时，楼盘升级按钮保持禁用
            disRecTxtDia:false,
            disRecTxtcoin:false,//购买推前金币按钮是否禁用
            isShowRecType:true,
            disTxtDia:false,//按钮样式禁用
            disTxtcoin:false,
            twoTypeDis:false,
            isShowPayWay:true,
            showCoinRs:false,
            showDiamondRs:false,
            disRecCoin:false,//购买推前金币按钮是否高亮
            disRecDiamond:false,
            disCoin: true,
            disDiamond: true,
            payWayEmpy: false,
            paymentType: '',
            paymentTypeRec:'',
            norEffectiveDays:'',
            fixPropertyList: [], //判断固定列按钮功能规则定义按钮
            noneFrontSel: true, //当下未选中,仅点击展开固定列时,上功能按钮不高亮
            // noneFrontSel: false, 
            showButtons: false, //展开固定列按钮
            scoreStar: [{ 一般: 1 }, { 較多: 2 }, { 優先: 3 }],
            isResouceShow: 1,
            copyPropertyTags: [],
            propertyListSort:[],
            categoryValueEnd: [],
            /**房源标签 */
            moreTagsHideTimeout: 360,
            propertyTagsValue: '',
            categoryValue: '',
            categoryIf: [], //已经选择的楼盘类型
            propertyTags: [],
            propertyTagsList: [],
            renewResData: {},
            delPropertyData: {},
            isShowdelPrompt: false,
            propertyPrice: {},
            recommendPrice:{},
            autoRecommendList:[],
            propertyRecommend:{},
            recTopPermission:false,
            recStarPermission:false,
            renewPropertyData: {},
            unExpire: [],
            deledProperty: {},
            isShowdeledPrompt: false,
            isShowRenewPromptBtn: false,
            isShowRenewPrompt: false,
            multipleChoiceDetails: [],
            /**新版是否能管理楼盘 不再判断是否是自己楼盘 */
            isEditProperty: false,
            /**星级盘重新置顶提示 */
            isShowRecommend: false,
            isShowDiamondPrompt: false,
            admin: false, //是否是管理员 删除楼盘使用
            adminSelf: false, //05期规则修改 删除楼盘使用
            maxSco: 0,
            sco: 0,
            isEnterCopy: false,
            driver: null,
            isAgent: true,
            isDisabledPublish: false,
            /**重新置顶 */
            isRecommend: false,
            isAutoRec:false,
            isShowJournal:false,
            isShowBuyRec:false,
            isShowRecRecord:false,
            isWatermark: false,
            isOwner:false,
            isBuyRecommend:false,
            autoRecommendDia:false,
            recAutoDia:'',
            // recAutoDay:'',
            // autoRecPropertyType:'',//选中自动置顶的楼盘类型
            // autoRecNumberType:'',//选中楼盘的自动置顶租售次数
            autoRecing:false,//楼盘是否在自动置顶中
            autoRectimTit:false,//自动置顶过期时间提示显隐开关
            autoRecExpireDate:'',//自动购买过期时间
            autoProExpire:'',//自动置顶楼盘的过期时间
            propertyExpiretime:'',
            autoRectimestamp:'',//自动购买过期时间戳
            autoRecNowDate:'',//购买起始时间
            autoRecPropertyID:'',
            propertyCoinSetID:'',
            conRecDia:false,
            recCoinDis:'',
            recDiaDis:'',
            recCoinPrice:'',
            recDiaPrice:'',
            recParts:'',
            recommendPro:{},
            recommendPart:1,
            recomMoneyCoin:'',
            recomMoneyDiamond:'',
            waterMark: false,
            waterVisible: false,
            firstLoading: true,
            isDepartment: false,
            isEnterPost: false,
            /**滚动值 */
            scrollValue: 0,
            /**操作栏是否置顶 */
            isFixed: false,
            isShow: false,
            isCopy: false,
            isCopyShow: true,
            isEdit: false,
            isEditText: false,
            isRenew: false,
            isRenewText: false,
            isPay: false,
            btndisable: false,
            isSet: false,
            isShowUpgrade:false,//升级按钮是否展示（true为展示）
            isUpgradeExpire:false,//按钮是否为禁用状态（true为禁用）
            upgraderDisMes:[],//升级在禁用情况下，触发限制规则提示内容字段
            isRenewUpgrade:false,//true 已过期楼盘无需判断其余规则，直接展示升级按钮且可升级
            isDel: false,
            // isRem: true,
            isMoreChoose: false,
            isShowText: true,
            upgradeDia:false,
            propertyOrder:{},
            upgradeDiaStep:false,
            upgradeType:'',//升级的楼盘类型
            minUpDiamond:false,
            upGradeProData:{},
            upGradeSuper:{
                upGradeExpireMoney:'',//原价
                shortfallMoney:'',//差额
                isShowSuper:false,//是否展示精选
                upGradeExpireTime :''//到期日
            },
            upGradeStar:{
                upGradeExpireMoney:'',//原价
                shortfallMoney:'',//差额
                isShowStar:false,//是否展示星级
                upGradeExpireTime :''//到期日
            },
            isAdminOffLine: '',
            isAutoRecommend:'',
            isPropertyUpgradeType:'',
            rankType: '',
            accountName: '', //放盘人搜索
            timeId: '', //定時器
            userInfo: [],
            /**修改房源状态变量 */
            propertyStatus: '',
            /**房源信息 */
            count: 0,
            propertyList: [],
            pageCount: 10, //每页数据量
            pageIndex: 1, //当前页数
            /**區塊信息 */
            regionList: [],
            gscopeList: [],
            regionCode: '', //區域
            gscopeCode: '', //地區
            zoneCode: '', // 樓市片區
            /**楼盘代理类型*/
            propertyAgentList: [
                { dictionaryValue: 0, dictionaryNameWithCulture: '全部' },
                { dictionaryValue: 'owner', dictionaryNameWithCulture: '個人放盤' },
                { dictionaryValue: 'agent', dictionaryNameWithCulture: '個人代理放盤' }
            ],
            /**屋苑 */
            estateName: '',
            /**关键字搜索 */
            keyString: '',
            /**訂單付款狀態 */
            paymentStatus: '',
            paymentStatusList: [
                { dictionaryValue: '0', dictionaryNameWithCulture: '未付款' },
                { dictionaryValue: '1', dictionaryNameWithCulture: '已付款' }
            ],
            /**房屋類型 */
            category: '',
            categoryList: [],
            isAdminOffList: [],
            isAutoRecommendList:[],
            isPropertyUpgradeTypeList:[],
            propertySourceList:[],
            /**租售類型 */
            rentalType: '',
            rentalList: [],
            /**放盤方式 */
            checked: false,
            topType: '',
            topOptions: [],
            AdRank: [],
            /**顯示狀態 */
            showStatus: '',
            showStatusList: [
                { dictionaryValue: 1, dictionaryNameWithCulture: '顯示' },
                { dictionaryValue: 2, dictionaryNameWithCulture: '隱藏' }
            ],
            showPropertyRemark: [
                { dictionaryValue: 1, dictionaryNameWithCulture: '有備註' },
                { dictionaryValue: 2, dictionaryNameWithCulture: '無備註' }
            ],
            /**放盤狀態 */
            saleRentStatus: '',
            statusList: [],
            SaleStatusList: [],
            RentStatusList: [],
            /**時間 */
            expireStartTime: '',
            expireEndTime: '',
            publicTimeStartTime: '',
            publicTimeEndTime: '',
            expireTimeOption: {
                disabledDate: this.expireTimeOption1
            },
            publicTimeOption: {
                disabledDate: this.publicTimeOption1
            },
            expireTimeOption2: {
                disabledDate: this.expireTimeOption3
            },
            publicTimeOption2: {
                disabledDate: this.publicTimeOption3
            },
            /**搜索內容 */
            // propertyIds: "",
            departmentList: [], //组织列表
            departmentID: '', //组织id
            showMorePha: false, //展示期数座数更多引导
            /**圖文 列表展示控制 */
            isSwitchShow: 0,
            /**楼盘状态管理弹窗 */
            isEditPropertyStatus: false,
            editStatusForm: {},
            /**修改放盤人 */
            accountID: '', //放盘人ID
            /**樓盤代理類型 */
            searchAccountPropertyType: '',
            isEditPostUser: false,
            editPostUserList: [], //放盘人列表
            /**修改字段顯示 */
            isEditTextShow: false,
            showTextList: [], //字段展示列表
            editTextList: [], //字段修改列表
            /**楼盘选中id列表 */
            propertyIdList: [],
            propertyDetail: {},
            recommendDetail: [],
            /**房間數目 */
            roomNumber: '',
            roomNumberList: [],
            /**修改放盤人名字 */
            editName: '',
            /**當前時間戳 */
            nowDate: parseInt(new Date().getTime() / 1000),
            expiredDate: parseInt((new Date().getTime() + 5 * 24 * 60 * 60 * 1000) / 1000),
            expiredUpDate: parseInt((new Date().getTime()) / 1000),
            /**是否有修改放盤人權限 */
            isShowEdit: false,
            isEditPost: false,
            isAdmin: false,
            /**修改代理人組別 */
            editDepartmentID: '',
            editAccountID: '',
            editPostDepartmentIDList: [],
            editDepartmentName: '',
            /**判斷是否能夠放盤 */
            isPost: false,
            /**中原利嘉阁或者其他代理公司 1,2,3 */
            companyCategory: 0,
            isShowPlayDialog: false,
            isPlayText: false,
            sortSale: 0,
            sortRent: 0,
            sortTime: 0,
            /** 1 VR 2一件裝修 */
            propertyLabelValue: '',
            propertyLabelValueList: [],
            unitFloor: '',
            unitFloorList: [],
            /**房源標簽列表 */
            propertyLabel: [],
            /*是否开启金币 */
            isUsedCoin: true,
            /**是否开启钻石 */
            isUsedDiamond: true,
            searchValue: {},
            /**租售价格列表 */
            salePriceList: [],
            rentPriceList: [],
            /**面积列表 */
            areaList: [],
            buildingAreaCode: '',
            saleableAreaCode: '',
            SearchPropertyRemark: '',
            propertySource:'',
            minBuildingArea: '',
            maxBuildingArea: '',
            minSaleableArea: '',
            maxSaleableArea: '',
            rentPriceCode: '',
            minRentPrice: '',
            maxRentPrice: '',
            salePriceCode: '',
            minSalePrice: '',
            maxSalePrice: '',
            topRentRecPrice:[],
            topSaleRecPrice:[],
            starRentRecPrice:[],
            starSaleRecPrice:[],
            /**排序 */
            order: '',
            showOrderBtn:false,//避免接口未返回，排序底色闪现问题
            /**是否启用相关放盘方式 */
            isUseStandard: true,
            isUseSuper: true,
            isUseStar: true,
            accountType: false,
            showAdRank: false,
            isUseBrowseStandard: true,
            isShowBrose: false,
            isUseBrowseStar: true,
            isUseBrowseSuper: true,
            isQueryCouponRange:false,
            disCopyRenew: false,
            propertyCategorySale:[],
            propertyCategoryRent:[],
            forms: {
                companyID: '',
                regionCode: '',
                gscopeCode: '',
                companyName: '',
                companyNameEN: '',
                address: '',
                addressEN: '',
                telephone: '',
                companyLicense: '',
                introduce: '',
                introduceEN: '',
                monopolyArea: '',
                monopolyAreaEN: '',
                watermark: false,
                web: '',
                logo: ''
            }
        };
    },
    async created() {
        /**获取值 */
        await this.setRouteSearchValue();
        /**传入页数 */
        if (this.$route.params.pageIndex) {
            this.pageIndex = this.$route.params.pageIndex;
        }
        /**获取代理公司类型 */
        let rescom = await this.axios.get(this.pub.getApi().GetCompanyCofig);
        if (rescom.data.code === 0 && rescom.data.result) {
            this.isDisabledPublish = rescom.data.result.isDisabledPublish;
            this.companyCategory = rescom.data.result.companyCategory;
            this.isUsedDiamond = rescom.data.result.isUsedDiamond;
            this.isUsedCoin = rescom.data.result.isUsedCoin;
            this.isUseStandard = rescom.data.result.isUseStandard;
            this.isUseSuper = rescom.data.result.isUseSuper;
            this.isUseStar = rescom.data.result.isUseStar;
            this.accountType = rescom.data.result.accountType;
            this.showAdRank = rescom.data.result.adRank;
            this.isUseBrowseStandard = rescom.data.result.isUseBrowseStandard;
            this.isUseBrowseStar = rescom.data.result.isUseBrowseStar;
            this.isUseBrowseSuper = rescom.data.result.isUseBrowseSuper;
            this.propertyCategorySale = rescom.data.result.propertyCategorySale;
            this.propertyCategoryRent = rescom.data.result.propertyCategoryRent;
            this.isQueryCouponRange = rescom.data.result.isQueryCouponRange;
            this.isOwner = rescom.data.result.isOwner;
            this.disCopyRenew = rescom.data.result.companyCategory == 1 || rescom.data.result.companyCategory == 2;
        }

        await this.pub.getDictionary().then(res => {
            this.categoryList = res.PropertyCategory.children;
            this.isAdminOffList = res.isAdminOffLine.children;
            this.isAutoRecommendList = res.IsAutoRecommend.children;
            if(res.IsPropertyUpgradeType && res.IsPropertyUpgradeType.children){
                this.isPropertyUpgradeTypeList = res.IsPropertyUpgradeType.children;
            }
            this.propertySourceList = res.PropertySource.children;
            this.rentalList = res.RentalType.children;
            /**去除置顶 */
            this.topOptions = res.TopOptions.children;
            this.AdRank = res.AdRank.children;
            this.SaleStatusList = res.SalePropertyStatus.children;
            this.RentStatusList = res.RentPropertyStatus.children;
            this.roomNumberList = res.RoomNumber.children;
            this.propertyLabel = res.PropertyLabel.children;
            this.salePriceList = res.SalePrice.children;
            this.rentPriceList = res.RentPrice.children;
            this.areaList = res.Area.children;
            this.propertyTagsList = res.PropertyTag.children;
            this.unitFloorList = res.UnitFloor.children;
            this.copyPropertyTags = res.PropertyTag.children;
            this.propertyListSort = res.PropertyListSort.children
            this.getOrder()
            // * 其他页面保留筛选条件,但tagshow会将标签置空,所以需要对楼盘标签重新赋值
            this.tagShow();
            if (this.$route.params.propertyTags) {
                this.propertyTags = this.$route.params.propertyTags;
                this.propertyTagsCascaderChange(this.propertyTags);
            }
            /**放盘状态判断 获取放盘状态列表 */
            if (this.rentalType == 1) {
                this.statusList = this.SaleStatusList;
            } else if (this.rentalType == 2) {
                this.statusList = this.RentStatusList;
            } else {
                this.statusList = [];
            }
            // /**是否开启相关楼盘 修改放盘方式 */
            if (!this.isUseSuper && this.topOptions && this.topOptions.length) {
                this.topOptions.forEach((item, index) => {
                    if (item.dictionaryValue == 1) this.topOptions.splice(index, 1);
                });
            }
            if (!this.isUseStar && this.topOptions && this.topOptions.length) {
                this.topOptions.forEach((item, index) => {
                    if (item.dictionaryValue == 3) this.topOptions.splice(index, 1);
                });
            }
            if (!this.isUseStandard && this.topOptions && this.topOptions.length) {
                this.topOptions.forEach((item, index) => {
                    if (item.dictionaryValue === '0') this.topOptions.splice(index, 1);
                });
            }
        });
        // if(localStorage.getItem("propertyIndexorder")){
        //     this.order = localStorage.getItem("propertyIndexorder")
        // }
        this.loadRouteValue();
        this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'proPageCount') || 10;
        await this.loadPropertyList(true);
        this.changeScroll(this.$route.params.scrollValue);

        this.axios
            .post(this.pub.getApi().GetAccountGuide, {
                guideType: 6
            })
            .then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.isSwitchShow = 0;
                    this.showMorePha = true;
                    if (!this.$route.params.guide) {
                        this.guidePage(true);
                        this.showMorePha = false;
                    }
                }
            });

        /**是否加载引导页*/
        if (this.$route.params.initiativeGuide) {
            this.isSwitchShow = 0;
        } else {
            /**不是手动引导获取当前模式 列表 图标模式 */
            let resource = await this.axios.post(this.pub.getApi().GetAccountResource + '?resource=propertydisplay');
            if (resource.data.code === 0 && resource.data.result) {
                this.isSwitchShow = resource.data.result.resourceValue;
            }
        }

        /**獲取顯示字段 */
        this.loadColumnsSetting('initcreated');

        /**获取登录用户信息 */
        await this.axios.get(this.pub.getApi().GetCompanyUserInfo).then(res => {
            if (res.data.code === 0 && res.data.result) {
                this.userInfo = res.data.result;
                this.renewPropertyData.remainderDiamond = this.userInfo.remainderDiamond;
                this.renewPropertyData.remainderPropertyCoin = this.userInfo.remainderPropertyCoin;
                // 水印: 总行+水印权限
                if (rescom.data.result.watermark && this.userInfo.roleID == '1') {
                    this.isWatermark = true;
                }
                if (this.accountType == true && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2)) {
                    this.getDepartmentById(this.userInfo.departmentID);
                }
                this.loadTreeDepartments();
                this.loadGetPermission();
                this.loadIsPost();
            }
        });
        // this.changeScroll(this.$route.params.scrollValue)
        /** 获取地区 */
        let resgscope = await this.axios.get(this.pub.getApi().GetGscope);
        if (resgscope.data.code === 0 && resgscope.data.result) {
            this.regionList = [];
            resgscope.data.result.forEach(item => {
                item.children.forEach(i => {
                    this.regionList.push(i);
                });
            });
            if (this.zoneCode) {
                this.gscopeList = [];
                this.regionList.forEach(item => {
                    if (item.gscopeCode === this.zoneCode) {
                        this.gscopeList = item.children;
                    }
                });
            }
            /**获取片区值 */
            if (this.$route.params.gscopeCode) this.gscopeCode = this.$route.params.gscopeCode;
        }
        /**获取字典信息 */

        /**获取跳转到当前页所带参数 */
        // this.loadRouteValue();

        if (this.$store.state.keyString != '-1') {
            // this.keyString=this.$store.state.keyString
            this.$store.commit('kongKeyString', -1);
        }
        // this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'proPageCount') || 10;
        /**获取楼盘信息 */
        // this.loadPropertyList(true);

        /**获取放盘价格 */
        this.searchPropertyPriceSet();

        this.GetFullAgentCompany('review');
    },
    mounted() {
        document.querySelector('.el-main').addEventListener('scroll', this.handleScroll);
        let stepsOth = {
            element: '.r-btn1',
            doneBtnText: '我知道了',
            closeBtnText: '關閉',
            popover: {
                className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                title: `列表字段與自訂欄目新增<br/>期數、座數、單位三個<br/>字段`
            }
        };

        setTimeout(() => {
            let steps = [];
            if ((this.userInfo.roleID == 3 || this.userInfo.roleID == 4) && this.showMorePha) {
                steps = [
                    {
                        element: '.more',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : '',
                            title: '點擊更多<br>打開更多篩選條件'
                        }
                    },
                    {
                        element: '.r-btn1',
                        doneBtnText: '下一步',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                            title: '支援自訂列表欄位'
                        },
                        onNext: () => {
                            this.$router.push({
                                name: this.pub.routeNameLists.PersonalCenter,
                                params: {
                                    guide: 1,
                                    initiativeGuide: this.$route.params.initiativeGuide
                                }
                            });
                        }
                    },
                    {
                        element: '.r-btn1',
                        doneBtnText: '我知道了',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                            title: `列表字段與自訂欄目新增<br/>期數、座數、單位三個<br/>字段`
                        }
                    }
                ];
            } else if ((this.userInfo.roleID !== 3 || this.userInfo.roleID !== 4) && this.showMorePha) {
                steps = [
                    {
                        element: '.more',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : '',
                            title: '點擊更多<br>打開更多篩選條件'
                        }
                    },
                    {
                        element: '.post-top',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                            title: '1.刊登樓盤<br>2.Mouse Over查看功能按鈕鍵用途'
                        }
                    },
                    {
                        element: '.r-btn1',
                        doneBtnText: '我知道了',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                            title: `列表字段與自訂欄目新增<br/>期數、座數、單位三個<br/>字段`
                        }
                    },
                    {
                        element: '.r-btn1',
                        doneBtnText: '下一步',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                            title: '支援自訂列表欄位'
                        },
                        onNext: () => {
                            this.$router.push({
                                name: this.pub.routeNameLists.CoinIndex,
                                params: {
                                    guide: 1,
                                    initiativeGuide: this.$route.params.initiativeGuide
                                }
                            });
                        }
                    }
                ];
            } else if (this.userInfo.roleID == 3 || this.userInfo.roleID == 4) {
                steps = [
                    {
                        element: '.more',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : '',
                            title: '點擊更多<br>打開更多篩選條件'
                        }
                    },
                    {
                        element: '.r-btn1',
                        doneBtnText: '下一步',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                            title: '支援自訂列表欄位'
                        },
                        onNext: () => {
                            this.$router.push({
                                name: this.pub.routeNameLists.PersonalCenter,
                                params: {
                                    guide: 1,
                                    initiativeGuide: this.$route.params.initiativeGuide
                                }
                            });
                        }
                    }
                ];
            } else {
                steps = [
                    {
                        element: '.more',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : '',
                            title: '點擊更多<br>打開更多篩選條件'
                        }
                    },
                    {
                        element: '.post-top',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                            title: '1.刊登樓盤<br>2.Mouse Over查看功能按鈕鍵用途'
                        }
                    },
                    {
                        element: '.r-btn1',
                        doneBtnText: '下一步',
                        closeBtnText: '關閉',
                        popover: {
                            className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                            title: '支援自訂列表欄位'
                        },
                        onNext: () => {
                            this.$router.push({
                                name: this.pub.routeNameLists.CoinIndex,
                                params: {
                                    guide: 1,
                                    initiativeGuide: this.$route.params.initiativeGuide
                                }
                            });
                        }
                    }
                ];
            }
            if (this.$route.params.guide) this.pub.guide(this.Driver, steps);
        }, 2000);
    },
    methods: {
        showUpgradeDialogStep(){
            let upPrice = this.upgradeType=='Super' ? this.propertyOrder.upgradeTypeToGoldTopSet.upgradePrice: this.propertyOrder.upgradeTypeToStarSet.upgradePrice
            if( upPrice <= 0 )return
            // 余额不足给出提示
            let diamondCount ;
            diamondCount = this.upgradeType=='Super' ? this.propertyOrder.upgradeTypeToGoldTopSet.upgradePrice: this.propertyOrder.upgradeTypeToStarSet.upgradePrice
            if(this.renewPropertyData.remainderDiamond < diamondCount){
                // this.minUpDiamond = true
                this.$message({
                    showClose: true,
                    message: '鑽石結餘不足',
                    type: 'error'
                });
                return
            }
            this.upgradeDia = false

            // 确认升级楼盘 升级为星级，是否缺失数据判断
            // • 房間數目
            // • 中文標題必須不少於8個字
            // • 上載至少3張樓盤圖片
            // • 住宅，工商厦字典输入楼层需要有
            if(
                (
                    ((this.upGradeProData.propertyCategory == 1 || this.upGradeProData.propertyCategory == 2) && !this.upGradeProData.unitFloor && this.upGradeProData.estateID) 
                    || (!this.upGradeProData.roomNumber && this.upGradeProData.propertyCategory == 1) 
                    || this.upGradeProData.images.length < 3 
                    || this.upGradeProData.titleWithCulture.length < 8
                ) 
                && this.upgradeType == 'Star'
            ){
                // 星级带弹框相关数据
                let isSaleRentDays;
                isSaleRentDays = this.upGradeProData.rentalType == 1 ? 'effectiveDays':'rentEffectiveDays'
                let isSaleRentDiamond =  this.upGradeProData.rentalType == 1 ? 'diamondSalePrice':'diamondRentPrice'
                let upgradeDate ;
                // if(this.expiredUpDate >=  this.upGradeProData.expireTime){
                //     let proUpgradetime;
                //     proUpgradetime = this.propertyPrice.Star[isSaleRentDays] * 60 * 60 * 24 * 1000 + new Date().getTime()
                //     proUpgradetime = new Date(proUpgradetime)
                //     upgradeDate = this.changeTimeFormat(proUpgradetime).split(' ')[0] + '，星級盤' + this.propertyPrice.Star[isSaleRentDays] + '天'
                // }else{
                //     upgradeDate = this.propertyOrder.upgradeTypeToStarSet.newExpireTime.substring(0, this.propertyOrder.upgradeTypeToStarSet.newExpireTime.indexOf('T'))+'，星級盤'+ this.propertyOrder.upgradeTypeToStarSet.newPriceSet[isSaleRentDays] + '天'
                // }
                upgradeDate = this.propertyOrder.upgradeTypeToStarSet.newExpireTime.substring(0, this.propertyOrder.upgradeTypeToStarSet.newExpireTime.indexOf('T'))+'，星級盤'+ this.propertyOrder.upgradeTypeToStarSet.newPriceSet[isSaleRentDays] + '天'
                sessionStorage.setItem('upgradeData', JSON.stringify({
                    targetType: this.upgradeType,
                    targetDate: upgradeDate,
                    targetPrice: this.expiredUpDate >= this.upGradeProData.expireTime 
                        ? this.propertyPrice.Star[isSaleRentDiamond] 
                        : this.propertyOrder.upgradeTypeToStarSet.upgradePrice
                }));

                //  params:{
                //      targetType:this.upgradeType,
                //     targetDate:upgradeDate,
                //     targetPrice: this.expiredUpDate >= this.upGradeProData.expireTime ? this.propertyPrice.Star[isSaleRentDiamond]: this.propertyOrder.upgradeTypeToStarSet.upgradePrice
                // },
                this.$router.push({
                    name: this.pub.routeNameLists.Post,
                    query: {
                        propertyId: this.upGradeProData.propertyID,
                        type: 'edit',
                        gradeRule: 'starValidate',
                    }
                });
            }else{
                this.axios.post(this.pub.getApi().BuyPropertyUpgradeType, {
                propertyId: this.upGradeProData.propertyID,
                targetUpTopType: this.upgradeType == 'Star' ? '3' : this.upgradeType == 'Super' ? '1' :'0'
                }).then(()=>{
                    this.upgradeDiaStep = true
                })
            }


        },
        confirmUpgrade(){
            // 调用直接升级接口
            // this.axios.post(this.pub.getApi().BuyPropertyUpgradeType, {
            //     propertyId: this.upGradeProData.propertyID,
            //     targetUpTopType: this.upgradeType == 'Star' ? '3' : this.upgradeType == 'Super' ? '1' :'0'
            // }).then(()=>{
                this.upgradeDiaStep = false
                setTimeout(() => {
                    this.upgradeType = '';
                }, 1000);
                this.loadPropertyList();
            // })

        },
        changeUpPro(type){
            this.upgradeType = type
        },
        closeErrCon(){
            this.isshowErrCon = false
        },
        upgradeDiaShow(proData){
            // 点击升级时需弹出dialog提示
            this.disCateCopyRenewDia(this.multipleChoiceDetails[0],'','','upgradeDialog')
            if(this.upbuttonClick)return
            if( this.upgraderDisMes && this.upgraderDisMes.length){          
                for (let i = 0; i < this.upgraderDisMes.length; i++) {     
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: this.upgraderDisMes[i],
                            type: 'error'
                        });
                    }, 500);               
                }
                return
            }
            // 直接楼盘升级
            /**
             * 弹出弹框 确认时 判断是否缺少星级数据 --缺少，跳转刊登。不缺少，弹出弹框
             * */ 
            this.upGradeProData = proData
            // let isSaleRent ;
            // isSaleRent = proData.rentalType == 1 ? 'diamondSalePrice' : 'diamondRentPrice'
            // 升级使用的钻石差额 或者 全额
            // if(this.nowDate >= proData.expireTime){
            //     this.upGradeSuper.upGradeExpireMoney =  this.upGradeSuper.isShowStar ? this.propertyPrice.GoldTop[isSaleRent] : ''
            //     this.upGradeStar.upGradeExpireMoney =  this.upGradeStar.isShowStar ? this.propertyPrice.Star[isSaleRent] : ''
            // }else{
            //     // 楼盘未过期 展示放盘方式之间的差额
            //     this.upGradeSuper.shortfallMoney =  this.upGradeSuper.isShowStar ? parseInt(this.propertyPrice.GoldTop[isSaleRent]) - parseInt(proData.) : ''
            //     this.upGradeStar.shortfallMoney =  this.upGradeStar.isShowStar ? parseInt(this.propertyPrice.Star[isSaleRent]) - parseInt(proData.) : ''
            // }
            this.upgradeType = this.upGradeSuper.isShowSuper ? 'Super' : 'Star'
            this.isShowRenewPromptBtn = false
            this.upgradeDia = true
        },
        getOrder(){
            this.axios.get(this.pub.getApi().GetPropertyUsersequence).then((res)=>{
                if (res.data.code === 0) {
                    if(res.data.result){
                        this.order = res.data.result
                    }else{
                        this.order = ''
                    }
                    this.changeOrder('created')
                }
                this.showOrderBtn = true
            })
        },
        changeOrder(fromType){
            let timeout;
            if(this.order == '' || !this.order){
                this.colorChanged = false;
                this.tooltipText = ''
                this.showTooltip = false
                this.showCurrentTooltip = false
                localStorage.setItem('propertyListTipShow',false)
            }else{
                this.tooltipText = this.propertyListSort.filter(item => item.dictionaryValue === this.order).map(item => item.dictionaryNameWithCulture).join(', ');;
                this.colorChanged = true
                if(fromType == 'created'){
                    if(localStorage.getItem('propertyListTipShow') == 'true'){
                        this.showTooltip = true
                        timeout = 10000
                        localStorage.setItem('propertyListTipShow',false)
                        setTimeout(() => {
                            this.showTooltip = false
                        }, timeout) // 3秒后隐藏
                    }
                }else{
                    this.showCurrentTooltip = true
                    setTimeout(() => {
                        this.showCurrentTooltip = false
                    }, 10000) // 3秒后隐藏
                }
            }
            // localStorage.setItem('propertyIndexorder',this.order)
            this.pageIndex = 1
            this.loadPropertyList()
            this.changeScroll(0);
        },
        showSourceDia(){
            if(this.isOwner && this.isFixDis){
                this.isshowSource = true 
            }else{
                return
            }
        },
        // 修改为业主盘
        updateSource(id,item){
            let updateProSource = this.updateProSource
            let sourceId = []
            if(id != '0'){
                sourceId.push(id)
                updateProSource = item.propertySource == '1' ? '2' : '1'
            }
            this.axios
                .post(this.pub.getApi().UpdatePropertySource, {
                    propertyIDs: id != '0' ? sourceId : this.propertyIdList,
                    propertySource: updateProSource,
                })
                .then(res => {
                    if(res.data.code == 0){
                        this.isshowSource = false
                        this.updateProSource = '2'
                        this.loadPropertyList();
                        this.isShowSourceSuccessId = true
                        if(res.data.result.failList && res.data.result.failList.length){
                            // 提示未成功的id 完全转为业主盘则为true
                            this.fileSourceList = res.data.result.failList
                            this.showSoureID = true
                        }else{
                            this.showSoureID = false
                        }
                        
                    }
                })
        },
        gozyCoupon(){
            this.$router.push('/property/zyCoupon');
        },
        changerental(){
            if(this.rentalType == 1){
                // 租价清空
                this.rentPriceCode = '';
                this.minRentPrice = '';
                this.maxRentPrice = '';
            }else{
                // 售价范围清空
                this.salePriceCode = '';
                this.maxSalePrice = ''
                this.maxSalePrice = ''

            }
        },
    changeRecPart(currentValue, oldValue){
        if(this.recCoinDis && this.recDiaDis){
            // 金币 钻石 符合金额置顶按钮禁用取消 
            if(currentValue*this.recDiaPrice <this.renewPropertyData.remainderDiamond){
                this.disRecTxtcoin = false
            }else if(currentValue*this.recCoinPrice <this.renewPropertyData.remainderPropertyCoin){
                this.disRecTxtDia = false
            }
            // 份数值从大至小 变化至余额够置顶时 金币钻石允许切换
            if(!this.disRecTxtDia && !this.disRecTxtcoin){
                this.twoTypeRecDis = false
            }
            // 双金币次数增加后 一种金币余额不足 则对应按钮禁用 金币余额不足
            if(currentValue*this.recCoinPrice >this.renewPropertyData.remainderPropertyCoin && currentValue*this.recDiaPrice <this.renewPropertyData.remainderDiamond){
                this.disRecDiamond = false;
                this.disRecTxtcoin = true
                this.disRecCoin = true;
                this.twoTypeRecDis = true
                this.paymentTypeRec = 3;
            }else if(currentValue*this.recCoinPrice <this.renewPropertyData.remainderPropertyCoin && currentValue*this.recDiaPrice >this.renewPropertyData.remainderDiamond ){
                this.disRecCoin = false;
                this.disRecTxtDia = true
                this.disRecDiamond = true;
                this.twoTypeRecDis = true;
                this.paymentTypeRec = 0;
            }
        }else{
            return 
        }
    },
        changeRecCoin(type) {
            if(this.twoTypeRecDis)return;
            if (type == 'coin') {
                this.paymentTypeRec = 0;
                this.disRecCoin = false;
                this.disRecDiamond = true;
            } else {
                this.paymentTypeRec = 3;
                this.disRecCoin = true;
                this.disRecDiamond = false;
            }
            // this.recommendPart =1
        },
        conBuyRecommend(){
            if(this.paymentTypeRec === '')return
            this.axios
                .post(this.pub.getApi().BuyRecommendCount, {
                    propertyID: this.recommendPro.propertyID,
                    paymentType: this.paymentTypeRec,
                    recommendCopies: this.recommendPart
                })
                .then(res => {
                    if(res.data.code == 0){
                        this.loadPropertyList();
                        this.$message({
                            showClose: true,
                            message: `已成功購買${this.recParts * this.recommendPart}次重新推前次數`,
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.isBuyRecommend=false
                })
        },
        changeTimeFormat(date){
            let y = date.getFullYear();
            let m = date.getMonth() + 1; // 月份是从0开始的
            let d = date.getDate();
            let h = date.getHours();
            let s = date.getMinutes();
            return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + '  ' + (h < 10 ? '0' + h : h) + ':' + (s < 10 ? '0' + s : s);
        },
        // 是否购买自动置顶
        isBuyAutoRec(){
            return new Promise((suc,err)=>{
                this.axios.get(this.pub.getApi().GetPropertyAutoRecommendLog,{params:{propertyId:this.autoRecPropertyID}}).then((res)=>{
                if (res.data.code === 0 && res.data.result) {
                        const recdate = new Date( res.data.result.recommendExpireTime);
                        this.autoRectimestamp =recdate.getTime();
                        this.autoRecExpireDate = res.data.result.recommendExpireTime.split('T')[0] + " " + res.data.result.recommendExpireTime.split('T')[1].split(':').slice(0, 2).join(':');
                        this.autoRecNowDate = res.data.result.createTime.split('T')[0] + " " + res.data.result.createTime.split('T')[1].split(':').slice(0, 2).join(':');
                        // this.recAutoDay = res.data.result.recommendNumber
                        this.autoRecing = true
                        this.autoRecingTxt = res.data.result.priceSetCulture
                        suc()
                    }else{
                        this.autoRecing = false
                        err()
                    }
                })
            })
        },
        goEditJournal(val){
            this.$router.push({
                name:this.pub.routeNameLists.EditJournal,
                query:{
                    propertyId:val
                }
            })
        },
        // 自動置頂
        showAutoRecDia(row,type){
            if(!this.isAutoRec)return 
            // let propertyExpiretime = ''
            // let autoRecPriceType = ''
            this.propertyExpiretime = ''
            if(type == 'autoRecTab'){
                if (!this.propertyIdList.length) {
                    this.$message({
                        showClose: true,
                        message: '請選擇要操作的樓盤',
                        type: 'warning'
                    });
                    return;
                } else if (this.propertyIdList.length !== 1) {
                    this.$message({
                        showClose: true,
                        message: '不能同時操作多個樓盤',
                        type: 'warning'
                    });
                    return
                }else{
                    // this.autoRecPropertyType =  this.propertyDetail.topType == 1?'GoldTop':'Star'
                    // autoRecPriceType =  this.propertyDetail.rentalType == 1 ? 'diamondSalePrice':'diamondRentPrice'
                    // this.autoRecNumberType = this.propertyDetail.rentalType == 1 ? 'saleRecommendNumber':'rentRecommendNumber'
                    // propertyExpiretime = this.propertyDetail.expireTime
                    this.propertyExpiretime = this.propertyDetail.expireTime
                    this.autoRecPropertyID = this.propertyIdList[0]
                }
            }else{
                // 自动置顶的下拉框选项
                // this.autoRecRentalType = row.rentalType
                // this.autoRecPropertyType = row.topType == 1?'GoldTop':'Star'
                // autoRecPriceType = row.rentalType == 1 ? 'diamondSalePrice':'diamondRentPrice'
                // this.autoRecNumberType = row.rentalType == 1 ? 'saleRecommendNumber':'rentRecommendNumber'
                // propertyExpiretime = row.expireTime
                this.propertyExpiretime = this.propertyDetail.expireTime
                this.autoRecPropertyID = row.propertyID
            }
            let proExpiretime = new Date(this.propertyExpiretime * 1000);
            this.autoProExpire = this.changeTimeFormat(proExpiretime)
            this.isBuyAutoRec().then(()=>{
                this.autoRecommendDia = true
                return
            }).catch(error=>{
                // 选中具体的方案后 进行做的处理
                this.autoRecommendDia = true
                //对下拉置顶做选中最小项处理
                this.autoListSeleted()
                // autoRectimTit：控制文案請注意, 自動置頂日期長過樓盤到期時間, 如果樓盤過期後
                // autoRecommendDia：自动置顶弹框弹出 字段
                // this.autoRectimestamp = new Date(new Date().setDate(new Date().getDate()+this.recommendPrice[this.autoRecPropertyType][this.autoRecNumberType]))
                // const recdate = new Date(this.autoRectimestamp).getTime();
                // // 自动购买 过期提示显隐
                // if(propertyExpiretime && propertyExpiretime*1000 < recdate){
                //     this.autoRectimTit = true
                // }else{
                //     this.autoRectimTit = false
                // }
                // this.recAutoDia = this.recommendPrice[this.autoRecPropertyType][autoRecPriceType]
                // this.recAutoDay = this.recommendPrice[this.autoRecPropertyType][this.autoRecNumberType]
                // let nowDate = new Date()
                // this.autoRecExpireDate = this.changeTimeFormat(this.autoRectimestamp)
                // this.autoRecNowDate = this.changeTimeFormat(nowDate)
                // this.autoRecommendDia = true
            })
        },
        // 选中置顶方案后 回显更新时间
        selAutoRecOption(item){
            this.recommendPrice = item
            // 只需要置顶时间，付款总额
            this.autoRectimestamp = new Date(new Date().setDate(new Date().getDate()+this.recommendPrice.recommendNumber))
            const recdate = new Date(this.autoRectimestamp).getTime();
            // 自动购买 过期提示显隐
            if(this.propertyExpiretime && this.propertyExpiretime*1000 < recdate){
                this.autoRectimTit = true
            }else{
                this.autoRectimTit = false
            }
            this.recAutoDia = this.recommendPrice.price
            let nowDate = new Date()
            this.autoRecExpireDate = this.changeTimeFormat(this.autoRectimestamp)
            this.autoRecNowDate = this.changeTimeFormat(nowDate)
        },
        goAutoRec(){
            this.axios
                .post(this.pub.getApi().BuyAutoRecommendDays, {
                    propertyID: this.autoRecPropertyID,
                    propertyCoinSetID:this.propertyCoinSetID,
                    paymentType: 3,
                })
                .then(res => {
                    if(res.data.code == 0){
                        this.$message({
                            showClose: true,
                            message: `已成功購買自動置頂`,
                            type: 'success'
                        });
                        this.loadPropertyList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.conRecDia=false
                    this.propertyCoinSetID = ''
                })
        },
        autoRecDiaConTime(){
            this.autoRecommendDia = false
            // 自动置顶中
            if(!this.autoRecing){
                let nowDate = new Date()
                this.autoRectimestamp = new Date(new Date().setDate(new Date().getDate()+this.recommendPrice.recommendNumber))
                this.autoRecExpireDate = this.changeTimeFormat(this.autoRectimestamp)
                this.autoRecNowDate = this.changeTimeFormat(nowDate)
                this.conRecDia= true
            }
        },
         // 购买重新推前
         async buyRecommend(data){
            if(data.topType == 0)return
            
            this.recommendPart = 1
            let proType = data.topType == 1?'GoldTop':'Star'
            let coinRs = data.rentalType == 1 ? 'enableCoinSalePrice':'enableCoinRentPrice'
            let diamondRs = data.rentalType == 1 ? 'enableDiamondSalePrice':'enableDiamondRentPrice'
            let isSaleRentDia = '';
            let isSaleRentCoin = '';
            isSaleRentDia = data.rentalType == 1 ? 'diamondSalePrice' : 'diamondRentPrice';
            isSaleRentCoin = data.rentalType == 1 ? 'coinSalePrice' : 'coinRentPrice';
            let recParts = data.rentalType == 1 ? 'saleRecommendNumber' : 'rentRecommendNumber';
            if(this.propertyRecommend[proType]){
               this.recCoinDis = this.propertyRecommend[proType][coinRs]
               this.recDiaDis = this.propertyRecommend[proType][diamondRs]
               this.recCoinPrice = this.propertyRecommend[proType][isSaleRentCoin]
               this.recDiaPrice = this.propertyRecommend[proType][isSaleRentDia]
               this.recParts = this.propertyRecommend[proType][recParts]
            }
            this.recommendPro = data
            this.judgeRecCoinDia()
            this.isBuyRecommend=true
        },

        judgeRecCoinDia(){
            // 显示金币更改
            this.disRecCoin = true;
            this.disRecDiamond = true;
            this.disRecTxtDia = false//按钮样式禁用
            this.disRecTxtcoin = false//按钮样式禁用
            // 单金币 余额不足以续期时 确认按钮禁用
            if((this.recCoinDis && !this.recDiaDis) ||(!this.recCoinDis && this.recDiaDis )){
                this.isShowRecType = false
                this.paymentTypeRec = this.recDiaDis ? 3:0
            }
           
           if(this.recCoinDis && this.recDiaDis){
            this.isShowRecType = true
            // 双金币仅有一种金币余额不足 则对应按钮禁用
            if(this.recCoinPrice >this.renewPropertyData.remainderPropertyCoin&& this.recDiaPrice <this.renewPropertyData.remainderDiamond ){
                this.disRecTxtcoin = true
                this.disRecCoin = true;
                this.disRecDiamond = false;
                this.twoTypeRecDis = true
                this.paymentTypeRec = 3;
            }else if(this.recCoinPrice <this.renewPropertyData.remainderPropertyCoin&& this.recDiaPrice >this.renewPropertyData.remainderDiamond ){
                this.disRecCoin = false;
                this.disRecTxtDia = true
                this.disRecDiamond = true;
                this.twoTypeRecDis = true;
                this.paymentTypeRec = 0;
            }else if(this.recCoinPrice >this.renewPropertyData.remainderPropertyCoin&& this.recDiaPrice >this.renewPropertyData.remainderDiamond ){
                 // 双金币都余额不足,按钮全部禁用
                this.disRecCoin = true;
                this.disRecDiamond = true;
                this.disRecTxtDia = true;
                this.disRecTxtcoin = true;
                this.twoTypeRecDis = true
                this.paymentTypeRec = '';
            }else{
                // 双金币余额都充足 默认金币
                this.disRecCoin = false;
                this.paymentTypeRec = 0;
            }
           }
        },
      
        recommendRecord(val){
            // 跳转置顶记录页
            this.$router.push({
                name: this.pub.routeNameLists.Recommend,
                query: {
                    propertyId: val
                }
            });
        },
        changeCoin(type) {
            if(this.twoTypeDis)return;
            if (type == 'coin') {
                this.paymentType = 0;
                this.disCoin = false;
                this.disDiamond = true;
            } else {
                this.paymentType = 3;
                this.disCoin = true;
                this.disDiamond = false;
            }
        },
        changeScroll(val) {
            setTimeout(() => {
                this.$nextTick(() => {
                    this.scrollValue = val;
                    document.querySelector('.el-main').scrollTop = val;
                });
            }, 1000);
        },
        judgeOldPro(type) {
            this.isShowRenewPrompt = false;
            if (this.renewResData.renewReasonList[0].propertyIDList.length == 1 && type == 'renew' && this.renewResData.renewReasonList[0].message.indexOf('因樓盤資料不完整，無法續期樓盤，須先補回填寫資料') == 0) {
                this.$router.push({
                    name: this.pub.routeNameLists.Post,
                    params: this.searchValue,
                    query: {
                        propertyId: this.renewResData.renewReasonList[0].propertyIDList[0],
                        type: 'edit',
                        editRule: 'renew',
                        rentalType: this.propertyDetail.rentalType
                    }
                });
            }
            /**重新加載列表 */
            this.loadPropertyList();
            // if(type!=='renew'){
            //     this.$router.push({
            //         name: this.pub.routeNameLists.Post,
            //         params: this.searchValue,
            //         query: {
            //             propertyId: this.propertyDetail.propertyID,
            //             type: 'edit',
            //             editRule:'payolddata',
            //             rentalType: this.propertyDetail.rentalType
            //         }
            //     });
            // }
        },
        /**页面引导 */
        guidePage(isFirst) {
            let steps = [];
            steps = [
                {
                    element: '.r-btn1',
                    doneBtnText: '我知道了',
                    closeBtnText: '關閉',
                    popover: {
                        className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'left-lpgl',
                        title: `列表字段與自訂欄目新增<br/>期數、座數、單位三個<br/>字段`
                    }
                }
            ];
            if (isFirst) {
                setTimeout(() => {
                    this.pub.guide(this.Driver, steps);
                }, 3000);
            }
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        isshowButtonselse(a, b, c) {
            if (!a) {
                this.isshowButtons(b, c);
            }
        },
        isshowButtons(item, flag) {
            // propertyIdList 前选中的所有楼盘id
            // propertyDetail 单选时选中的楼盘信息
            // fixPropertyList 单独为判断固定列展示规则定义字段
            if (!this.fixPropertyList.length) {
                this.noneFrontSel = false;
            }
            // 只允许存在一个弹出功能按钮框,当没有选中时要判断  已经要展开的楼盘相关规则
            if (flag) {
                this.propertyIdList = [];
                this.editPostDepartmentIDList = [];
                this.multipleChoiceDetails = []; //续期楼盘
                if (!this.editPostDepartmentIDList.length) {
                    this.editPostDepartmentIDList.push(item.departmentID);
                    this.editDepartmentName = item.departmentNameWithCulture;
                } else if (this.editPostDepartmentIDList[0] !== item.departmentID) {
                    this.editPostDepartmentIDList.push(item.departmentID);
                }
                this.propertyIdList.push(item.propertyID);
                this.multipleChoiceDetails.push(item);
                this.propertyDetail = item;
                this.isSelected();
                this.propertyList.forEach((it, index) => {
                    it['showButtons'] = false;
                });
            } else if (!this.propertyIdList.length && !flag) {
                this.propertyDetail = {};
            }
            this.$set(this.propertyList[item.index], 'showButtons', flag);
            this.$forceUpdate();
            // let span = document.querySelector('.popdiv');
            // const key = 'popover-' + item.propertyID;
            // this.$nextTick(() => {
            //     this.$refs[key].$refs.popper.previousSibling.style.display = 'none';
            // });
            // ?
            this.showButtons = !this.showButtons;
        },
        starNum(adRankWithCulture) {
            return adRankWithCulture == '一般' ? 1 : adRankWithCulture == '較多' ? 2 : adRankWithCulture == '優先' ? 3 : 4;
        },
        async GetFullAgentCompany(type) {
            const res = await this.axios.get(this.pub.getApi().GetFullAgentCompany);
            let { result } = res.data;
            const { data } = await this.axios.get(this.pub.getApi().SearchGscope);
            const list = data.result;
            const effect = list.find(item => {
                return item.children.find(el => {
                    return el.gscopeCode === result.gscopeCode;
                });
            });
            this.forms = result;
            this.gscopeList = effect.children;
            this.$set(this.forms, 'regionCode', effect.gscopeCode);
            if (type == 'review') {
                this.waterMark = this.forms.watermark;
            } else {
                this.$set(this.forms, 'watermark', this.waterMark);
            }
        },
        // 水印
        async storeMark() {
            this.waterVisible = false;
            await this.GetFullAgentCompany('store');
            this.axios.post(this.pub.getApi().UpdateCompanyDetail, this.forms);
        },
        rentalTags(val) {
            this.propertyTagsValue = '';
            this.propertyTags = [];
            if (this.propertyTagsList[3]) {
                if (val == 1) {
                    // 如果先选类型，后选楼盘租售
                    this.propertyTagsList[3].children = this.propertyTagsList[3].children.filter(function (item) {
                        return item.dictionaryValue != '24';
                    });
                } else if (val == 2 || val == 0) {
                    let arr = {
                        children: null,
                        dictionaryNameWithCulture: '連傢電',
                        dictionaryValue: '24',
                        itemName: 'PropertyTagInfo',
                        sequence: 2
                    };
                    let flags = false;
                    this.propertyTagsList[3].children.forEach(item => {
                        if (item.dictionaryValue == '24') {
                            flags = true;
                        }
                    });
                    if (!flags) {
                        this.propertyTagsList[3].children.push(arr);
                    }
                }
            }
        },
        tagShow() {
            ++this.isResouceShow;
            this.propertyTagsList = JSON.parse(JSON.stringify(this.copyPropertyTags));
            this.propertyTagsValue = '';
            this.propertyTags = [];
            // this.propertyTagsList=Object.assign(this.propertyTagsList,this.copyPropertyTags)
            // 住宅 无工商专用 为售无连家电
            if (this.categoryIf[0] == 1) {
                this.propertyTagsList = this.propertyTagsList.filter(function (item) {
                    return item.dictionaryValue !== '5' && item.dictionaryValue !== '6';
                });
                // 先选租售后选楼盘类型
                if (this.rentalType == 1) {
                    if (this.propertyTagsList[3]) {
                        this.propertyTagsList[3].children = this.propertyTagsList[3].children.filter(function (item) {
                            return item.dictionaryValue != '24';
                        });
                    }
                }
            }
            // 工商厦
            if (this.categoryIf[0] == 2) {
                this.propertyTagsList = this.propertyTagsList.filter(function (item) {
                    return item.dictionaryValue !== '6';
                });
                this.propertyTagsList[0].children = this.propertyTagsList[0].children.filter(function (item) {
                    return item.dictionaryValue !== '13' && item.dictionaryValue !== '8' && item.dictionaryValue !== '34' && parseInt(item.dictionaryValue) < 34;
                });
                this.propertyTagsList[3].children = this.propertyTagsList[3].children.filter(function (item) {
                    return item.dictionaryValue == 23 || item.dictionaryValue == 28;
                });
            }
            // 店铺
            if (this.categoryIf[0] == '3') {
                this.propertyTagsList = this.propertyTagsList.filter(function (item) {
                    return item.dictionaryValue == '4' || item.dictionaryValue == '3';
                });
                this.propertyTagsList[1].children = this.propertyTagsList[1].children.filter(function (item) {
                    return item.dictionaryValue == 23 || item.dictionaryValue == 28;
                });
            }
            if (this.categoryIf[0] == '4') {
                this.propertyTagsList = this.propertyTagsList.filter(function (item) {
                    return item.dictionaryValue == '6';
                });
            }
        },
        filterPeopertyTags(data, type) {
            let TagData = [];
            let TagDataList = [];
            if (type == 1) {
                TagData = this.propertyTags;
                TagDataList = this.propertyTagsList;
            } else {
                TagData = this.categoryIf;
                TagDataList = this.categoryList;
            }
            if (!data || !TagData.length) return '';
            let total = 0;

            // this.propertyTagsList[data - 1].children.forEach(item => {
            //     this.propertyTags.forEach(it => {
            //         it == item.dictionaryValue ? total++ : '';
            //     });
            // });
            // 住宅 || 工商厦
            if (this.categoryIf[0] == 1 || this.categoryIf[0] == 2) {
                TagDataList[data - 1].children.forEach(item => {
                    TagData.forEach(it => {
                        it == item.dictionaryValue ? total++ : '';
                    });
                });
            }
            // 店铺 || 车位
            if (this.categoryIf[0] == 3 || this.categoryIf[0] == 4) {
                TagDataList.forEach(item => {
                    if (item.dictionaryValue == data) {
                        item.children.forEach(ite => {
                            TagData.forEach(it => {
                                it == ite.dictionaryValue ? total++ : '';
                            });
                        });
                    }
                });
            }
            return total ? `(${total})` : '';
        },
        propertyTagsCascaderChange(data) {
            if (!data || !data.length) {
                this.propertyTagsValue = '';
                return;
            }
            this.propertyTagsValue = `樓盤標籤(已選${data.length}個標籤)`;
        },
        categoryCascaderChange(val) {
            let that = this;
            let ConversData = [];
            // 是否与上次的类型相同
            let changeFlag = false;
            let changeItem = null;
            if (this.categoryValueEnd.length == 0) {
                this.category = val;
            } else {
                // 与原数组比对
                this.category.forEach(item => {
                    if (item[0] !== this.categoryValueEnd[0][0]) {
                        // 一级标签不同
                        changeFlag = true;
                        changeItem = item;
                        ConversData.push(item);
                    } else if ((!item[2] && this.categoryValueEnd[0][2]) || (item[2] && !this.categoryValueEnd[0][2])) {
                        changeFlag = true;
                        changeItem = item;
                        // console.log('二级标签不同');
                    }
                });
            }
            if (changeFlag) {
                this.category = [];
                this.category = ConversData;
            }
            function flatten(arr) {
                while (arr.some(item => Array.isArray(item))) {
                    //如果当前数组中还有数组，则展开
                    arr = [].concat(...arr);
                }
                return arr;
            }
            this.categoryValueEnd = this.category;
            let categoryValueEnd2 = flatten(this.category);
            this.categoryIf = [...new Set(categoryValueEnd2)];
            if (!this.category || !this.category.length) {
                this.categoryValue = '';
                return;
            }
            this.categoryValue = `樓盤類型(已選${this.category.length}個標籤)`;
        },
        /**监控价格改变 */
        watchRentPrice(val) {
            if (!val) return;
            this.rentalType = '2';
            this.salePriceCode = '';
            this.minSalePrice = '';
            this.maxSalePrice = '';
        },
        watchSalePrice(val) {
            if (!val) return;
            this.rentalType = '1';
            this.rentPriceCode = '';
            this.minRentPrice = '';
            this.maxRentPrice = '';
        },
        /**获取跳转到当前页所带参数 */
        loadRouteValue() {
            
            if(this.$route.params.autoRecId)this.keyString = this.$route.params.autoRecId
            /**排序 */
            if (this.$route.params.order) this.order = this.$route.params.order;
            /**代理人 */
            if (this.$route.params.keystring) this.keyString = this.$route.params.keystring;
            /**租售類型 */
            if (this.$route.params.rentaltype) this.rentalType = this.$route.params.rentaltype + '';
            /**組別類型 */
            if (this.$route.params.departmentid) this.departmentID = this.$route.params.departmentid;
            /**放盤人id */
            if (this.$route.params.accountid) this.accountID = this.$route.params.accountid;
            /**置頂類型 */
            if (this.$route.params.topoption === 0 || this.$route.params.topoption === 1 || this.$route.params.topoption === 2 || this.$route.params.topoption === 3) {
                this.topType = this.$route.params.topoption + '';
            }
            /**已付款和未付款 */
            if (this.$route.params.paymentstatus === 0 || this.$route.params.paymentstatus === 1) {
                this.paymentStatus = this.$route.params.paymentstatus + '';
            }
            /**過期與快過期 未过期 */
            if (this.$route.params.due === 'over') {
                this.expireEndTime = new Date().getTime();
            } else if (this.$route.params.due === 'will') {
                this.expireStartTime = new Date().getTime();
                this.expireEndTime = new Date().getTime() + 5 * 24 * 60 * 60 * 1000;
            } else if (this.$route.params.due === 'notexpired') {
                this.expireStartTime = new Date().getTime();
            }
            /**accountID搜索类型 个人放盘  代理放盘 */
            if (this.$route.params.searchaccountpropertytype) {
                this.searchAccountPropertyType = this.$route.params.searchaccountpropertytype.toLowerCase();
            }
        },
        setRouteSearchValue() {
            return new Promise((resolve, rej) => {
                let _this = this.$route.params;
                this.isMoreChoose = _this.isMoreChoose;
                if (_this.pageIndex) this.pageIndex = _this.pageIndex;
                if (_this.pageCount) this.pageCount = _this.pageCount;
                /**排序 */
                if (_this.sortSale) this.sortSale = _this.sortSale;
                if (_this.sortRent) this.sortRent = _this.sortRent;
                if (_this.sortTime) this.sortTime = _this.sortTime;
                if (_this.order) this.order = _this.order;
                /**组织ID */
                if (_this.departmentID) this.departmentID = _this.departmentID;
                /**楼盘代理 */
                if (_this.searchAccountPropertyType) this.searchAccountPropertyType = _this.searchAccountPropertyType;
                /**租售类型 */
                if (_this.rentalType) this.rentalType = _this.rentalType;
                /**租售类型 */
                /**搜索 */
                if (_this.keyString) this.keyString = _this.keyString;
                /**顯示狀態 */
                if (_this.showStatus) this.showStatus = _this.showStatus;
                /**樓盤類型 */
                if (_this.category) {
                    // 将[1,6,7,8,9]转成=>[[1,6],[1,8]...]
                    this.category = _this.category;
                    let arr1 = [];
                    let arr2 = [];
                    let arr3 = [];
                    _this.category.forEach(item => {
                        if (item <= 5) {
                            arr3.push(item);
                        }
                    });

                    _this.category.forEach(item => {
                        arr2 = JSON.parse(JSON.stringify(arr3));
                        if (item > 5) {
                            arr2.push(item);
                            arr1.push(arr2);
                        }
                        arr2 = [];
                    });
                    if (_this.category.length == 1) {
                        arr1 = arr3;
                    }
                    this.categoryCascaderChange(arr1);
                }
                // if (_this.categoryIf) this.categoryIf = _this.categoryIf;
                /**付款狀態 */
                if (_this.paymentStatus) this.paymentStatus = _this.paymentStatus;
                /**地區 */
                if (_this.zoneCode) this.zoneCode = _this.zoneCode;
                /**樓市片區 */
                if (_this.gscopeCode) this.gscopeCode = _this.gscopeCode;
                /**放盤狀態 */
                if (_this.saleRentStatus) this.saleRentStatus = _this.saleRentStatus;
                if (typeof _this.isAdminOffLine == 'boolean') this.isAdminOffLine = _this.isAdminOffLine ? '1' : '0';
                if (typeof _this.isAutoRecommend == 'boolean') this.isAutoRecommend = _this.isAutoRecommend ? '1' : '0';
                if (typeof _this.isPropertyUpgradeType == 'boolean') this.isPropertyUpgradeType = _this.isPropertyUpgradeType ? '1' : '0';
                // 曝光等级 maxAdRank minAdRank
                if (_this.minAdRank || _this.maxAdRank) this.rankType = _this.minAdRank + '-' + _this.maxAdRank;
                if (_this.unitFloor) this.unitFloor = _this.unitFloor;
                /**放盤方式 */
                if (_this.topType) this.topType = _this.topType;
                /**VR */
                if (_this.propertyLabelValue) this.propertyLabelValue = _this.propertyLabelValue;
                if (_this.propertyLabelValueList && _this.propertyLabelValueList.length) this.propertyLabelValueList = _this.propertyLabelValueList;
                /**放盤時間 */
                if (_this.publicTimeStartTime) this.publicTimeStartTime = _this.publicTimeStartTime;
                if (_this.publicTimeEndTime) this.publicTimeEndTime = _this.publicTimeEndTime;
                /**到期時間 */
                if (_this.expireStartTime) this.expireStartTime = _this.expireStartTime;
                if (_this.expireEndTime) this.expireEndTime = _this.expireEndTime;
                /**建筑实用面积 */
                if (_this.buildingAreaCode) this.buildingAreaCode = _this.buildingAreaCode;
                if (_this.saleableAreaCode) this.saleableAreaCode = _this.saleableAreaCode;
                if (_this.SearchPropertyRemark) this.SearchPropertyRemark = _this.SearchPropertyRemark;
                if (_this.propertySource) this.propertySource = _this.propertySource;
                

                /**租售价 */
                if (_this.rentPriceCode) this.rentPriceCode = _this.rentPriceCode;
                if (_this.salePriceCode) this.salePriceCode = _this.salePriceCode;
                if (_this.minRentPrice) this.minRentPrice = _this.minRentPrice;
                if (_this.maxRentPrice) this.maxRentPrice = _this.maxRentPrice;
                if (_this.minSalePrice) this.minSalePrice = _this.minSalePrice;
                if (_this.maxSalePrice) this.maxSalePrice = _this.maxSalePrice;
                /**标签 */
                if (_this.propertyTags) {
                    this.propertyTags = _this.propertyTags;
                    this.propertyTagsCascaderChange(this.propertyTags);
                }
                resolve();
            });

            // 備註
            // if (_this.SearchPropertyRemark) this.SearchPropertyRemark = _this.SearchPropertyRemark;
        },
        getRouteSearchValue() {
            let value = {};
            value.isMoreChoose = this.isMoreChoose;
            if (this.pageIndex) value.pageIndex = this.pageIndex;
            if (this.pageCount) value.pageCount = this.pageCount;
            /**排序 */
            if (this.sortSale) value.sortSale = this.sortSale;
            if (this.sortRent) value.sortRent = this.sortRent;
            if (this.sortTime) value.sortTime = this.sortTime;
            if (this.order) value.order = this.order;
            /**组织ID */
            if (this.departmentID) value.departmentID = this.departmentID;
            /**楼盘代理 */
            if (this.searchAccountPropertyType) value.searchAccountPropertyType = this.searchAccountPropertyType;
            /**租售类型 */
            if (this.rentalType) value.rentalType = this.rentalType;
            /**搜索 */
            if (this.keyString) value.keyString = this.keyString;
            /**顯示狀態 */
            if (this.showStatus) value.showStatus = this.showStatus;
            /**樓盤類型 */
            // if (this.category) value.category = this.category;
            if (this.categoryIf) value.category = this.categoryIf;
            /**付款狀態 */
            if (this.paymentStatus) value.paymentStatus = this.paymentStatus;
            /**地區 */
            if (this.zoneCode) value.zoneCode = this.zoneCode;
            /**樓市片區 */
            if (this.gscopeCode) value.gscopeCode = this.gscopeCode;
            /**放盤狀態 */
            if (this.saleRentStatus) value.saleRentStatus = this.saleRentStatus;
            if (this.isAdminOffLine) value.isAdminOffLine = this.isAdminOffLine == 0 ? false : true;
            if (this.isAutoRecommend) value.isAutoRecommend = this.isAutoRecommend == 0 ? false : true;
            if (this.isPropertyUpgradeType) value.isPropertyUpgradeType = this.isPropertyUpgradeType == 0 ? false : true;
            // 曝光等级  maxAdRank minAdRank
            if (this.rankType) {
                let rank = this.rankType.split('-');
                value.minAdRank = rank[0];
                value.maxAdRank = rank[1];
            }

            if (this.unitFloor) value.unitFloor = this.unitFloor;
            /**放盤方式 */
            if (this.topType) value.topType = this.topType;
            /**VR */
            if (this.propertyLabelValue) value.propertyLabelValue = this.propertyLabelValue;
            if (this.propertyLabelValueList && this.propertyLabelValueList.length) value.propertyLabelValueList = this.propertyLabelValueList;
            /**放盤時間 */
            if (this.publicTimeStartTime) value.publicTimeStartTime = this.publicTimeStartTime;
            if (this.publicTimeEndTime) value.publicTimeEndTime = this.publicTimeEndTime;
            /**到期時間 */
            if (this.expireStartTime) value.expireStartTime = this.expireStartTime;
            if (this.expireEndTime) value.expireEndTime = this.expireEndTime;
            /**建筑实用面积 */
            if (this.buildingAreaCode) value.buildingAreaCode = this.buildingAreaCode;
            if (this.saleableAreaCode) value.saleableAreaCode = this.saleableAreaCode;
            if (this.SearchPropertyRemark) value.SearchPropertyRemark = this.SearchPropertyRemark;
            if (this.propertySource) value.propertySource = this.propertySource;
            

            /**租售价 */
            if (this.rentPriceCode) value.rentPriceCode = this.rentPriceCode;
            if (this.salePriceCode) value.salePriceCode = this.salePriceCode;
            if (this.minRentPrice) value.minRentPrice = this.minRentPrice;
            if (this.maxRentPrice) value.maxRentPrice = this.maxRentPrice;
            if (this.minSalePrice) value.minSalePrice = this.minSalePrice;
            if (this.maxSalePrice) value.maxSalePrice = this.maxSalePrice;
            /**标签 */
            if (this.propertyTags) value.propertyTags = this.propertyTags;
            this.searchValue = value;
        },
        getPorpertyOrder(id){
            return new Promise((resolve, reject) => {
                this.axios.get(this.pub.getApi().GetPropertyCapabilities, {
                    params: { propertyId: id }
                }).then(response => {
                    this.propertyOrder = response.data.result
                    // if((!this.propertyOrder.upgradeTypeToGoldTopSet && !this.propertyOrder.upgradeTypeToStarSet) || this.propertyOrder.lastSuccessPropertyOrder.paymentType == 0){
                    //     this.isShowUpgrade = false;
                    // }else{
                    //     this.isShowUpgrade = true;
                    // }
                    resolve()
                })
            })
        },
        /**获取放盘价格 */
        searchPropertyPriceSet() {
            this.axios.get(this.pub.getApi().GetCompanyPropertyPriceSet).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    res.data.result.forEach(item => {
                        this.propertyPrice[item.itemName] = item;
                    });

                }
            });

            this.axios.get(this.pub.getApi().GetCompanyPropertyRecommendPriceSet).then(res => {
                if (res.data.code === 0 && res.data.result.length) {
                    res.data.result.forEach(item => {
                        // 精选星级是否可以购买置顶推前
                        this.propertyRecommend[item.itemName] = item;
                        if(item.itemName == 'GoldTop'){
                            this.recTopPermission = true
                        }
                        if(item.itemName == 'Star'){
                            this.recStarPermission = true
                        }
                    });
                }else{
                    this.recTopPermission = false
                    this.recStarPermission = false
                }
            });

            this.axios.get(this.pub.getApi().GetCompanyPropertyAutoRecommendPriceSets).then(res => {
                // 筛选 精选-租售 星级-租售 的下拉价格
                if (res.data.code === 0 && res.data.result) {
                    this.topRentRecPrice = res.data.result.filter(item => item.itemName === 'GoldTop' && item.rentalType === 2);
                    this.topSaleRecPrice = res.data.result.filter(item => item.itemName === 'GoldTop' && item.rentalType === 1);
                    this.starRentRecPrice = res.data.result.filter(item => item.itemName === 'Star' && item.rentalType === 2);
                    this.starSaleRecPrice = res.data.result.filter(item => item.itemName === 'Star' && item.rentalType === 1);
                    // ! this.recommendPrice[item.itemName]是下拉框最终选中后的价格
                    // res.data.result.forEach(item => {
                    //     this.recommendPrice[item.itemName] = item;
                    // });

                    // 刊登勾选了自动置顶后 弹出自动置顶弹框  
                    // ! 此处补充 刊登页选中的具体选项   通过id获取当前选项配置复现
                    if(this.$route.params.autoRecId){
                        if (!this.fixPropertyList.length) {
                            this.noneFrontSel = false;
                        }
                        this.propertyDetail = this.propertyList[0];
                        this.isSelected();
                        let propertyExpiretime = ''
                        propertyExpiretime = this.propertyDetail.expireTime
                        let proExpiretime = new Date(propertyExpiretime * 1000);
                        this.autoProExpire = this.changeTimeFormat(proExpiretime)
                        // this.showAutoRecDia(this.propertyDetail)
                        this.autoRecommendDia = true
                        this.autoRecPropertyID = this.$route.params.autoRecId
                        this.isBuyAutoRec()
                    }
                }
            });
        },
        /**打开VR页面 */
        enterVr(data) {
            /**后续调整 */
            if (!data.vr.vrUrl) return;
            window.open(data.vr.vrUrl);
        },
        /**圖文排序 */
        // imgSort(data) {
        //     this.pageIndex = 1;
        //     if (data == 'sale') {
        //         this.sortRent = 0;
        //         this.sortTime = 0;
        //         if (this.sortSale == 2) {
        //             this.order = '';
        //             this.rentalType = '';
        //             this.loadPropertyList();
        //             this.sortSale = 0;
        //         } else if (this.sortSale == 0) {
        //             this.rentalType = '1';
        //             this.order = 'SalePriceASC';
        //             this.loadPropertyList();
        //             this.sortSale++;
        //         } else if (this.sortSale == 1) {
        //             this.rentalType = '1';
        //             this.order = 'SalePriceDESC';
        //             this.loadPropertyList();
        //             this.sortSale++;
        //         }
        //     }
        //     if (data == 'rent') {
        //         this.sortSale = 0;
        //         this.sortTime = 0;
        //         if (this.sortRent == 2) {
        //             this.order = '';
        //             this.rentalType = '';
        //             this.loadPropertyList();
        //             this.sortRent = 0;
        //         } else if (this.sortRent == 0) {
        //             this.rentalType = '2';
        //             this.order = 'RentPriceASC';
        //             this.loadPropertyList();
        //             this.sortRent++;
        //         } else if (this.sortRent == 1) {
        //             this.rentalType = '2';
        //             this.order = 'RentPriceDESC';
        //             this.loadPropertyList();
        //             this.sortRent++;
        //         }
        //     }
        //     if (data == 'time') {
        //         if (this.sortSale || this.sortRent) this.rentalType = '';
        //         this.sortSale = 0;
        //         this.sortRent = 0;
        //         if (this.sortTime == 2) {
        //             this.order = '';
        //             this.loadPropertyList();
        //             this.sortTime = 0;
        //         } else if (this.sortTime == 0) {
        //             this.order = 'ExpireTimeASC';
        //             this.loadPropertyList();
        //             this.sortTime++;
        //         } else if (this.sortTime == 1) {
        //             this.order = 'ExpireTimeDESC';
        //             this.loadPropertyList();
        //             this.sortTime++;
        //         }
        //     }
        // },
        /**小分类  对象转换成数据*/
        subCategory(data) {
            if (data.propertyCategory == 1 || data.propertyCategory == 5 || data.propertyCategory == 4) {
                return data.subCategory ? Object.values(data.subCategory).join('|') : '';
            }
        },
        /**点击滚动*/
        clicLeftScroll(data) {
            let left = this.$(`.${data} .el-table__body-wrapper `).scrollLeft();
            this.$(`.${data} .el-table__body-wrapper`).animate({ scrollLeft: left + 200 }, 200);
        },
        clicRightScroll(data) {
            let left = this.$(`.${data} .el-table__body-wrapper `).scrollLeft();
            if (left >= 200) {
                this.$(`.${data} .el-table__body-wrapper `).animate({ scrollLeft: left - 200 }, 200);
            } else {
                this.$(`.${data} .el-table__body-wrapper `).animate({ scrollLeft: 0 }, 200);
            }
        },
        /*入複製樓盤  并選擇租售*/
        enterCopyPost(data) {
            if (!data) return;
            if (this.propertyIdList.length !== 1) return;
            this.disCateCopyRenewDia(this.multipleChoiceDetails[0],data,'copy')
            if(this.isshowErrCon){
                this.isEnterCopy = false;
                return;
            }
            this.$router.push({
                name: this.pub.routeNameLists.Post,
                params: this.searchValue,
                query: {
                    propertyId: this.propertyIdList[0],
                    type: 'copy',
                    rentalType: data
                }
            });
        },
        /**打開複製樓盤租售選擇 */
        openCopyEnter(data) {
            if (!data ) return;
            this.isEnterCopy = true;
        },
        /*未付款链接置灰 调整*/
        isGoPlay(res) {
            if (!res.ibsNo) {
                if (this.companyCategory == 1 || this.companyCategory == 2) {
                    if (res.propertyCategory == 1 || res.propertyCategory == 2 || res.topType == 1) {
                        return false;
                    } else return true;
                } else return true;
            } else return true;
        },
        /**未付款點擊跳轉付款頁面 */
        goPlay(id, accountID, res) {
            /**新版本不允許付款 */
            if (!res.ibsNo) {
                if (this.companyCategory == 1 || this.companyCategory == 2) {
                    if (res.propertyCategory == 1 || res.propertyCategory == 2 || res.topType == 1) {
                        this.isShowPlayDialog = true;
                        return;
                    }
                }
            }
            /**未开启相关权限不允许付款 */
            if (!this.isUseStandard && res.topType === 0) {
                this.isShowDiamondPrompt = true;
                return;
            }
            if (!this.isUseSuper && res.topType === 1) {
                this.isShowDiamondPrompt = true;
                return;
            }
            if (!this.isUseStar && res.topType === 3) {
                this.isShowDiamondPrompt = true;
                return;
            }
            // /**未开启钻石不允许付款 */
            // if (!this.isUsedDiamond && (res.topType == 1 || res.topType == 3)) {
            //     this.isShowDiamondPrompt = true;
            //     return;
            // }
            // /**未开启金币不允许付款 */
            // if (!this.isUsedCoin && res.topType === 0) {
            //     this.isShowDiamondPrompt = true;
            //     return;
            // }
            if (this.userInfo.accountID !== accountID) return;
            this.$router.push({
                name: this.pub.routeNameLists.Post,
                params: this.searchValue,
                query: {
                    type: '1',
                    propertyId: id,
                    backUrl: '/property/index'
                }
            });
        },
        handleScroll() {
            this.scrollValue = document.querySelector('.el-main').scrollTop;
        },
        // 固定列判断修改按钮高亮
        isFixshowEdit() {
            const user = this.userInfo;
            this.propertyList.forEach((dtl, i) => {
                if ((dtl.accountID === this.$store.state.userInfo.accountID && dtl.departmentID === this.$store.state.userInfo.departmentID) || this.$store.state.userInfo.roleID == 2 || this.$store.state.userInfo.roleID == 1) {
                } else {
                    this.$set(this.propertyList[i], 'showEditButtons', false);
                }
                if (this.companyCategory == 1 || this.companyCategory == 2) {
                    if (dtl.propertyCategory == 1 || dtl.propertyCategory == 2) {
                        if (!dtl.ibsNo) {
                            this.$set(this.propertyList[i], 'showEditButtons', false);
                        }
                    } else if (dtl.topType == 1) {
                        if (!dtl.ibsNo) {
                            this.$set(this.propertyList[i], 'showEditButtons', false);
                        }
                    }
                }
            });
            // if (this.companyCategory == 1 || this.companyCategory == 2) {
            //     if (dtl.propertyCategory == 1 || dtl.propertyCategory == 2) {
            //         if (!dtl.ibsNo) {
            //             this.$set(this.propertyList[i], 'showEditButtons', false);
            //         }
            //     } else if (dtl.topType == 1) {
            //         if (!dtl.ibsNo) {
            //             this.$set(this.propertyList[i], 'showEditButtons', false);
            //         }
            //     }
            // }
        },
        // 接口已处理为 默认从小到大排序，所以也可以不处理
        autoListSeleted(){
            if(this.autoRecommendList.length == 1){
                this.propertyCoinSetID = this.autoRecommendList[0].id
                this.selAutoRecOption(this.autoRecommendList[0])
            }else{
                // 自动置顶默认选中价格最低的
                let minPriceObject = this.autoRecommendList.reduce((minObj, currentObj) => {
                    if (!minObj || currentObj.price < minObj.price) {
                        return currentObj;
                    }
                    return minObj;
                }, null);
                this.propertyCoinSetID = minPriceObject ? minPriceObject.id : null;
                this.selAutoRecOption(minPriceObject)
            }
        },
        /**按鈕是否置灰 */
        async isSelected() {
            const user = this.userInfo;
            const dtl = this.propertyDetail;
            await this.getPorpertyOrder(dtl.propertyID)
            // 0 标准 1精选 3星级 瀏覽及聯絡數據
            if ((dtl.topType == 0 && this.isUseBrowseStandard) || (dtl.topType == 1 && this.isUseBrowseSuper) || (dtl.topType == 3 && this.isUseBrowseStar)) {
                this.isShowBrose = true;
            } else {
                this.isShowBrose = false;
            }
            /*
                roleID: 2 分行管理员 规则:不是自己刊登的楼盘 相关按钮也要可点 || user.roleID == 1
             */
            /**複製 修改 */
            if (this.isEditPost) this.isShowEdit = true;
            if ((dtl.accountID === user.accountID && dtl.departmentID === user.departmentID) || user.roleID == 2 || user.roleID == 1) {
                this.isShowJournal = true
                // 是否允许自动置顶
                // let permitRecAutoType  = dtl.rentalType == 1 ? 'enableDiamondSalePrice' : 'enableDiamondRentPrice'
                // this.autoRecPropertyType = dtl.topType == 1?'GoldTop':'Star'
                // let autoRecPriceType = dtl.rentalType == 1 ? 'diamondSalePrice':'diamondRentPrice'
                this.autoRecommendList = [] //自动置顶筛选项下拉列表
                if( dtl.topType == 1 ){
                    this.autoRecommendList = dtl.rentalType == 1 ? this.topSaleRecPrice : this.topRentRecPrice
                }else if(dtl.topType == 3){
                    this.autoRecommendList = dtl.rentalType == 1 ? this.starSaleRecPrice : this.starRentRecPrice
                }
                if(dtl.topType !=0 && this.autoRecommendList &&  this.autoRecommendList.length){
                // if(dtl.topType !=0 && this.recommendPrice && this.recommendPrice[this.autoRecPropertyType]){
                    // this.isAutoRec = this.recommendPrice[this.autoRecPropertyType][permitRecAutoType]  操作栏按钮是否展示自动置顶 
                    // this.recAutoDia = this.recommendPrice[this.autoRecPropertyType][autoRecPriceType]
                    this.isAutoRec = true
                    this.autoListSeleted()
                }else{
                    this.isAutoRec =false
                }
                // 过期的楼盘,下架楼盘禁止自动置顶 
                if(parseInt(new Date().getTime() / 1000) > dtl.expireTime || dtl.isAdminOffLine){
                    this.isAutoRec =false
                }
                /**
                 * 楼盘升级不显示规则：
                 * 星级不显示、最后一次为金币支付方式不显示、精选，星级禁止钻石放盘不显示、升级时间过期不显示,过期楼盘可直接忽略前面规则，直接展示升级（this.expiredUpDate >= dtl.expireTime）
                 * */ 

                let ediamondRs ;
                // 注意:升级天数若>0代表开启楼盘升级。其中精选的升级天数返回在标准的saleUpEffectiveDays字段里，星级返回在精选的{}里。eg.propertyPrice.GoldTop[ediamondRs]为星级的升级是否开启
                ediamondRs = dtl.rentalType == 1 ? 'saleUpEffectiveDays':'rentUpEffectiveDays'
                this.upGradeSuper.isShowSuper = dtl.topType == '0' && this.propertyOrder.upgradeTypeToGoldTopSet ? true : false
                this.upGradeStar.isShowStar = dtl.topType !== '3' && this.propertyOrder.upgradeTypeToStarSet ? true : false
                // this.upGradeSuper.isShowSuper = dtl.topType == '0' && this.propertyPrice.Normal[ediamondRs] ? true : false
                // this.upGradeStar.isShowStar = dtl.topType !== '3' && this.propertyPrice.GoldTop[ediamondRs] ? true : false
                this.isShowUpgrade = false;
                this.isRenewUpgrade = false;
                this.isUpgradeExpire = false;
                this.upgraderDisMes = []
                // this.propertyOrder.lastSuccessPropertyOrder.paymentType !== 3 ||
                // dtl.topType === 3 ||
                if ((
                    !this.isUsedDiamond || 
                    (dtl.topType === 1 && !this.upGradeStar.isShowStar) ||
                    ( !this.upGradeStar.isShowStar && !this.upGradeSuper.isShowSuper ))
                ) {
                    // this.isShowUpgrade = false
                    console.log("false")
                }else{
                    this.isShowUpgrade = true
                }
                // 星级盘、钻石放盘、存在升级有效期且该有效期过期情况下，仍展示该按钮，但按钮禁用. 
                // !this.upGradeStar.isShowStar && !this.upGradeSuper.isShowSuper &&
                if(this.isUsedDiamond && ((dtl.topType === 3 && ((this.propertyPrice.GoldTop && this.propertyPrice.GoldTop[ediamondRs]) || (this.propertyPrice.Normal && this.propertyPrice.Normal[ediamondRs]))) || (this.propertyPrice.GoldTop && this.propertyPrice.GoldTop[ediamondRs] && dtl.topType ==1 ) || (this.propertyPrice.Normal && this.propertyPrice.Normal[ediamondRs] && dtl.topType == 0 ))){
                    const currentTimeMs = Date.now();
                    let isMessagePushed = false; 
                    if(dtl.topType == 3){
                        this.isUpgradeExpire = true
                        let str = '星級盤無法升級'
                        this.upgraderDisMes.push(str)
                        isMessagePushed = true;
                    }
                    if(this.propertyOrder.lastSuccessPropertyOrder && this.propertyOrder.lastSuccessPropertyOrder.paymentType != 3 && !isMessagePushed){
                        this.isUpgradeExpire = true
                        let str = '只限鑽石盤可升級'
                        this.upgraderDisMes.push(str) 
                        isMessagePushed = true;
                    }
                    if(dtl.topType == 1 && this.propertyOrder.lastSuccessPropertyOrder && this.propertyPrice.GoldTop && this.propertyPrice.GoldTop[ediamondRs] && !isMessagePushed){
                        const validityMs = this.propertyPrice.GoldTop[ediamondRs] * 24 * 60 * 60 * 1000;
                        const createTimeMs = this.propertyOrder.lastSuccessPropertyOrder.createTime * 1000;
                        const expireTimeMs = createTimeMs + validityMs;
                        this.isUpgradeExpire = this.isUpgradeExpire ? this.isUpgradeExpire : currentTimeMs > expireTimeMs 
                        if (currentTimeMs > expireTimeMs) {
                            let str = '過了升級限期，不能升級';
                            this.upgraderDisMes.push(str);
                            isMessagePushed = true;
                        }
                    }
                    if(dtl.topType == 0 && this.propertyOrder.lastSuccessPropertyOrder && this.propertyPrice.Normal && this.propertyPrice.Normal[ediamondRs] && !isMessagePushed){
                        const validityMs = this.propertyPrice.Normal[ediamondRs] * 24 * 60 * 60 * 1000;
                        const createTimeMs = this.propertyOrder.lastSuccessPropertyOrder.createTime * 1000;
                        const expireTimeMs = createTimeMs + validityMs;
                        this.isUpgradeExpire = this.isUpgradeExpire ? this.isUpgradeExpire : currentTimeMs > expireTimeMs 
                        if (currentTimeMs > expireTimeMs) {
                            let str = '過了升級限期，不能升級';
                            this.upgraderDisMes.push(str);
                            isMessagePushed = true;
                        }
                    }
                }
                // this.isUpgradeExpire // true 展示 且 置灰
                // this.isShowUpgrade 按钮是否展示 
                if(parseInt(new Date().getTime() / 1000) > dtl.expireTime && dtl.topType != 3 && this.isShowUpgrade){
                    // 未过期的楼盘 在续期弹框无需显示升级按钮
                    this.isRenewUpgrade = true
                    // 过期的楼盘在 楼盘类型不存在错误的情况下 无需判断金币，升级有效期等相关禁用逻辑，可直接高亮展示升级按钮。
                    // 需判断是否存在楼盘类型错误（无需弹出dialog提示）
                    this.disCateCopyRenewDia(this.multipleChoiceDetails[0],'','','upgrade')
                    if(this.upgradeDisBut){
                        this.isUpgradeExpire = true;
                    }else {
                        this.isUpgradeExpire = false;
                        // this.isShowUpgrade = true
                    }
                    this.upgraderDisMes = []
                }
                if(dtl.topType !=0 && ((this.recTopPermission && dtl.topType == 1) || (this.recStarPermission && dtl.topType == 3))){
                    this.isShowBuyRec = true
                }else{
                    this.isShowBuyRec = false
                }
                this.isCopy = true;
                this.isEdit = true;
                this.isShow = true;
                // this.isDel = true;
                if (dtl.paymentStatus) {
                    this.isRenew = true;
                    this.isSet = true;
                    this.isPay = false;

                    if (dtl.topType) this.isRecommend = true;
                }
                if (!dtl.paymentStatus) {
                    this.isRecommend = false;
                    this.isRenew = false;
                    this.isSet = false;
                    this.isPay = true;
                }
                if (!dtl.topTypeWithCulture) this.isRenew = false;
            } else {
                this.isRecommend = false;
                this. isShowBuyRec = false;
                this.isPay = false;
                this.isCopy = false;
                this.isAutoRec = false;
                this.isShowJournal = false;
                this.isEdit = false;
                this.isRenew = false;
                this.isSet = false;
                // this.isDel = false;
                this.isShow = false;
            }
            if(dtl.topType !=0 ){
                this.isShowRecRecord = true
            }else{
                this.isShowRecRecord=false;
            }
            // 重新推前次数为0 且 楼盘推前权限被关闭 推前按钮禁用
            if(!dtl.recommendNumber && !((this.recTopPermission && dtl.topType == 1) || (this.recStarPermission && dtl.topType == 3))){
                this.isRecommend = false;
            }
            // 删除按钮规则修改:仅判断 是否是管理员 及 是否是楼盘放盘人
            if ((this.adminSelf && dtl.accountID === user.accountID) || this.admin || (dtl.accountID === user.accountID && dtl.departmentID === user.departmentID)) {
                this.isDel = true;
            } else {
                this.isDel = false;
            }
            /**管理员可以修改楼盘 */
            if (this.isEditProperty) this.isEdit = true;
            /**管理员可以删除楼盘 */
            // if (this.admin && (this.nowDate >= dtl.expireTime || !dtl.paymentStatus)) this.isDel = true;
            /**中原利嘉阁 住宅工商 不允许编辑  续期 支付 隐藏复制    精选盘同理*/
            if (this.companyCategory == 1 || this.companyCategory == 2) {
                this.nowDate = parseInt(new Date().getTime() / 1000);
                /**中原利嘉阁 非住宅和工商 以及 精选盘  需到期后(利嘉阁为距离到期24h内都)可续期 */
                if (dtl.propertyCategory !== 5) {
                    if (this.companyCategory == 1) {
                        // 中原到期后
                        this.nowDate >= dtl.expireTime ? (this.isRenew = true) : ((this.isRenew = false), (this.isRenewText = true));
                    } else {
                        // 利嘉阁24h内
                        ((this.nowDate - dtl.expireTime) / (24 * 3600)) * 24 >= -24 ? (this.isRenew = true) : ((this.isRenew = false), (this.isRenewText = true));
                    }
                }
                // this.nowDate >= dtl.expireTime && dtl.propertyCategory !== 5 ? (this.isRenew = true) : ((this.isRenew = false), (this.isRenewText = true));

                if (!dtl.paymentStatus) this.isRenew = false;
                // 中原李嘉格土地--禁止复制
                dtl.propertyCategory !== 5 ? (this.isCopy = true) : (this.isCopy = false);
                if (dtl.propertyCategory == 1 || dtl.propertyCategory == 2) {
                    this.isCopy = false;
                    this.isCopyShow = false;
                    /**判断1.0 2.0数据 */
                    if (!dtl.ibsNo) {
                        this.isEdit = false;
                        this.isEditText = true;
                        this.isRenew = false;
                        if (!dtl.paymentStatus) {
                            this.isPay = false;
                            this.isPlayText = true;
                        }
                        if (dtl.paymentStatus) this.isRenewText = true;
                    }
                } else if (dtl.topType == 1) {
                    // 中原利嘉阁 精选盘不能续期
                    /**判断1.0 2.0数据 */
                    if (!dtl.ibsNo) {
                        this.isCopy = false;
                        this.isCopyShow = false;
                        this.isEdit = false;
                        this.isEditText = true;
                        this.isRenew = false;
                        if (!dtl.paymentStatus) {
                            this.isPay = false;
                            this.isPlayText = true;
                        }
                        if (dtl.paymentStatus) this.isRenewText = true;
                    }
                }
            }
            // 屋苑名称与楼盘类型不匹配 禁止续期
            let estateRenew = true;
            if (this.isRenew) {
                if (dtl.estateSrcList) {
                    for (let i = 0; i < dtl.estateSrcList.length; i++) {
                        if (dtl.estateSrcList[i] == dtl.propertyCategory) {
                            estateRenew = true;
                            break;
                        } else {
                            estateRenew = false;
                        }
                    }
                }
            }
            if (this.isRenew && !estateRenew) {
                this.isRenew = false;
            }
            // 后台禁止使用该类型楼盘此处 则此类型楼盘禁用续期
            if((!this.isUseStandard && dtl.topType == 0)||(!this.isUseSuper && dtl.topType == 1)||(!this.isUseStar && dtl.topType == 3)){
                this.isRenew = false;
            }
            // 如果是老数据 禁止付款
            if (!dtl.propertyDisPlayType) {
                this.isPay = false;
                this.btndisable = true;
            }
        },
        // 单选续期 复制 在楼盘类型禁用下弹框
        disCateCopyRenewDia(dtl,copyRentalType,type,fromType){
            this.isshowErrCon = false
            this.upgradeDisBut = false
            let category = []
            let ChildrenCategory = []
            let diaType = type == 'copy' ? copyRentalType : dtl.rentalType;
            category = diaType == 1 ?this.propertyCategorySale:this.propertyCategoryRent
            category.forEach(item => {
                if (item.dictionaryValue == dtl.propertyCategory) {
                    ChildrenCategory = item.children;
                }
            });
            //主类型中存在禁用
            let matchP = category.find((obj) =>{
                if( obj.dictionaryValue == dtl.propertyCategory && !obj.isUse){
                    return true
                }
            });
            if (matchP) {
                if(fromType != 'upgrade' && fromType != 'upgradeDialog'){
                    this.isshowErrCon = true
                }
                if( fromType == 'upgradeDialog'){
                    this.upbuttonClick = true
                }
                this.upgradeDisBut = true
            }

            // 主类型中不存在.判断子类型
            let strArr = []
            this.childCateStr = []
            if(!matchP && dtl.subCategory){
                for (const key in dtl.subCategory) {
                    let match = ChildrenCategory.find((obj) => {
                        if(obj.dictionaryValue === String(key) && !obj.isUse){
                            return true
                        }
                    });
                    if (match) {
                        strArr.push({"dictionaryValue":match.dictionaryValue,'dictionaryWithCulture':match.dictionaryNameWithCulture});
                    }
                }
                // 子类型中存在禁用
                if(strArr.length){
                    strArr.forEach((ele,index) => {
                        if(type == 'copy' && copyRentalType == 1 && ele.dictionaryValue == 19){
                            strArr.splice(index,1)
                        }
                        if(index == 0 ){
                           ele.dictionaryWithCulture = '-'+ele.dictionaryWithCulture
                        }
                        if(index == strArr.length-1 && index != 0 ){
                           ele.dictionaryWithCulture = ','+ ele.dictionaryWithCulture
                        }
                    });
                }
                if(strArr.length){
                    this.childCateStr = strArr
                    if(fromType != 'upgrade' && fromType != 'upgradeDialog'){
                        this.isshowErrCon = true
                    }
                    if( fromType == 'upgradeDialog'){
                        this.upbuttonClick = true
                    }
                    this.upgradeDisBut = true
                }
            }
        }, 
        /**新开窗口进入详情页 */
        enterDetails(type, id) {
            let url = `${this.pub.config.pcUrl}${type === 1 ? 'buy' : 'rent'}-property-${id}/`;
            window.open(url);
        },
        /** 时间选择调整*/
        expireTimeOption1(time) {
            if (this.expireStartTime) {
                return time.getTime() < this.expireStartTime;
            } else {
                return false;
            }
        },
        publicTimeOption1(time) {
            if (this.publicTimeStartTime) {
                return time.getTime() < this.publicTimeStartTime;
            } else {
                return false;
            }
        },
        expireTimeOption3(time) {
            if (this.expireEndTime) {
                return time.getTime() > this.expireEndTime;
            } else {
                return false;
            }
        },
        publicTimeOption3(time) {
            if (this.publicTimeEndTime) {
                return time.getTime() > this.publicTimeEndTime;
            } else {
                return false;
            }
        },

        /**关闭修改字段框 */
        editTextClose() {
            this.editTextList = JSON.parse(JSON.stringify(this.showTextList));
        },

        /**改变每页数据 */
        sizeChange(data) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID, 'proPageCount', data);
            this.pageCount = data;
            this.loadPropertyList();
        },
        /**獲取是否能夠放盤 */
        loadIsPost() {
            this.axios
                .get(this.pub.getApi().AllowAddProperty, {
                    params: {
                        departmentID: this.userInfo.departmentID
                    }
                })
                .then(res => {
                    if (res.data.code === 0) {
                        this.isPost = res.data.result;
                    }
                });
        },
        /**進入放盤 */
        enterPostPage(data) {
            if (!data) return;
            this.$router.push({
                name: this.pub.routeNameLists.Post,
                params: this.searchValue,
                query: {
                    rentalType: data
                }
            });
        },
        /**草稿箱判断 */
        enterDraftBox() {
            if (this.isPost) {
                this.$router.push('/property/draftbox/');
            } else {
                this.$message({
                    showClose: true,
                    message: '您的組別未關聯分行，暫時無法放盤',
                    type: 'warning'
                });
            }
        },
        enterPost() {
            if (this.isPost) {
                this.isEnterPost = true;
            } else {
                this.$message({
                    showClose: true,
                    message: '您的組別未關聯分行，暫時無法放盤',
                    type: 'warning'
                });
            }
        },
        /**是否可選 */
        isDisabled(val) {
            if (this.isAgent) return false;
            else return true;
        },
        async getDepartmentById(departmentID) {
            let res = await this.axios.get(this.pub.getApi().GetDepartmentById, {
                params: {
                    departmentID
                }
            });
            let { code } = res.data;
            if (code == 0) {
                this.renewPropertyData.remainderDiamond = res.data.result.remainderDiamond;
                this.renewPropertyData.remainderPropertyCoin = res.data.result.remainderPropertyCoin;
            }
        },
        /**楼盘续期 */
        async renewProperty(isRenew) {
            let dels = this.multipleChoiceDetails;
            if(this.multipleChoiceDetails.length == 1){
                this.disCateCopyRenewDia(dels[0])
            }
            if (!isRenew || !dels || !dels.length || this.isshowErrCon) return;
            let type = dels[0].topType;
            let rentalTypePro = dels[0].rentalType;
            /**获取多选续期时数据 */
            this.renewPropertyData.data = {};
            this.renewPropertyData.list = [];
            this.renewPropertyData.expireTime = dels[0].expireTime;
            this.renewPropertyData.topType = dels[0].topType;
            this.renewPropertyData.topTypeWithCulture = dels[0].topTypeWithCulture;
            this.renewPropertyData.remainderDiamond = this.userInfo.remainderDiamond;
            this.renewPropertyData.remainderPropertyCoin = this.userInfo.remainderPropertyCoin;
            this.renewPropertyData.money = 0;
            this.renewPropertyData.moneyCoin = 0;
            this.renewPropertyData.moneyDiamond = 0;
            this.showCoinRs = false
            this.showDiamondRs = false
            this.paymentType = ''
            if (this.accountType == true && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2)) {
                // 当分(总)行管理员且默认为公司账户时,将金币和钻石换成公司账户
                await this.getDepartmentById(this.userInfo.departmentID);
            }
            let arr = [{a:true,b:false,c:'sale'},{a:false,b:true,c:'rent'},{}]
            let flag = true;
            this.isShowPayWay = true
            let proType = type == '0' ? 'Normal' :type == '1'?'GoldTop':'Star'
           
            /**不同放盘类型不能续期 */
            dels.forEach(item => {
                this.renewPropertyData.list.push(item.propertyID);
                if (item.topType !== type) {
                    this.$confirm('多選續期功能僅適用於相同放盤方式的樓盤', '提示', {
                        confirmButtonText: '確認',
                        showCancelButton: false,
                        type: 'warning'
                    });
                    flag = false;
                }
                // 针对此种:租盘 金币开启 钻石关闭,售盘 金币关闭 钻石开启,禁止續期
                if(item.rentalType !== rentalTypePro && this.propertyPrice[proType] && (( !this.propertyPrice[proType].enableCoinSalePrice && !this.propertyPrice[proType].enableDiamondRentPrice && this.propertyPrice[proType].enableDiamondSalePrice) || (this.propertyPrice[proType].enableCoinSalePrice && !this.propertyPrice[proType].enableCoinRentPrice && !this.propertyPrice[proType].enableDiamondSalePrice) )  ){
                    this.$confirm('多選續期功能僅適用於相同付款方式的樓盤', '提示', {
                        confirmButtonText: '確認',
                        showCancelButton: false,
                        type: 'warning'
                    });
                    flag = false;
                }
                let isSaleRentDia = '';
                let isSaleRentCoin = '';
                isSaleRentDia = item.rentalType == 1 ? 'diamondSalePrice' : 'diamondRentPrice';
                isSaleRentCoin = item.rentalType == 1 ? 'coinSalePrice' : 'coinRentPrice';
                if (item.topType == 0 && this.propertyPrice.Normal) {
                    this.renewPropertyData.moneyCoin += this.propertyPrice.Normal[isSaleRentCoin];
                    this.renewPropertyData.moneyDiamond += this.propertyPrice.Normal[isSaleRentDia];
                } else if (item.topType == 1 && this.propertyPrice.GoldTop) {
                    this.renewPropertyData.moneyCoin += this.propertyPrice.GoldTop[isSaleRentCoin];
                    this.renewPropertyData.moneyDiamond += this.propertyPrice.GoldTop[isSaleRentDia];
                } else if (item.topType == 3 && this.propertyPrice.Star) {
                    this.renewPropertyData.moneyCoin += this.propertyPrice.Star[isSaleRentCoin];
                    this.renewPropertyData.moneyDiamond += this.propertyPrice.Star[isSaleRentDia];
                }
                // if (item.topType == 0) this.renewPropertyData.money += this.propertyPrice.Normal[payWay];
                // else if (item.topType == 1) this.renewPropertyData.money += this.propertyPrice.GoldTop[payWay];
                // else if (item.topType == 3 && item.rentalType == 1) this.renewPropertyData.money += this.propertyPrice.Star_Buy;
                // else if (item.topType == 3 && item.rentalType == 2) this.renewPropertyData.money += this.propertyPrice.Star_Rent;
            });
            for (let i = 0; i < dels.length; i++) {
                let coinRs = dels[i].rentalType == 1 ? 'enableCoinSalePrice':'enableCoinRentPrice'
                let diamondRs = dels[i].rentalType == 1 ? 'enableDiamondSalePrice':'enableDiamondRentPrice'
                if(this.propertyPrice[proType]){
                    this.showCoinRs = this.propertyPrice[proType][coinRs]
                    this.showDiamondRs = this.propertyPrice[proType][diamondRs]
                    // 仅开启一种货币权限时 不展示金币钻石按钮
                    if((!this.propertyPrice[proType][coinRs] && this.propertyPrice[proType][diamondRs] ) || (this.propertyPrice[proType][coinRs] && !this.propertyPrice[proType][diamondRs])){
                        this.isShowPayWay = false
                        this.paymentType = this.propertyPrice[proType][coinRs] ? 0 : 3
                        if(this.paymentType === 3 ){
                            this.showCoinRs = false
                            this.showDiamondRs = true
                        }else{
                            this.showCoinRs = true
                            this.showDiamondRs = false
                        }
                        break;
                    }
                }
            }
    
            this.unExpire = [];
            dels.forEach(item => {
                if (item.expireTime > this.nowDate) {
                    this.unExpire.push(item.propertyID);
                }
            });
            if (!flag) return;
            /**未开钻石开关 不可续期精选盘和星级盘 */
            // if (!this.isUsedDiamond && (type == 1 || type == 3)) {
            //     this.isShowDiamondPrompt = true;
            //     return;
            // }
            /**未开启相关权限不允许付款 liu */
            if (!this.isUseStandard && type == 0) {
                this.isShowDiamondPrompt = true;
                return;
            }
            if (!this.isUseSuper && type == 1) {
                this.isShowDiamondPrompt = true;
                return;
            }
            if (!this.isUseStar && type == 3) {
                this.isShowDiamondPrompt = true;
                return;
            }
            /**提示框显示 */
            if (!this.isUsedDiamond && this.isUsedCoin) {
                if (this.renewPropertyData.moneyCoin > this.renewPropertyData.remainderPropertyCoin) {
                    {
                        this.isShowRenewPromptBtn = false;
                        this.$message({
                            showClose: true,
                            message: '金幣餘額不足',
                            type: 'warning'
                        });
                        return;
                    }
                }
            } else if (this.isUsedDiamond && !this.isUsedCoin) {
                if (this.renewPropertyData.moneyDiamond > this.renewPropertyData.remainderDiamond) {
                    this.isShowRenewPromptBtn = false;
                    this.$message({
                        showClose: true,
                        message: '鑽石餘額不足',
                        type: 'warning'
                    });
                    return;
                }
            }
            
            this.disCoin = true;
            this.disDiamond = true;
            this.twoTypeDis = false
            this.disTxtDia = false//按钮样式禁用
            this.disTxtcoin = false//按钮样式禁用
            // 单金币 余额不足以续期时 确认按钮禁用
            if(!this.isShowPayWay && ((this.showCoinRs && !this.showDiamondRs && this.renewPropertyData.moneyCoin > this.renewPropertyData.remainderPropertyCoin) || (!this.showCoinRs && this.showDiamondRs && this.renewPropertyData.moneyDiamond > this.renewPropertyData.remainderDiamond))){
                this.paymentType = ''
            }
            // 双金币都余额不足,按钮全部禁用
            if (this.isShowPayWay &&  this.paymentType === '' && this.renewPropertyData.moneyDiamond > this.renewPropertyData.remainderDiamond  && this.renewPropertyData.moneyCoin > this.renewPropertyData.remainderPropertyCoin) {
                this.disCoin = true
                this.disDiamond = true
                this.twoTypeDis = true
                this.disTxtDia = true
                this.disTxtcoin = true
            }
            // 双金币仅有一种金币余额不足 则对应按钮禁用
            if(this.isShowPayWay && ((this.renewPropertyData.moneyDiamond > this.renewPropertyData.remainderDiamond && this.renewPropertyData.moneyCoin < this.renewPropertyData.remainderPropertyCoin)||(this.renewPropertyData.moneyDiamond < this.renewPropertyData.remainderDiamond && this.renewPropertyData.moneyCoin > this.renewPropertyData.remainderPropertyCoin))){
                this.twoTypeDis = true
                if(this.renewPropertyData.moneyDiamond < this.renewPropertyData.remainderDiamond){
                    this.paymentType = 3
                    this.disCoin = true
                    this.disDiamond = false
                    this.disTxtcoin = true
                }else if(this.renewPropertyData.moneyCoin < this.renewPropertyData.remainderPropertyCoin){
                    this.paymentType = 0
                    this.disCoin = false
                    this.disDiamond = true
                    this.disTxtDia = true
                }
            }
            
            this.isShowRenewPromptBtn = true;
            // 单选续期 楼盘续期有效期数
            if(this.multipleChoiceDetails.length == 1){
                this.norEffectiveDays = this.getRenewTime()
            }
        },
        getRenewTime(){
            let isSaleRent = '';
            isSaleRent = this.multipleChoiceDetails[0].rentalType == 1 ? 'effectiveDays' : 'rentEffectiveDays';
            let time = this.renewPropertyData.topType == '1' && this.propertyPrice.GoldTop ? this.propertyPrice.GoldTop[isSaleRent] : this.renewPropertyData.topType == '3' && this.propertyPrice.Star ? this.propertyPrice.Star[isSaleRent] : this.propertyPrice.Normal? this.propertyPrice.Normal[isSaleRent]:'';
            return time* 60 * 60 * 24
        },
        submitRenewProperty() {
            /**批量续期 */
            this.axios
                .post(this.pub.getApi().RenewProperty, {
                    propertyID: this.renewPropertyData.list,
                    paymentType: this.paymentType
                })
                .then(res => {
                    if (res.data.code == 0 && res.data.result) {
                        this.isShowRenewPromptBtn = false;
                        this.renewResData = res.data.result;
                        /**需要判断调整 */
                        this.isShowRenewPrompt = true;
                        /**重新加載列表 */
                        // this.loadPropertyList();
                        /**重新获取个人信息 */
                        this.axios.get(this.pub.getApi().GetCompanyUserInfo).then(res => {
                            if (res.data.code === 0 && res.data.result) this.userInfo = res.data.result;
                        });
                    }
                });
        },
        /**操作跳转 */
        async operatingEnter(type, data, idlistData) {
            if (idlistData) {
                this.propertyIdList = [];
                this.propertyIdList.push(idlistData.propertyID);
            }

            let dtl = this.propertyDetail;
            if (type == '1') {
                if (this.isPlayText) {
                    this.isShowPlayDialog = true;
                    return;
                }
            }

            /**type == 1 付款 */
            if (type == '1') {
                /** 根据是否能够使用相关放盘方式 */
                if (!this.isUseStandard && dtl.topType === 0) {
                    this.isShowDiamondPrompt = true;
                    return;
                }
                if (!this.isUseSuper && dtl.topType === 1) {
                    this.isShowDiamondPrompt = true;
                    return;
                }
                if (!this.isUseStar && dtl.topType === 3) {
                    this.isShowDiamondPrompt = true;
                    return;
                }
            }
            // /**根据是否能够使用金币钻石判断 付款 */
            // if (type == '1' && !this.isUsedDiamond && (dtl.topType == 1 || dtl.topType == 3)) {
            //     this.isShowDiamondPrompt = true;
            //     return;
            // }
            // if (type == '1' && !this.isUsedCoin && dtl.topType === 0) {
            //     this.isShowDiamondPrompt = true;
            //     return;
            // }
            // if (type == '2' && !this.isUsedDiamond && (dtl.topType == 1 || dtl.topType == 3)) {
            //     this.isShowDiamondPrompt = true;
            //     return;
            // }
            if (!data) return;
            if (!this.propertyIdList.length) {
                this.$message({
                    showClose: true,
                    message: '請選擇要操作的樓盤',
                    type: 'warning'
                });
                return;
            } else if (this.propertyIdList.length !== 1) {
                this.$message({
                    showClose: true,
                    message: '不能同時操作多個樓盤',
                    type: 'warning'
                });
            } else {
                if (type == '2') {
                    if (dtl.renewalNumber < 1 || dtl.expireTime < new Date() / 1000) {
                        /**跳轉頁面 */
                        this.$router.push({
                            name: this.pub.routeNameLists.Post,
                            params: this.searchValue,
                            query: {
                                propertyId: this.propertyIdList[0],
                                type: type,
                                pageIndex: this.pageIndex
                            }
                        });
                    } else {
                        /**在有效期內，最多續期3次 */
                        this.$confirm('已達續期上限<br>在有效期內樓盤最多續期1次', '提示', {
                            confirmButtonText: '確認',
                            dangerouslyUseHTMLString: true,
                            showCancelButton: false,
                            type: 'warning'
                        }).then();
                    }
                } else {
                    this.searchValue.scrollValue = this.handleScrollAll();
                    this.$router.push({
                        name: this.pub.routeNameLists.Post,
                        params: this.searchValue,
                        query: {
                            propertyId: this.propertyIdList[0],
                            type: type,
                            pageIndex: this.pageIndex
                        }
                    });
                }
            }
        },
        handleScrollAll() {
            return document.querySelector('.el-main').scrollTop;
        },
        /**获取权限列表 */
        loadGetPermission() {
            this.axios
                .post(this.pub.getApi().GetPermissionByRoleId, {
                    roleID: this.userInfo.roleID
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        res.data.result.forEach(item => {
                            /**是否能够修改放盘人 */
                            if (item.permissionsCode === 'Property_PropertyManage_Modif_All') {
                                this.isEditPost = true;
                                this.isEditProperty = true;
                            } else if (
                                /**是否是超级管理员 */
                                item.permissionsCode === 'Property_PropertyManage_Manager_All'
                            ) {
                                this.admin = true;
                                this.isDepartment = true;
                                this.isAgent = false;
                            } else if (item.permissionsCode === 'Property_PropertyManage_ExamineList_All') {
                                this.isDepartment = true;
                            } else if (item.permissionsCode === 'Property_PropertyManage_Manager_MySelf') {
                                this.adminSelf = true;
                                this.isAgent = false;
                            }
                        });
                    }
                });
        },
        /**获取组织 */
        loadTreeDepartments() {
            this.axios
                .get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                    params: { departmentID: this.userInfo.departmentID }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.departmentList.push(res.data.result);
                    }
                });
        },
        // * 水印
        waterClose() {
            this.waterMark = false;
            this.waterVisible = false;
        },
        /**获取列表 */
        async loadPropertyList(first) {
            /*关闭置顶对话框*/
            this.isShowRecommend = false;
            const data = this.getSearchValue();
            /**加载列表 */
            await this.axios.post(this.pub.getApi().SearchPropertyList, data).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    /**重置选择 */
                    this.propertyIdList = [];
                    this.fixPropertyList = [];
                    this.propertyList = res.data.result.data;
                    this.propertyList.forEach((it, index) => {
                        it['showButtons'] = false;
                        it['isFixDisOth'] = false; //当选中一个时,其他数据按钮禁用
                        it['showEditButtons'] = true; //固定列按钮高亮
                    });

                    this.count = res.data.result.count;
                    if (first) this.firstLoading = false;
                    /**记录搜索值 */
                    this.getRouteSearchValue();
                    this.isFixshowEdit();
                } else if (res.data.code === 1209) {
                    /**个人放盘代理盘调整 */
                    this.$message({
                        showClose: true,
                        message: '請選擇當前登錄組別進行篩選個人代理盤',
                        type: 'warning'
                    });
                } else if (res.data.code === 1210) {
                    this.$message({
                        showClose: true,
                        message: '請選擇當前登錄組別進行篩選個人放盤',
                        type: 'warning'
                    });
                }
            });
        },
        /**數據翻頁 */
        currentChange(pageIndex) {
            this.pageIndex = pageIndex;
            this.loadPropertyList();
        },
        /**转换搜索条件 */
        getSearchValue() {
            const data = {};
            data.pageIndex = this.pageIndex;
            data.pageCount = this.pageCount;
            if (this.order) data.order = this.order;
            if (this.departmentID) data.departmentID = this.departmentID;
            if (this.regionCode) data.regionCode = this.regionCode;
            if (this.gscopeCode) data.gscopeCode = this.gscopeCode;
            if (this.zoneCode) data.zoneCode = this.zoneCode;
            // 消息中心跳转置顶跳转的keystring是number类型
            if (typeof this.keyString == 'number') {
                this.keyString = String(this.keyString);
            }
            if (this.SearchPropertyRemark) {
                if (this.SearchPropertyRemark == '1') {
                    data.SearchPropertyRemark = true;
                } else {
                    data.SearchPropertyRemark = false;
                }
            }
            if (this.propertySource) data.propertySource = this.propertySource;
            if (this.keyString) data.keyString = this.keyString.trim();
            if (this.paymentStatus) data.paymentStatus = this.paymentStatus;
            if (this.estateName) data.estateName = this.estateName;
            if (this.rentalType) data.rentalType = +this.rentalType;
            if (this.topType) data.topType = +this.topType;
            if (this.showStatus) data.isHide = this.showStatus - 1;
            if (this.saleRentStatus) data.propertyStatus = this.saleRentStatus;
            if (this.isAdminOffLine) data.isAdminOffLine = this.isAdminOffLine == 0 ? false : true;
            if (this.isAutoRecommend) data.isAutoRecommend = this.isAutoRecommend == 0 ? false : true;
            if (this.isPropertyUpgradeType) data.isPropertyUpgradeType = this.isPropertyUpgradeType == 0 ? false : true;
            if (this.rankType) {
                let rank = this.rankType.split('-');
                data.minAdRank = parseInt(rank[0]);
                data.maxAdRank = parseInt(rank[1]);
            }
            if (this.unitFloor) data.unitFloor = this.unitFloor;
            /**楼盘类型全部category 为  '0'  */
            // if (+this.categoryIf.length  > 1) data.category = this.categoryIf[0];
            this.categoryList.forEach(item => {
                if (item.itemName == this.categoryIf[0]) {
                    if (item.children != null) {
                        // 二级筛选
                        if (item.children.length != this.categoryIf.length - 1 && this.categoryIf.length > 1) data.SubCategory = this.categoryIf.slice(1);
                        // 一级分类
                        if (item.children.length == this.categoryIf.length - 1) data.category = this.categoryIf[0];
                    } else {
                        data.category = this.categoryIf[0];
                    }
                }
            });
            if (this.expireStartTime) data.expireStartTime = parseInt(this.expireStartTime / 1000);
            /**过期时间 */
            if (this.expireEndTime) {
                if (this.$route.params.due) data.expireEndTime = parseInt(this.expireEndTime / 1000);
                else data.expireEndTime = parseInt(this.expireEndTime / 1000 + 24 * 60 * 60);
            }
            if (this.publicTimeStartTime) data.publicTimeStartTime = parseInt(this.publicTimeStartTime / 1000);
            /**放盘时间 */
            if (this.publicTimeEndTime) {
                if (this.$route.params.due) data.publicTimeEndTime = parseInt(this.publicTimeEndTime / 1000);
                else data.publicTimeEndTime = parseInt(this.publicTimeEndTime / 1000 + 24 * 60 * 60);
            }
            if (this.accountName) data.accountName = this.accountName;
            if (this.accountID) data.accountID = this.accountID;
            if (this.searchAccountPropertyType) data.searchAccountPropertyType = this.searchAccountPropertyType;
            if (this.roomNumber) data.roomNumber = +this.roomNumber;
            /**是否VR */
            if (this.propertyLabelValue) data.propertyLabelValue = +this.propertyLabelValue;
            if (this.propertyLabelValueList && this.propertyLabelValueList.length) data.propertyLabelValueList = this.propertyLabelValueList;
            /**租售面积 */
            /**建筑实用面积 */
            if (this.buildingAreaCode) {
                data.minBuildingArea = this.buildingAreaCode.split('-')[0];
                data.maxBuildingArea = this.buildingAreaCode.split('-')[1];
            }
            if (this.saleableAreaCode) {
                data.minSaleableArea = this.saleableAreaCode.split('-')[0];
                data.maxSaleableArea = this.saleableAreaCode.split('-')[1];
            }

            /**租售价格*/
            if (this.rentPriceCode) {
                data.minRentPrice = this.rentPriceCode.split('-')[0];
                data.maxRentPrice = this.rentPriceCode.split('-')[1];
            }
            if (this.salePriceCode) {
                data.minSalePrice = this.salePriceCode.split('-')[0];
                data.maxSalePrice = this.salePriceCode.split('-')[1];
            }
            if (this.minRentPrice) data.minRentPrice = this.minRentPrice;
            if (this.maxRentPrice) data.maxRentPrice = this.maxRentPrice;
            if (this.minSalePrice) data.minSalePrice = this.minSalePrice * 10000;
            if (this.maxSalePrice) data.maxSalePrice = this.maxSalePrice * 10000;
            if (this.propertyTags) data.propertyTags = this.propertyTags;
            return data;
        },
        /**點擊搜索 */
        clickSearch() {
            this.pageIndex = 1;
            this.loadPropertyList();
        },
        /**重置搜索 */
        resetSearch() {
            this.sortSale = 0;
            this.sortRent = 0;
            this.sortTime = 0;
            this.order = '';
            this.zoneCode = '';
            this.regionCode = '';
            this.gscopeCode = '';
            this.estateName = '';
            this.rentalType = '';
            this.topType = '';
            this.showStatus = '';
            this.saleRentStatus = '';
            this.isAdminOffLine = '';
            this.isAutoRecommend = ''
            this.isPropertyUpgradeType = ''
            this.rankType = '';
            this.unitFloor = '';
            this.expireStartTime = '';
            this.expireEndTime = '';
            this.publicTimeStartTime = '';
            this.publicTimeEndTime = '';
            this.departmentID = '';
            this.accountName = '';
            this.roomNumber = '';
            this.category = '';
            this.categoryIf = '';
            this.keyString = '';
            this.paymentStatus = '';
            this.accountID = '';
            this.searchAccountPropertyType = '';
            this.propertyLabelValue = '';
            this.propertyLabelValueList = '';
            this.buildingAreaCode = '';
            this.saleableAreaCode = '';
            this.SearchPropertyRemark = '';
            this.propertySource = ''
            this.rentPriceCode = '';
            this.salePriceCode = '';
            this.minRentPrice = '';
            this.maxRentPrice = '';
            this.minSalePrice = '';
            this.maxSalePrice = '';
            this.propertyTags = [];
            this.propertyTagsValue = '';
            this.categoryValue = '';
            this.colorChanged = false
            this.clickSearch();
        },
        /**修改放盘人 */
        editPostUserShow() {
            if (!this.isShowEdit) return;
            if (!this.isEditPost) return;
            /**重置放盤人選擇 */
            this.editAccountID = '';
            if (this.editPostDepartmentIDList.length >= 2) {
                this.$message({
                    showClose: true,
                    message: '只能選擇同組別樓盤',
                    type: 'warning'
                });
                return;
            }
            if (!this.propertyIdList.length) {
                this.$message({
                    showClose: true,
                    message: '請選擇要操作的樓盤',
                    type: 'warning'
                });
                return;
            }
            this.isEditPostUser = true;
            this.loadMarketParticipantsUser();
        },
        loadMarketParticipantsUser() {
            if (this.editPostDepartmentIDList.length) {
                this.axios
                    .post(this.pub.getApi().SearchMarketParticipantsUser, {
                        departmentID: this.editPostDepartmentIDList[0]
                    })
                    .then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            this.editPostUserList = res.data.result;
                        }
                    });
            }
        },
        /**修改放盘人 */
        editPostUser() {
            if (!this.editAccountID) {
                this.$message({
                    showClose: true,
                    message: '請選擇放盤人',
                    type: 'warning'
                });
                return;
            }
            this.axios
                .post(this.pub.getApi().UpdatePropertyOwner, {
                    propertyIDs: this.propertyIdList,
                    accountID: this.editAccountID,
                    departmentID: this.editPostDepartmentIDList[0]
                })
                .then(res => {
                    let name = '';
                    if (res.data.code === 0 && res.data.result) {
                        this.isEditPostUser = false;
                        this.editPostUserList.forEach(item => {
                            if (item.accountID == this.editAccountID) {
                                name = item.name;
                            }
                        });
                        this.$message({
                            showClose: true,
                            message: `您將修改${this.propertyIdList.length}個樓盤放盤人為${this.editDepartmentName},${name}`,
                            type: 'success'
                        });
                        this.loadPropertyList();
                    } else {
                        this.isEditPostUser = false;
                        this.$message({
                            showClose: true,
                            message: '修改失败,请重试',
                            type: 'error'
                        });
                    }
                });
        },
        // 水印开关
        watermark() {
            if (!this.isWatermark) return;
            if (!this.forms.watermark) {
                this.waterMark = false;
            }
            this.waterVisible = true;
        },
       
        /**重新推前 */
        recommend(isRecommend, val) {
            if(val && val.recommendNumber == 0 && ((this.recTopPermission && val.topType == 1) || (this.recStarPermission && val.topType == 3))){
                this.$confirm('可重新推前次數：0<br/>確定要購買重新推前次數嗎？', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                })
                .then(()=>{
                    this.buyRecommend(val)
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        type: 'warning',
                        message: '已取消操作'
                    });
                });
                return
            }
            // 多个楼盘重新置顶
            if (!this.isRecommend) return;
            // 置顶接口分为两个,一个为多个楼盘置顶,一个为单个置顶
            this.$confirm('確認要重新推前嗎', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    if (this.recommendDetail.length > 1) {
                        this.axios
                            .post(this.pub.getApi().BathRefreshProperty, {
                                propertyIDList: this.propertyIdList
                            })
                            .then(res => {
                                if (res.data.code === 0 && res.data.result) {
                                    let fail = res.data.result.failList.toString();
                                    let suc = res.data.result.successList.toString();
                                    let sucleng = res.data.result.successList;
                                    let failleng = res.data.result.failList;
                                    if (sucleng.length != 0 && failleng.length != 0) {
                                        this.$alert(`成功重新推前樓盤，共${sucleng.length}個 <br/> 樓盤編號：<br/>${suc}<br/>因重新推前次數不足，無法重新推前，共${failleng.length}個<br/>樓盤編號：<br/>${fail}`, '重新推前', { confirmButtonText: '確認', dangerouslyUseHTMLString: true });
                                    } else if (sucleng.length == 0 && failleng.length != 0) {
                                        this.$alert(`因重新推前次數不足，無法重新推前，共${failleng.length}個<br/>樓盤編號：<br/>${fail}`, '重新推前', { confirmButtonText: '確認', dangerouslyUseHTMLString: true });
                                    } else {
                                        this.$alert(`成功重新推前樓盤，共${sucleng.length}個 <br/> 樓盤編號：<br/>${suc}`, '重新推前', { confirmButtonText: '確認', dangerouslyUseHTMLString: true });
                                    }
                                    this.loadPropertyList();
                                }
                            });
                    } else {
                        // 此樓盤無置頂次數
                        this.axios
                            .get(this.pub.getApi().RefreshPropertyAndRecommendById, {
                                params: {
                                    propertyId: this.propertyIdList[0]
                                }
                            })
                            .then(res => {
                                if (res.data.code === 0 && res.data.result) {
                                    if (this.propertyDetail.topType === 3 || this.propertyDetail.topType === 1) this.isShowRecommend = true;
                                    else
                                        this.$message({
                                            showClose: true,
                                            message: '置頂成功',
                                            type: 'success'
                                        });
                                    this.loadPropertyList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: '修改失敗，請重試',
                                        type: 'error'
                                    });
                                }
                            });
                    }
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        type: 'warning',
                        message: '已取消操作'
                    });
                });
        },
        /**楼盘显示隐藏 */
        propertyShow(data) {
            if (!this.isShow) return;
            if (!this.propertyIdList.length) {
                this.$message({
                    showClose: true,
                    message: '請選擇要操作的樓盤',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('確認要修改樓盤狀態嗎', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    /**过滤自己的楼盘 */
                    let list = [];
                    this.propertyList.forEach(item => {
                        this.propertyIdList.forEach(it => {
                            // 分行管理员身份需要传入propertyidlist
                            if (item.propertyID == it && (this.userInfo.accountID == item.accountID || this.userInfo.roleID == 2 || this.userInfo.roleID == 1)) {
                                list.push(it);
                            }
                        });
                    });
                    this.axios
                        .post(this.pub.getApi().UpdatePropertyShowStatus, {
                            propertyIdList: list,
                            isHide: data
                        })
                        .then(res => {
                            if (res.data.code === 0 && res.data.result) {
                                this.loadPropertyList();
                                this.$message({
                                    showClose: true,
                                    message: '修改成功',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: '修改失敗，請重試',
                                    type: 'error'
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        type: 'warning',
                        message: '已取消操作'
                    });
                });
        },
        loadColumnsSetting(isInit) {
            /**獲取字段列表 */
            this.axios.get(this.pub.getApi().PropertyColumnsSetting).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.isShowText = false;
                    /**调整字段修改后 不重新渲染页面问题 */
                    this.$nextTick(function () {
                        this.isShowText = true;
                        this.showTextList = res.data.result;
                        this.editTextList = JSON.parse(JSON.stringify(res.data.result));
                        if (isInit == 'initcreated') {
                            this.editText(isInit);
                        }
                    });
                }
            });
        },
        /**修改顯示字段 */
        editShow() {
            this.isEditTextShow = true;
        },
        /**修改顯示字段 */
        editText(isInit) {
            const data = [];
            this.editTextList.forEach((item, index) => {
                if (item.isDefault) {
                    const value = {
                        columnID: item.columnID,
                        sequence: data.length + 1
                    };
                    data.push(value);
                }
            });
            if (!data.length && isInit !== 'initcreated') {
                this.$message({
                    showClose: true,
                    message: '請至少選擇一項顯示字段',
                    type: 'warning'
                });
                return;
            }
            this.axios
                .post(this.pub.getApi().PropertyColumnsSettingExt, {
                    propertyColumns: data
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.isEditTextShow = false;
                        if (isInit !== 'initcreated') {
                            this.$message({
                                showClose: true,
                                message: '修改成功',
                                type: 'success'
                            });
                        }
                        this.loadColumnsSetting();
                    }
                });
        },
        viewData(data) {
            if (!this.isShowBrose) return;
            this.$router.push({
                name: this.pub.routeNameLists.BroseDaTa,
                query: {
                    propertyId: data
                }
            });
        },
        /** 修改楼盘弹窗点击显示*/
        editPropertyStatusShow(data) {
            if (!data) return;
            if (!this.propertyIdList.length) {
                this.$message({
                    showClose: true,
                    message: '請選擇要操作的樓盤',
                    type: 'warning'
                });
                return;
            } else if (this.propertyIdList.length !== 1) {
                this.$message({
                    showClose: true,
                    message: '不能同時操作多個樓盤',
                    type: 'warning'
                });
            } else {
                this.propertyList.forEach(item => {
                    if (item.propertyID === this.propertyIdList[0]) {
                        this.propertyStatus = '' + item.propertyStatus;
                        this.editStatusForm.propertyID = item.propertyID;
                        this.editStatusForm.rentalType = item.rentalType;
                        this.isEditPropertyStatus = true;
                    }
                });
            }
        },
        /**修改楼盘显示状态 */
        editPropertyStatus() {
            this.axios
                .get(this.pub.getApi().UpdatePropertyStatus, {
                    params: {
                        propertyId: this.editStatusForm.propertyID,
                        propertyStatus: this.propertyStatus
                    }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.isEditPropertyStatus = false;
                        this.loadPropertyList();
                        this.$message({
                            showClose: true,
                            message: '修改成功',
                            type: 'success'
                        });
                        /**重新加载刷剧 */
                    } else {
                        this.$message({
                            showClose: true,
                            message: '修改失敗，請重試',
                            type: 'error'
                        });
                    }
                });
        },
        /**切換展示  圖文--列表*/
        switchShow(data) {
            this.isSwitchShow = data;
            this.axios.post(this.pub.getApi().SetAccountResources, {
                resource: 'propertydisplay',
                resourceValue: data
            });
            if (this.isSwitchShow) {
                this.$refs.textMultipleTable.clearSelection();
            } else {
                this.$refs.imgMultipleTable.clearSelection();
            }
            let val = [];
            this.handleSelectionChange(val);
        },
        /**分頁 調整每頁數量 */
        pageCountChange() {
            const _this = this;
            clearTimeout(this.timeId);
            this.timeId = setTimeout(function () {
                _this.loadPropertyList();
            }, 1000);
        },
        /**多选 */
        handleSelectionChange(val) {
            // 当前有选中操作,固定列展开需要关闭
            this.propertyList.forEach((it, index) => {
                it['showButtons'] = false;
            });
            // 通过判断'前'是否选中,来判断横功能按钮是否高亮
            if (!val.length) {
                this.noneFrontSel = false;
            } else {
                this.noneFrontSel = true;
            }
            /**多选参数楼盘参数 */
            this.multipleChoiceDetails = val;

            /**
             * propertyIdList 前选中的所有楼盘id
             * propertyDetail 单选时选中的楼盘信息
             * */
            /**按钮置灰 显示 */
            this.propertyDetail = {};
            this.isRecommend = false;
            this.isCopy = false;
            this.isAutoRec = false;
            this.isShowJournal = false
            this.isEdit = false;
            this.isRenew = false;
            this.isPay = false;
            this.isSet = false;
            this.isDel = false;
            this.isShow = false;
            this.isShowEdit = false;
            this.isEditText = false;
            this.isCopyShow = true;
            this.isRenewText = false;
            this.isPlayText = false;
            this.fixPropertyList = [];
            this.propertyIdList = []; //被选中的楼盘的楼盘id
            //注： propertyList：每页显示的楼盘数据
            this.editPostDepartmentIDList = [];
            if (!val.length) return;

            val.forEach(item => {
                if (!this.editPostDepartmentIDList.length) {
                    this.editPostDepartmentIDList.push(item.departmentID);
                    this.editDepartmentName = item.departmentNameWithCulture;
                } else if (this.editPostDepartmentIDList[0] !== item.departmentID) {
                    this.editPostDepartmentIDList.push(item.departmentID);
                }
                this.propertyIdList.push(item.propertyID);
                this.fixPropertyList.push(item.propertyID);
            });

            // 固定列功能按钮是否可选重新置为false
            this.propertyList.forEach((item, i) => {
                if (item['isFixDisOth']) {
                    item['isFixDisOth'] = false;
                }
            });
            // 页面中仅选中一个楼盘时
            if (this.propertyIdList.length === 1) {
                this.propertyList.forEach((item, i) => {
                    if (item.propertyID === this.propertyIdList[0]) {
                        // 固定列 仅前面选中数据的后方按钮可操作
                        this.$set(this.propertyList[i], 'isFixDisOth', true);
                        this.$forceUpdate();

                        this.propertyDetail = item;
                        this.isSelected();
                    }
                });
            } else if (this.propertyIdList.length) {
                this.propertyList.forEach(item => {
                    this.propertyIdList.forEach(i => {
                        if (item.propertyID === i) {
                            this.recommendDetail.push(item);
                        }
                    });
                });
                // 页面选中多个楼盘时
                this.isShowEdit = true;
                // 多选隐藏显示按钮高亮
                this.isShow = true;
                // 多选删除楼盘按钮高亮
                this.isDel = true;
                // 多选重新置顶高亮
                this.isRecommend = true;
                // 多选续期按钮高亮  中原利嘉阁禁用
                if (this.companyCategory == 1 || this.companyCategory == 2) this.isRenew = false;
                else this.isRenew = true;
            }
        } /**删除楼盘 */,
        deleteRow(data) {
            if (!data) return;
            if (!this.propertyIdList.length) {
                this.$message({
                    showClose: true,
                    message: '請選擇要操作的樓盤',
                    type: 'warning'
                });
                return;
            } else {
                let dels = this.multipleChoiceDetails;
                this.delPropertyData.noPay = 0;
                this.delPropertyData.expired = 0;
                this.delPropertyData.post = 0;
                dels.forEach(item => {
                    if (item.paymentStatus == 0) this.delPropertyData.noPay++;
                    else if (this.nowDate >= item.expireTime) this.delPropertyData.expired++;
                    else if (item.paymentStatus == 1) this.delPropertyData.post++;
                });
                this.isShowdelPrompt = true;
            }
        },
        deleteProperty() {
            this.isShowdelPrompt = false;
            this.axios
                .post(this.pub.getApi().RemoveProperty, {
                    propertyID: this.propertyIdList
                })
                .then(res => {
                    /**删除调整和显示隐藏一致 */
                    if (res.data.code === 0 && res.data.result) {
                        this.loadPropertyList();
                        this.isShowdeledPrompt = true;
                        this.deledProperty = res.data.result;
                        // if (res.data.result.removeSuccess) {
                        //     this.$message({
                        //         showClose: true,
                        //         message: `已成功刪除${res.data.result.removeSuccess}個樓盤`,
                        //         type: 'success'
                        //     });
                        // } else {
                        //     this.$message({
                        //         showClose: true,
                        //         message: '暫無可刪除樓盤',
                        //         type: 'info'
                        //     });
                        // }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '刪除失敗，請重試',
                            type: 'error'
                        });
                    }
                });
        }
    }
};
</script>
<style lang="less">
/* 隐藏默认箭头 */
.grecol .el-input__inner{
    background-color: #E9FFF5 ;
}
.custom-select-icon .el-input__suffix {
  display: none;
}
.sort-btn{
    position: relative;
    .pos_shengxu{
        position: absolute;
        top: 1px;
        left: 207px;
        z-index: 1;
    }
}
// .custom-tooltip-box {
//   background-color: #000;
//   color: #fff;
//   border: 1px solid #e1f3d8;
//   border-radius: 10px;
//   padding: 8px 16px;
//   font-size: 14px;
//   white-space: nowrap;
//   animation: fadeInOut 10s forwards;
// }

// @keyframes fadeInOut {
//   0% {
//     opacity: 0;
//     transform: translateY(10px);
//   }
//   10% {
//     opacity: 1;
//     transform: translateY(0);
//   }
//   90% {
//     opacity: 1;
//     transform: translateY(0);
//   }
//   100% {
//     opacity: 0;
//     transform: translateY(-10px);
//   }
// }
.custom-tooltip {
  position: absolute;
  top: -45px; /* 显示在选择框上方 */
  left: 50%;
  transform: translateX(-50%);
  background-color: #000000;
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 10px;
  border: 1px solid #e1f3d8;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999;
  white-space: nowrap;
  font-size: 14px;
  animation: fadeInOut 10s forwards;
}
@keyframes fadeInOut {
  0% { opacity: 0; transform: translate(-50%, 10px); }
  10% { opacity: 1; transform: translate(-50%, 0); }
  90% { opacity: 1; transform: translate(-50%, 0); }
  100% { opacity: 0; transform: translate(-50%, -10px); }
}
.ti-shi{
    .el-input-number{
        border:none;
        width:150px
    }
    .el-input__inner{
        background-color: #F5F7FA;
        border:none;
        font-size: 24px;
    }
    .el-input-number__increase{
        border-left: 5px solid #fff;
        color:#1677FF;
    
    }
    .el-input-number__decrease{
        border-right: 5px solid #FFF;
        color:#1677FF;
    }
}
.btn-text {
    cursor: pointer;
    position: relative;
    top: 0px;
    font-size: 15px;
    padding-left: 5px;
    color: #0062ff;
}
.baseicon{
    vertical-align: baseline;
}
.imgTip {
    width: 20px;
    height: 20px;
    vertical-align: sub;
}
.ban {
    color: #666;
}
.fixColumm {
    border-left: 1px solid rgba(51, 51, 51, 0.1);
    box-shadow: -10px 0px rgba(234, 234, 234, 0.2) !important;
    // .cell {
    //     border-left: 1px solid rgba(51, 51, 51, 0.1) !important;
    // }
}
.disspan {
    pointer-events: none;
}
.disspancol {
    pointer-events: none;
    background-color: #e5e5e5;
    border-color: transparent;
}
.flexStar {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.starimg {
    img {
        width: 17px;
        height: 17px;
        margin-left: 3px;
    }
    vertical-align: middle;
}
.el-button--danger {
    background: #e50113;
}
.el-button--info {
    background: #bbbbbb;
    border: 1px solid #bbb;
}
/**标签级联选择器样式覆盖 */
.property-tags-cascader-panel.el-cascader-panel.is-bordered {
    border: none;
    .el-scrollbar__view.el-cascader-menu__list {
        padding: 0;
    }
    .el-scrollbar.el-cascader-menu:first-child {
        .el-cascader-node > .el-checkbox {
            display: none;
        }
    }
}
.property-tags-cascader-panelcheckbox.el-cascader-panel.is-bordered {
    border: none;
    .el-scrollbar__view.el-cascader-menu__list {
        padding: 0;
    }
    // .el-scrollbar.el-cascader-menu:first-child {
    //     .el-cascader-node > .el-checkbox {
    //         // display: none;
    //     }
    // }
}
.property-tags-cascader-none-li {
    display: none;
}
/**标签级联选择器样式覆盖 结束*/

/**更多标签展示弹出 下拉框样式修改 */
.properyty-tag-more-dropdown {
    color: #222;
    padding: 0 6px;
    font-size: 14px;
    max-width: 280px;
    word-break: break-all;
}

/**更多标签展示弹出 下拉框样式修改 结束*/
.property {
    /* 按钮样式 */
    .el-button {
        height: 38px;
        width: 95px;
    }

    .fl {
        float: left;
    }
    .w100 {
        width: 100px;
    }
    .post-enter {
        padding: 25px 30px 40px;
        text-align: center;
        button {
            padding: 16px 18px;
        }
        span {
            font-size: 30px;
        }
        .el-button {
            width: 85%;
            height: 100%;
        }
    }
    .wa-mark {
        .el-dialog__title {
            font-size: 16px;
            font-weight: 400;
            color: #acacb4;
        }
        .el-dialog__headerbtn .el-dialog__close {
            position: absolute;
            top: -7px;
            left: -25px;
        }
        .el-dialog__header {
            padding: 9px 32px;
            background: rgb(250 250 251);
            border-bottom: 1px solid rgb(226 226 234);
            border-radius: 8px 8px 0 0;
        }
        .wa-qiyong {
            height: 27px;
            .qiyong {
                position: absolute;
                top: 105px;
                left: 116px;
                color: #696974;
            }
        }
    }
    .ti-shi {
        .inormal{
            font-style:normal;
        }
        .el-dialog__body {
            padding: 20px 30px 25px;
        }
        .renew-onesel {
            margin-top: 25px;
            .goon-renew {
                margin-top: 25px;
                display: inline-block;
            }
        }
        .iconBox{
            .goon-renew {
                margin:0 0 10px 19px;
            }
            .renew_lu{
                font-size:18px;
                color:#0062ff;
                margin-left:20px;
            }
            margin-top:10px;
        }
        .icons {
                width: 180px;
                height: 56px;
                display: inline-block;
                line-height: 56px;
                position: relative;
                vertical-align:middle;
                margin-left:26px;
                margin-top:15px;
                cursor: pointer;
                .dis_txt{
                    cursor:not-allowed;
                }
                .icon_img {
                    width: 180px;
                    height: 56px;
                    background-size: 100%;
                }
                .dis_coin {
                    background: url('./../../assets/dis-coin.png') no-repeat;
                    background-size: cover;
                }
                .cli_coin {
                    background: url('./../../assets/icon.png') no-repeat;
                }
                .icon_diamond {
                    width: 180px;
                    height: 56px;
                    background-size: 100%;
                }
                .dis_diamond {
                    background: url('./../../assets/dis-star.png') no-repeat;
                }
                .cli_diamond {
                    background: url('./../../assets/star.png') no-repeat;
                }
                .dis_but{
                    background-color:#BBBBBB ;
                }
                .total {
                    color: #171725;
                    font-size: 22px;
                    position: absolute;
                    left: 65px;
                    top: 0px;
                    font-weight: 550;
                }
            }
        .left_coin{
                margin-left:80px;
        }
        .property-id {
            color: #0064ff;
            width: 300px;
            span {
                display: inline-block;
                padding-right: 12px;
            }
        }
        .sour_box{
            padding-left: 115px;
            .el-radio__label{
                font-size: 18px;
            }
        }
        .source-tishi{
            .greeicon{
                color:#07D379 ;
                font-size: 24px;
                vertical-align:top;
            }
            .id_box{
                padding-left: 50px;
                font-size: 16px;
                color: #444444;
                .property-id{
                    margin-top: 20px;
                }
            }
            .icon_box{
                padding-left: 135px;
                font-size: 16px;
                color :#444444;
            }
        }
        .renew-tishi {
            position: relative;
            padding-left: 20px;
            line-height: 24px;
            color: #44444f;
            font-size: 15px;
            .greeicon{
                color:#52c41a ;
                font-size: 24px;
                vertical-align: bottom;
            }
            // .property-id {
            //     color: #0064ff;
            //     width: 300px;
            //     span {
            //         display: inline-block;
            //         padding-right: 12px;
            //     }
            // }
            .property-idwid{
                width: auto;
            }
        }
        .del-tishi {
            div {
                color: #44444f;
                font-size: 15px;
                span.span {
                    display: inline-block;
                    padding-left: 12px;
                    margin-bottom: 8px;
                }
                .num {
                    padding-left: 30px;
                    line-height: 28px;
                }
            }
            p {
                margin-top: 8px;
                font-size: 14px;
                color: #f04134;
                padding-left: 30px;
            }
            .icon {
                color: #faad14;
                font-size: 18px;
            }
        }
        .tishi {
            position: relative;
            padding-left: 70px;
            line-height: 24px;
            color: #44444f;
            font-size: 14px;

            .icon {
                left: 32px;
                top: 6px;
                position: absolute;
                color: #0064ff;
                font-size: 18px;
            }
        }
        .dis_but{
            background-color:#BBBBBB ;
            pointer-events:none;
            border-color:#BBBBBB;
        }

        .upgrade_box{
            display: inline-block;
            width: 80px;
            height: 36px;
            background-color: #e9e9eb;
            color:#848485 ;
            border-radius: 10px;
            line-height: 36px;
            text-align: center;
            margin-right: 10px;
            cursor: pointer;
        }
        .highlight_box{
            background-color: #e1c999;
            color: #040303;
        } 
        .footerdiv{
            text-align: right;
            display: inline-block;
            margin-right: 10px;
            font-size: 14px;
            color: #444444;
            vertical-align: bottom;
        }
        .rec_jieyu{
            margin-top:20px;
            font-size:18px;
            color:#444444;
            .redStar{
                color:#f04134;
            }
        }
        .mrl130{
            margin-left:130px;
            margin-top:10px;
        }
        .mrl153{
            margin-left:153px;
            margin-top:10px;
        }
        .iconbox{
            margin-top:53px;
            .mrauto{
                color:#000000;
                font-size:14px;
                margin-left:12px;
            }
        }
        .mrtxt{
            color:#E50113;
            margin-top:20px;
        }
        .redTxt{
            color:#E50113;
            margin-left:90px;
        }
    }
    .disti-shi{
        .distishi{
            text-align:left;
            padding-left:31px;
            font-size:18px;
            .icon{
                left:5px;
                color:#44444f;
            }
        }
    }

    .more {
        background-color: #e1c999;
        border-color: #e1c999;
        color: #fff;
    }
    .more:active {
        background-color: #e6a23c;
        border-color: #e6a23c;
        color: #fff;
    }
    button {
        border-radius: 10px;
    }
    .el-dialog {
        border-radius: 10px;
        /deep/ .el-dialog__header {
            padding: 0;
            padding-left: 20px;
            height: 42px;
            line-height: 42px;
            box-sizing: border-box;
            border-radius: 10px 10px 0 0;
            background: #fafafb;
            border-bottom: 1px solid #eee;
            .el-dialog__title {
                font-size: 16px;
                color: #92929d;
            }
            .el-dialog__headerbtn {
                top: 12px;
            }
        }
    }

    background-color: #f3f3f5;
    padding: 0;
    margin: 0;
    text-align: left;
    .title {
        padding: 0 0 20px 0;
        font-size: 24px;
        color: #171725;

        .span {
            padding-right: 16px;
            font-size: 14px;
            color: #0062ff;
        }
    }
    .filter {
        padding-bottom: 16px;
        .btn-filter {
            padding-left: 10px;
            display: inline-block;
            padding-bottom: 16px;
            .el-button {
            &.seabtn {
                background-color: #E50113 ;
            }
        }
        }

        input {
            color: #000;
            font-size: 14px;
            border: none;
            border-radius: 10px;
            height: 38px;
        }
        button {
            border-radius: 10px;
            width: 88px;
            height: 38px;
        }
        .w90,
        .w135,
        .w150,
        .w160,
        .w280,
        .w120,
        .w100,
        .w180,
        .w195,
        .w245,
        .w315 {
            margin-right: 15px;
            margin-bottom: 10px;
        }
        .mr4 {
            margin-right: 5px;
        }
        .w90 {
            width: 90px;
        }
        .w100 {
            width: 100px;
        }
        .w135 {
            width: 135px;
        }
        .w150 {
            width: 150px;
        }
        .w160 {
            width: 160px;
        }
        .w120 {
            width: 120px;
        }
        .w180 {
            width: 180px;
        }
        .w195 {
            width: 195px;
        }
        .w280 {
            width: 280px;
        }
        .w315 {
            width: 315px;
        }
        .w245 {
            width: 245px;
        }
        span.time {
            font-size: 14px;
            color: #666;
        }
        .self {
            background-color: #fff;
            border-radius: 10px;
            margin-bottom: 12px;
        }
        /**覆蓋樣式 */
        .more {
            width: 105px;
            padding: 12px 10px;
        }
        .input-model {
            box-sizing: border-box;
            display: inline-block;
            height: 38px;
            line-height: 38px;
            border-radius: 10px;
            padding: 0 8px;
            font-size: 14px;
            color: #333;
            .w90 {
                margin: 0;
            }
            .pm {
                margin: 0 6px;
            }
            /deep/ .el-input__inner {
                padding: 0 8px;
                line-height: 38px;
                height: 36px;
            }
        }
        .area-span {
            font-size: 14px;
            color: #666;
        }
        /**楼盘标签相关 */
        .property-tags-cascader {
            position: relative;
            display: inline-block;
        }
    }
    .line {
        width: 100%;
        height: 1px;
        background-color: #e2e2ea;
    }
    .shangye {
        width: 86px;
        margin-right: 10px;
        margin-top: 4px;
        .el-input__inner {
            height: 35px;
        }
        /* 下面设置右侧按钮居中 */
        .el-input__suffix {
            top: 8px;
        }
        .el-input__icon {
            line-height: inherit;
        }
        .el-input__suffix-inner {
            display: inline-block;
        }
    }
    .w_110{
        width:116px;
    }
    .w_230{
        width:230px;
    }
    .button2 {
        height: 74px;
        overflow: hidden;
    }
    .overBut{
        overflow: hidden;
    }
    .button {
        top: 50px;
        z-index: 999;
        padding: 10px 0px 12px 0px;
        box-sizing: border-box;
        background-color: #f3f3f5;
        // overflow: hidden;
        margin-bottom: 6px;
        .span {
            margin-top: 14px;
            position: relative;
            top: -2px;
            cursor: pointer;
            display: inline-block;
            padding: 0 14px 0 0;
            .icon {
                font-size: 20px;
            }
            .btn-text {
                position: relative;
                top: 0px;
                font-size: 15px;
                padding-left: 5px;
                color: #0062ff;
            }
            .ban {
                color: #666;
            }
        }
        .btn-span-r {
            float: right;
            display: inline-block;
            // margin-top:10px;
        }
        .sort {
            // float: right;
            margin-right: 10px;
            span {
                cursor: pointer;
                display: inline-block;
                position: relative;
                // top: 12px;
                top: 2px;
                padding: 0 10px 0 0px;
                font-size: 14px;
                .el-icon-sort {
                    font-size: 12px;
                }
            }
            .blue {
                color: #0062ff;
            }
        }

        .w110 {
            width: 110px;
        }

        button {
            border: 1px solid #92929d;
            width: 100px;
            border-radius: 10px;
            color: #bbb;
        }
        button:active {
            color: #fff;
            background-color: #0062ff;
        }
        .w40 {
            width: 40px;
            text-align: center;
        }
        .r-btn {
            display: inline-block;
            float: right;
            margin-top: 4px;
            .icon {
                font-size: 16px;
            }
            div {
                line-height: 34px;
                text-align: center;
                width: 34px;
                height: 34px;
                float: left;
                color: #92929d;
                background-color: #fff;
            }
            .r-btn1 {
                border-radius: 10px;
                margin-right: 12px;
            }
            .r-btn2 {
                border-radius: 10px 0 0 10px;
            }
            .r-btn3 {
                border-radius: 0 10px 10px 0px;
            }
            .r-btn1:active,
            .r-btn2:active,
            .r-btn3:active {
                color: #fff;
                background-color: #b5b5be;
            }
            .active {
                color: #fff;
                background-color: #b5b5be;
            }
        }
    }
    /**固定操作栏 */
    /**固定 */
    .fixed-1 {
        padding: 12px 24px 12px 30px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
        position: fixed;
        left: 140px;
        width: calc(100% - 140px);
        transform: translateX();
        transition-duration: 1s;
    }
    /**宽度改变 */
    .fixed-2 {
        width: calc(100% - 60px);
        left: 60px;
    }
    /**解决 */
    .fixed {
        width: 100%;
    }
    .table {
        .red {
            color: #ed1d25;
        }
        .el-button {
            text-align: left;
            width: 100%;
        }
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding: 20px;
        box-sizing: border-box;

        /**勾选框颜色覆盖 */
        .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #0062ff;
            border-color: #0062ff;
        }
        .el-table__header tr,
        .el-table__header th {
            padding: 0 !important;
            height: 38px;
        }
        /**文字列表 */
        .text-list {
            line-height: 24px;
            .btn-text {
                cursor: pointer;
                position: relative;
                top: 0px;
                font-size: 15px;
                padding-left: 5px;
                color: #0062ff;
            }
            .ban {
                color: #666;
            }
            .editBut {
                width: 52px;
                height: 24px;
                padding: 0;
                text-align: center;
                border-radius: 6px;
            }
            .marBut {
                margin-left: 10px;
            }
            .expandBut {
                margin-left: 0;
                width: 24px;
                height: 24px;
                display: inline-block;
                padding: 0;
                text-align: center;
                border-radius: 6px;
            }
            .blue-vr {
                color: #0062ff;
                cursor: pointer;
            }

            .btn-a {
                color: #0062ff;
            }
            .btn-cursor {
                cursor: pointer;
            }
            .account {
                white-space: pre-wrap;
                display: block;
                line-height: 24px;
            }

            .img-cover {
                background-image: url('../../assets/none_img.png');
                width: auto;
                height: auto;
                max-width: 80px;
                max-height: 60px;
            }
            .img-number {
                display: inline-block;
                background-color: #0054a6;
                width: 80px;
                height: 14px;
                font-size: 10px;
                color: #fff;
                line-height: 14px;
                text-align: center;
                position: absolute;
                bottom: 14px;
                left: 10px;
            }
            /**标签sapn */
            .property-tags-main {
                .property-tags {
                    display: inline-block;
                    color: #222;
                    span {
                        padding: 0 4px;
                        display: inline-block;
                    }
                }
                .property-tags-more {
                    cursor: pointer;
                    display: inline-block;
                    padding: 0 4px;
                    color: #0062ff;
                }
            }
        }
        /**修改表格背景 */
        .el-table tbody tr:hover > td {
            background-color: rgba(80, 181, 255, 0.1) !important;
        }
        /** */
        /deep/ .el-table thead tr {
            th:first-child {
                border-radius: 10px 0 0 10px;
            }
            th:nth-last-child(2) {
                border-radius: 0 10px 10px 0;
            }
        }
        .el-table th {
            border: none;
        }
        /**分割线 */
        .el-table td {
            border-bottom: 1px solid #e2e2ea;
        }
        table {
            .btn-table {
                color: #222;
            }
            .btndisable {
                pointer-events: none;
            }
            color: #222;
            font-size: 14px;
            tr th .cell {
                line-height: 38px;
                font-weight: normal;
                font-size: 13px;
                color: #444444;
            }
        }

        .img-list {
            .h_230 {
                height: 230px;
            }
            .h_120 {
                height: 120px;
            }
            .sale-color {
                color: #ed1c24;
            }
            .rent-color {
                color: #30b631;
            }
            .btn-a {
                color: #0062ff;
            }
            .r-btn {
                padding-right: 12px;
                margin-top: 16px;
                width: 100%;
                border-top: 1px solid #eee;
                padding-top: 6px;
                box-sizing: border-box;
                .el-button {
                    padding-left: 12px;
                    float: right;
                }
            }
            td {
                position: relative;
            }

            .title {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                // justify-content: space-between;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 18px;
                line-height: 24px;
                color: #333333;
                padding: 0;
                padding-bottom: 10px;
                // width :908px;
                .left-titbox-one {
                    width: 588px;
                    margin-right:14px;
                }
                .left-titbox {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    // flex-direction: row;
                    // justify-content: space-between;
                    .full-adre {
                        color: #3b589d;
                        font-size: 16px;
                        white-space: normal;
                    }
                    .stitle {
                        // padding-left: 24px;
                        color: #999;
                        font-size: 14px;
                        color: #333;
                        .click-span {
                            cursor: pointer;
                        }
                        span {
                            .btn-a {
                                width: 50px;
                            }
                        }
                        .stitile-no {
                            width: 90px;
                        }
                    }
                }
                .title-text {
                    font-weight: bold;
                }
            }
            .content-1 {
                overflow: hidden;
                border-bottom: 1px solid #e2e2ea;
                padding-bottom: 16px;
            }
            .content-2 {
                overflow: hidden;
                padding: 16px 0 10px 0;
                .imgTip {
                    width: 20px;
                    height: 20px;
                    vertical-align: sub;
                }
                .property-tags-main {
                    .property-tags {
                        display: inline-block;
                        color: #222;
                        span {
                            padding: 0 4px;
                            display: inline-block;
                        }
                    }
                    .property-tags-more {
                        cursor: pointer;
                        display: inline-block;
                        padding: 0 4px;
                        color: #0062ff;
                    }
                }
            }
            .detaildown {
                float: left;
                width: 100%;
                font-size: 14px;
                color: #444;
                line-height: 26px;
                margin-right: 38px;
                .left {
                    color: #666;
                    // width: 115px;
                    width: 91px;
                    margin-right: 10px;
                    float: left;
                }
                .right {
                    color: #222;
                    display: inline-block;
                    padding-right: 20px;
                    font-size: 15px;
                }
                .property-tags-more {
                    cursor: pointer;
                    display: inline-block;
                    padding: 0 4px;
                    color: #0062ff;
                }
            }
            .detail {
                float: left;
                // width: 280px;
                width: 286px;
                font-size: 14px;
                color: #444;
                line-height: 26px;
                margin-right: 38px;
                p {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .left {
                    color: #666;
                    // width: 115px;
                    width: 84px;
                    margin-right: 10px;
                    float: left;
                }
                .right {
                    color: #222;
                    float: right;
                    width: 192px;
                    // padding-right: 20px;
                    .pl16 {
                        padding-left: 16px;
                    }
                    .btn-a {
                        cursor: pointer;
                        font-size: 12px;
                        color: #0062ff;
                    }
                }
            }
           
            .detail-2 {
                // width: 280px;
                width: 255px;
                .left {
                    // width: 115px;
                    width: 80px;
                }
                .right {
                    // width: 155px;
                    width: 165px;
                    .imgTip {
                        width: 20px;
                        height: 20px;
                        vertical-align: sub;
                    }
                }
            }
            .detail-21{
                width: 294px;
                .left {
                    width: 119px;
                }
            }
            .detail-3 {
                margin-right: 0px;
                // width: 320px;
                width: 332px;
                .left {
                    // width: 112px;
                    width: 126px;
                }
                .right {
                    padding-right: 12px;
                    width: 195px;
                    position: relative;
                    .tags-more {
                        padding: 6px;
                        border-radius: 4px;
                        border: 1px solid #efefef;
                        background-color: #fff;
                        position: absolute;
                        bottom: -10px;
                        right: 0px;
                        width: 340px;
                        height: 120px;
                        span {
                            display: inline-block;
                            padding: 2px 4px;
                        }
                    }
                }
                .property-tags-p {
                    .tags-show {
                        display: flex;
                        .tags-list {
                            display: inline-block;
                            max-width: 148px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            color: #222;
                        }
                        .tag-more {
                            display: inline-block;
                            color: #0062ff;
                            cursor: pointer;
                        }
                    }
                }
            }

            .img {
                width: 120px;
                position: relative;
                .top {
                    background: linear-gradient(244deg, rgba(233, 183, 8, 1) 0%, rgba(242, 160, 24, 1) 100%);
                    border-radius: 1px;
                    position: absolute;
                    top: 4px;
                    left: 4px;
                    height: 16px;
                    padding: 0 6px;
                    line-height: 16px;
                    color: #fff;
                    font-size: 12px;
                    text-align: center;
                }
                .star {
                    background-image: url('//static.house730.com/m/images/star-pg.png');
                    background-size: 100% 100%;
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    width: 32px;
                    height: 24px;
                    line-height: 19px;
                    color: #fff;
                    font-size: 12px;
                    text-align: center;
                }
                .vr {
                    position: absolute;
                    bottom: 6px;
                    left: 6px;
                    .vr-gif,
                    .vr-ai {
                        cursor: pointer;
                        display: inline-block;
                        border-radius: 11px;
                        width: 22px;
                        height: 22px;
                        background-size: 100% 100%;
                        margin-right: 6px;
                    }
                    .vr-gif {
                        background-color: rgba(0, 0, 0, 0.3);
                        background-image: url('//static.house730.com/m/images/vr.gif');
                    }
                    .vr-ai {
                        background-color: rgba(255, 255, 255, 0.7);
                        background-image: url('//static.house730.com/m/images/ai-loading.gif');
                    }
                }
                .number {
                    width: 25px;
                    background-color: #0062ff;
                    color: #fff;
                    border-radius: 1px;
                    position: absolute;
                    bottom: 9px;
                    right: 6px;
                    height: 16px;
                    line-height: 16px;
                    font-size: 12px;
                    text-align: center;
                }
                .vidM {
                    color: gray;
                    border-radius: 50%;
                    position: absolute;
                    bottom: 33px;
                    right: 48px;
                    width: 30px;
                    height: 30px;
                }
            }
            .img img {
                background-image: url('../../assets/none_img.png');
                border-radius: 4px;
                width: 120px;
                height: 90px;
                // width: auto;
                // height: auto;
                max-width: 120px;
                max-height: 90px;
            }
            .disspancol {
                pointer-events: none;
                background-color: #e5e5e5;
                border-color: transparent;
            }
            .editBut {
                width: 52px;
                height: 24px;
                padding: 0;
                text-align: center;
                border-radius: 6px;
            }
            .btn-text {
                cursor: pointer;
                position: relative;
                top: 0px;
                font-size: 15px;
                padding-left: 5px;
                color: #0062ff;
            }
            .marBut {
                margin-left: 10px;
            }
            .expandBut {
                margin-left: 0;
                width: 24px;
                height: 24px;
                display: inline-block;
                padding: 0;
                text-align: center;
                border-radius: 6px;
            }
            .popdiv {
                position: absolute;
                top: 202px !important;
                left: -32px;
                background-color: #fff;
                top: 0;
                width: 150px;
            }
        }
        .footer {
            overflow: hidden;
            input {
                border-radius: 4px;
            }
            span {
                font-size: 14px;
                color: #44444f;
                margin-left: 16px;
            }
            margin-top: 16px;
            padding-top: 20px;
            box-sizing: border-box;
            height: 72px;
            .page {
                float: right;
            }
            .input-number {
                input {
                    border-radius: 0px;
                }
                text-align: left;
                float: right;
                width: 70px;
            }
            /**覆盖计数器样式 */
            .el-input-number.is-controls-right .el-input__inner {
                padding-left: 8px;
                padding-right: 42px;
                overflow: hidden;
            }
        }
    }
    .left-right-scorll {
        width: 100%;
        width: calc(100% - 160px);
        margin-top: 12px;
        height: 24px;
        text-align: center;
        position: fixed;
        bottom: 48px;
        span {
            margin: 0 48px;
            display: inline-block;
            position: relative;
            height: 30px;
            height: 30px;
            width: 52px;
            cursor: pointer;
            overflow: hidden;
            border-radius: 4px;
            &:hover {
                background-color: #ccc;
            }
        }
        .icon {
            font-size: 68px;
            position: absolute;
            left: -6px;
            top: -20px;
            z-index: 99;
        }
    }
    .edit-text-show {
        .el-dialog {
            height: 550px;
            .el-dialog__header {
                font-weight: 600;
            }
            .el-dialog__body {
                height: 380px;
                overflow: auto;
                .el-checkbox__input.is-checked .el-checkbox__inner {
                    background-color: #0064ff;
                    border-color: #0064ff;
                }
                .el-row-dialog.el-row {
                    background: rgba(80, 181, 255, 0.15);
                }
                .el-col {
                    // padding-left: 5px;
                }
            }
        }
    }
    .edit-text {
        line-height: 40px;
        font-size: 14px;
        color: #44444f;
    }
    .edit-content {
        line-height: 40px;
        font-size: 14px;
        color: #44444f;
    }
    input {
        border-radius: 10px;
    }
    .p-dialog {
        margin: 0 0 24px 0;
        font-size: 14px;
        color: #44444f;
    }
    .el-row-dialog {
        font-size: 12px;
        color: #44444f;
        height: 38px;
        line-height: 38px;
        background: #fafafb;
        border-radius: 10px;
        padding: 0 16px;
    }
    .el-list {
        border-bottom: 1px solid #e2e2ea;
        .icon {
            position: relative;
            top: 4px;
            font-size: 24px;
        }
        padding: 0 12px;
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        color: #171725;
        width: 100%;
    }
}
</style>
